// Generated by ts-to-zod
import { z } from 'zod';
import {
  AccountOwnerType,
  TransactionFlow,
  TransactionCategory,
  PaymentMethodType,
  TransferStatus,
  CustomerAgreementStatus,
  AnnouncementColor,
  AnnouncementScope,
  AttachmentKind,
  AttachmentStatus,
  AttachmentEntityType,
  AttachmentContentType,
  AuditTrailAction,
  AuthType,
  CognitoAttributeDataType,
  Language,
  ResourceTypeV2,
  ActionV2,
  SoftDeleteFlag,
  UpdatePermissionCommandV2,
  UpdateRoleCommandV2,
  UpdatePrincipalCommandV2,
  PolicyDecision,
  TransactionType,
  LoyaltyType,
  DailyCountItemStatus,
  DebtOriginType,
  EntityTypes,
  DebtStatus,
  DebtEvent,
  DebtCommandType,
  DiscountType,
  DiscountApplication,
  ProductDiscountChangeAction,
  CalculateDiscountCommands,
  ShopAndSmileEventSource,
  QueueWarning,
  ApprovalStatus,
  ProductIssueType,
  ActivityAction,
  ActivityOrigin,
  ImageFileTypes,
  StringBoolean,
  InventoryTemplateStatus,
  InventoryChangeReason,
  StockBucket,
  StockOperationType,
  CountBasis,
  ReasonCounted,
  InventoryChangeEvent,
  SortOrder,
  InvoiceStatus,
  PaymentAttemptStatus,
  BillingRunStatus,
  BillingTriggerType,
  InvoiceCollectionMethod,
  PricingType,
  BillingPeriod,
  InvoiceType,
  LoanStatus,
  LoanHistoryEvent,
  UiLanguage,
  ModuleStatus,
  MerchantPaymentStatus,
  NotificationEvents,
  EmailCharset,
  NotificationRequestType,
  NotificationTrigger,
  NotificationKind,
  NotificationStatus,
  NotificationScheduleFrequency,
  PurchaseOrderNotificationEvent,
  DebtNotificationEvent,
  DebtReminderTier,
  PaymentReason,
  PlatformFinanceCategory,
  PlatformFinanceAssignmentStatus,
  PlatformFinanceAllocationStatus,
  PlatformFinancePhoneEntity,
  PlatformFinancePhoneStatus,
  PlatformFinanceWaiverReason,
  PlatformFinanceWaiverStatus,
  PlatformFinanceAuditAction,
  PlatformFinanceReconciliationStatus,
  MessageOperator,
  TxSubtype,
  ClaimStatus,
  TopupNumberStatus,
  PlatformFinanceBillingStatus,
  PlatformExpenseStatus,
  PlatformExpenseSource,
  PricingPlanStatus,
  PricingDiscountType,
  ProductExpiryDismissReason,
  CostUpdateOrigin,
  StoreProductChangeEvents,
  ProductChangeEvents,
  PromotionTypes,
  PromotionStatus,
  PurchaseStatus,
  PurchaseOrderPaymentStatus,
  PurchaseOrderEstimateStatus,
  UpdatePurchaseOrderCommand,
  ReasonMissing,
  ReceiptStatus,
  ReceiptHistoryItemType,
  ReceiptType,
  ConfirmationType,
  UpdateReceiptCommand,
  ReceiptEvents,
  SalesReportInterval,
  WebWorkerActions,
  GSI_DESCRIPTORS,
  RelationshipTypes,
  DefaultPricingType,
  Form,
  Color,
  ErrorCodes,
  UserRole,
  PaymentName,
  ShiftCommandType,
  CloseShiftStepEvent,
  ShiftStatus,
  ReconciliationStatus,
  ShiftEvents,
  StockOrderStatus,
  TransferLogisticsStatus,
  TransferReconciliationStatus,
  TransferValuationStatus,
  TransferOverallStatus,
  TransferCustody,
  TransferExtraResolution,
  StockOperationIntentStep,
  StockOperationIntentStatus,
  SettleExtraDecision,
  FlowType,
  StoreEvents,
  LocationType,
  TaskType,
  TaskEventOp,
  TaskStatus,
  TaskOrigin,
  TaskPriority,
  TaskScope,
  TaxType,
  CalculateTaxCommands,
  EmolaPrefix,
  CounterpartyType,
  TopupTransactionType,
  AssignmentSource,
  ClaimHistoryTypes,
  TopupClaimMatchMethod,
  TopupSource,
  WalletTransferDirection,
  UpdateTopupNumberCommand,
  TopupDeviceStatus,
  UserEvents,
  WalletTransactionType,
  WeightedSaleStatus,
  WeightedSaleSource,
  WeightedSaleScaleType,
  StoreProductFraction,
  StoreProductAttributes,
  StoreProduct,
  RealTimeProductEventMessage,
  StoreProductPage,
  DeletedProductsPage,
  StoreProductDBItem,
  StoreProductWebSocketMessage,
} from './../to-generate/to-generate';

export const accountOwnerTypeSchema = z.nativeEnum(AccountOwnerType);

export const transactionFlowSchema = z.nativeEnum(TransactionFlow);

export const transactionCategorySchema = z.nativeEnum(TransactionCategory);

export const personRefSchema = z.object({
  id: z.string(),
  type: accountOwnerTypeSchema,
  name: z.string().nullish(),
  note: z.string().nullish(),
});

export const originEntityRefSchema = z.object({
  entity_type: z.string(),
  entity_id: z.string(),
  description: z.string().nullish(),
  metadata: z.record(z.string()).nullish(),
});

export const timestampsSchema = z.object({
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string().nullish(),
  deleted_by_id: z.string().nullish(),
  deleted_by_name: z.string().nullish(),
  restored_at: z.string().nullish(),
  restored_by_id: z.string().nullish(),
  restored_by_name: z.string().nullish(),
});

export const paymentMethodTypeSchema = z.nativeEnum(PaymentMethodType);

export const currencySchema = z.object({
  code: z.string(),
  decimal_places: z.number(),
  symbol: z.union([z.string(), z.undefined()]).nullish(),
});

export const accountSnapshotSchema = timestampsSchema.extend({
  account_id: z.string(),
  amount: z.number(),
  created_by: z.union([z.literal('SYSTEM'), z.string()]),
  version: z.number(),
  store_id: z.string(),
  merchant_id: z.string(),
  payment_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
});

export const summaryByPaymentMethodSchema = z.object({
  payment_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  total_inflow: z.number(),
  total_outflow: z.number(),
  net_amount: z.number(),
});

export const accountSnapshotBalancesSchema = z.record(z.record(z.number()));

export const balancesByPaymentMethodSchema = z.record(z.number());

export const transferApprovalSchema = z.object({
  transfer_id: z.string(),
  approver: personRefSchema,
  approved_at: z.string(),
  notes: z.string().nullish(),
  transferer_owner: personRefSchema.nullish(),
  transferee_owner: personRefSchema.nullish(),
  currency: currencySchema.nullish(),
  shift_id: z.string().nullish(),
});

export const transferStatusSchema = z.nativeEnum(TransferStatus);

export const versionedSchema = z.object({
  version: z.number().nullish(),
  updated_by_id: z.string().nullish(),
  updated_by_name: z.string().nullish(),
});

export const createTransferRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  transferer_account_id: z.string(),
  transferee_account_id: z.string(),
  amount: z.number(),
  payment_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  forced: z.boolean().nullish(),
  without_consent: z.boolean().nullish(),
  shift_id: z.string().nullish(),
  currency: currencySchema,
  transferer_owner: personRefSchema,
  transferee_owner: personRefSchema,
  creator: personRefSchema,
  approver: personRefSchema.nullish(),
});

export const snapshotRequestEventSchema = z.object({
  account_id: z.string(),
  trigger: z.union([z.literal('AUTO'), z.literal('MANUAL')]),
});

export const listAccountTransactionsBaseSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export const listAccountTransactionsByStoreSchema =
  listAccountTransactionsBaseSchema.extend({
    merchant_id: z.string(),
    store_id: z.string(),
  });

export const listAccountTransactionsByOwnerSchema =
  listAccountTransactionsBaseSchema.extend({
    owner_id: z.string(),
    owner_type: accountOwnerTypeSchema,
  });

export const listAccountTransactionsByShiftSchema =
  listAccountTransactionsBaseSchema.extend({
    shift_id: z.string(),
  });

export const getAccountsByStoreSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getAccountsByOwnerSchema = z.object({
  owner_id: z.string(),
  owner_type: accountOwnerTypeSchema,
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getAccountsByShiftSchema = z.object({
  shift_id: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getAccountsByAccountSchema = z.object({
  account_id: z.string(),
  store_id: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getTransfersSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  transferer_id: z.string().nullish(),
  transferee_id: z.string().nullish(),
  status: transferStatusSchema.nullish(),
  date_from: z.string().nullish(),
  date_to: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const rejectTransferRequestSchema = z.object({
  transfer_id: z.string(),
  reason: z.string(),
  actor: personRefSchema,
  shift_id: z.string().nullish(),
});

export const cancelTransferRequestSchema = z.object({
  transfer_id: z.string(),
  reason: z.string(),
  actor: personRefSchema,
  shift_id: z.string().nullish(),
});

export const reverseLoanGivenRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  debt_id: z.string(),
  creator: personRefSchema,
  owner: personRefSchema.nullish(),
  shift_id: z.string().nullish(),
  reason: z.string(),
  currency: currencySchema.nullish(),
});

export const reverseAccountTransactionRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  account_id: z.string(),
  payment_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  version: z.number(),
  creator: personRefSchema,
  shift_id: z.string().nullish(),
  reason: z.string(),
});

export const reverseDebtPaymentTransactionRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  payment_id: z.string(),
  debt_id: z.string(),
  creator: personRefSchema,
  shift_id: z.string().nullish(),
  reason: z.string(),
});

export const timeSeriesIntervalSchema = z.union([
  z.literal('hourly'),
  z.literal('daily'),
  z.literal('weekly'),
  z.literal('monthly'),
  z.literal('yearly'),
]);

export const getStoreTimeSeriesRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  from: z.string(),
  to: z.string(),
  interval: timeSeriesIntervalSchema,
});

export const timeSeriesPointSchema = z.object({
  label: z.string(),
  start: z.string(),
  end: z.string(),
  receiptCount: z.number(),
  transactionCount: z.number(),
  inventoryCount: z.number(),
  inventoryCountCorrections: z.number(),
  inventoryValueEnd: z.number(),
  purchaseOrderCount: z.number(),
  debtCount: z.number(),
  totalDebtsOutstanding: z.number(),
  grossSales: z.number(),
  netSales: z.number(),
  expenses: z.number(),
  moneyEnd: z.number(),
});

export const agreementFilterSchema = z.union([
  z.literal('all'),
  z.literal('has_agreement'),
  z.literal('no_agreement'),
]);

export const getStorePaymentsRequestSchema = z.object({
  agreement_filter: agreementFilterSchema.nullish(),
  sort_field: z.string().nullish(),
  sort_direction: z.union([z.literal('asc'), z.literal('desc')]).nullish(),
  merchant_ids: z.string().nullish(),
});

export const customerAgreementStatusSchema = z.nativeEnum(
  CustomerAgreementStatus,
);

export const activityFilterSchema = z.union([
  z.literal('no_sales'),
  z.literal('sales'),
  z.literal('all_sales'),
  z.literal('no_transactions'),
  z.literal('transactions'),
  z.literal('all_transactions'),
]);

export const getStoreActivityRequestSchema = z.object({
  from: z.string(),
  to: z.string(),
  filter: activityFilterSchema.nullish(),
  relative_from: z.string().nullish(),
  relative_to: z.string().nullish(),
  merchant_ids: z.string().nullish(),
});

export const storeActivityRowSchema = z.object({
  storeId: z.string(),
  storeName: z.string(),
  merchantId: z.string(),
  merchantName: z.string(),
  merchantPhone: z.string().nullable(),
  storeCreatedAt: z.string(),
  receiptCount: z.number(),
  transactionCount: z.number(),
  inventoryCount: z.number(),
  inventoryCountCorrections: z.number(),
  inventoryValueEnd: z.number(),
  purchaseOrderCount: z.number(),
  debtCount: z.number(),
  totalDebtsOutstanding: z.number(),
  grossSales: z.number(),
  netSales: z.number(),
  expenses: z.number(),
  moneyEnd: z.number(),
  currency: z.string(),
});

export const storeActivityResponseSchema = z.object({
  rows: z.array(storeActivityRowSchema.nullable()),
  total: z.number(),
  filtered: z.number(),
  currency: z.string(),
});

export const getPlatformMetricsRequestSchema = z.object({
  from: z.string().nullish(),
  to: z.string().nullish(),
});

export const platformStoreArRowSchema = z.object({
  storeId: z.string(),
  storeName: z.string(),
  merchantId: z.string(),
  totalBilled: z.number(),
  totalPaid: z.number(),
  outstanding: z.number(),
  overdue: z.number(),
  pendingCount: z.number(),
  failedCount: z.number(),
  maxDaysOverdue: z.number().nullable(),
  earliestDueDate: z.string().nullable(),
  collectionRatePct: z.number().nullable(),
});

export const platformBillingRunInfoSchema = z.object({
  status: z.string(),
  startedAt: z.string().nullable(),
  invoicesCreated: z.number(),
  invoicesPaid: z.number(),
  invoicesUnpaid: z.number(),
});

export const getPlatformMetricsRangeRequestSchema = z.object({
  from: z.string().datetime({ offset: true }),
  to: z.string().datetime({ offset: true }),
}).refine(
  (range) =>
    !range.from ||
    !range.to ||
    new Date(range.from).getTime() <= new Date(range.to).getTime(),
  { message: 'from must not be after to', path: ['from'] },
);

export const platformMonthlyBillingSchema = z.object({
  month: z.string(),
  billed: z.number(),
  collected: z.number(),
  outstanding: z.number(),
  invoiceCount: z.number(),
});

export const platformBillingMetricsSchema = z.object({
  currency: z.string(),
  excludedBilledByCurrency: z.record(z.number()),
  from: z.string(),
  to: z.string(),
  billedInRange: z.number(),
  invoicesInRange: z.number(),
  collectedOnRangeInvoices: z.number(),
  collectedInRange: z.number(),
  collectionRatePct: z.number().nullable(),
  momGrowthPct: z.number().nullable(),
  dso: z.number().nullable(),
  avgDaysToPay: z.number().nullable(),
  arOutstanding: z.number(),
  arOverdue: z.number(),
  pendingInvoiceCount: z.number(),
  overdueInvoiceCount: z.number(),
  failedInvoiceCount: z.number(),
  failedInvoiceAmount: z.number(),
  arAging: z.array(
    z.object({
      bucket: z.string(),
      amount: z.number(),
      invoiceCount: z.number(),
    }),
  ),
  expectedByMonth: z.array(
    z.object({
      month: z.string(),
      amount: z.number(),
      overdueAmount: z.number(),
      invoiceCount: z.number(),
    }),
  ),
  monthly: z.array(platformMonthlyBillingSchema),
  storeRows: z.array(platformStoreArRowSchema),
  lastBillingRun: platformBillingRunInfoSchema.nullable(),
});

export const platformMonthlySalesSchema = z.object({
  month: z.string(),
  gmv: z.number(),
  netSales: z.number(),
  refunds: z.number(),
  receipts: z.number(),
  refundReceipts: z.number(),
  activeStores: z.number(),
  newStores: z.number(),
  activatedStores: z.number(),
});

export const platformSalesMetricsSchema = z.object({
  currency: z.string(),
  excludedGmvByCurrency: z.record(z.number()),
  from: z.string(),
  to: z.string(),
  gmv: z.number(),
  netSales: z.number(),
  refunds: z.number(),
  receipts: z.number(),
  refundReceipts: z.number(),
  activeStores: z.number(),
  totalStores: z.number(),
  failedStores: z.number(),
  monthly: z.array(platformMonthlySalesSchema),
});

export const platformRegistryMetricsSchema = z.object({
  from: z.string(),
  to: z.string(),
  totalMerchants: z.number(),
  merchantsWithoutStores: z.number(),
  totalStores: z.number(),
  totalUsers: z.number(),
  failedUserMerchants: z.number(),
  totalCustomers: z.number().nullish(),
  failedCustomerMerchants: z.number().nullish(),
  monthly: z.array(
    z.object({
      month: z.string(),
      merchants: z.number(),
      stores: z.number(),
      users: z.number(),
      customers: z.number().nullish(),
    }),
  ),
});

export const platformOperationsMetricsSchema = z.object({
  currency: z.string(),
  platformWalletByCurrency: z.record(z.number()),
  platformWalletMethodCount: z.number(),
  failedWalletMethods: z.number(),
  topupsProcessed: z.number(),
  topupsUnprocessed: z.number(),
});

export const requestAdminLoginCodeSchema = z.object({
  phone_number: z.string(),
});

export const requestAdminLoginCodeResponseSchema = z.object({
  message: z.string(),
});

export const verifyAdminLoginCodeSchema = z.object({
  phone_number: z.string(),
  code: z.string(),
});

export const verifyAdminLoginCodeResponseSchema = z.object({
  token: z.string(),
  expires_at: z.number(),
});

export const requestAdminLoginEmailCodeSchema = z.object({
  email: z.string(),
});

export const verifyAdminLoginEmailCodeSchema = z.object({
  email: z.string(),
  code: z.string(),
});

export const verifyAdminLoginPasswordSchema = z.object({
  identifier: z.string(),
  password: z.string(),
});

export const announcementColorSchema = z.nativeEnum(AnnouncementColor);

export const announcementScopeSchema = z.nativeEnum(AnnouncementScope);

export const announcementMessagesSchema = z.object({
  en: z.string(),
  pt: z.string(),
  fr: z.string(),
});

export const announcementSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    messages: announcementMessagesSchema,
    color: announcementColorSchema,
    scope: announcementScopeSchema,
    merchant_ids: z.array(z.string()),
    store_ids: z.array(z.string()),
    starts_at: z.string(),
    ends_at: z.string(),
    ended_at: z.string().nullish(),
  });

export const createAnnouncementSchema = z.object({
  messages: announcementMessagesSchema,
  color: announcementColorSchema,
  scope: announcementScopeSchema,
  merchant_ids: z.array(z.string()).nullish(),
  store_ids: z.array(z.string()).nullish(),
  starts_at: z.string().nullish(),
  ends_at: z.string(),
});

export const updateAnnouncementSchema = createAnnouncementSchema.extend({
  version: z.number(),
});

export const announcementsResponseSchema = z.object({
  announcements: z.array(announcementSchema),
});

export const activeAnnouncementSchema = z.object({
  id: z.string(),
  version: z.number(),
  messages: announcementMessagesSchema,
  color: announcementColorSchema,
});

export const getActiveAnnouncementsSchema = z.object({
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
});

export const activeAnnouncementsResponseSchema = z.object({
  announcements: z.array(activeAnnouncementSchema),
});

export const announcementDBItemSchema = announcementSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const attachmentKindSchema = z.nativeEnum(AttachmentKind);

export const attachmentStatusSchema = z.nativeEnum(AttachmentStatus);

export const attachmentEntityTypeSchema = z.nativeEnum(AttachmentEntityType);

export const attachmentContentTypeSchema = z.nativeEnum(AttachmentContentType);

export const attachmentSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    entity_type: attachmentEntityTypeSchema,
    entity_id: z.string(),
    kind: attachmentKindSchema,
    file_name: z.string(),
    expected_content_type: attachmentContentTypeSchema,
    expected_size: z.number(),
    status: attachmentStatusSchema,
    rejected_reason: z.string().nullish(),
    verified_at: z.string().nullish(),
    created_by_id: z.string(),
    created_by_name: z.string(),
  });

export const getAttachmentSchema = z.object({
  merchant_id: z.string(),
  attachment_id: z.string(),
});

export const createAttachmentIntentSchema = z.object({
  store_id: z.string().trim().min(1),
  entity_type: attachmentEntityTypeSchema,
  entity_id: z.string().trim().min(1).max(100),
  kind: attachmentKindSchema,
  file_name: z.string().trim().min(1).max(200),
  content_type: attachmentContentTypeSchema,
  size: z.number().int().positive().max(10 * 1024 * 1024),
});

export const attachmentIntentResultSchema = z.object({
  attachment: attachmentSchema,
  upload_url: z.string(),
  upload_headers: z.record(z.string()),
  expires_at: z.string(),
});

export const attachmentViewUrlSchema = z.object({
  attachment: attachmentSchema,
  url: z.string(),
  expires_at: z.string(),
});

export const signatureRecordSchema = z.object({
  role: z.string(),
  attachment_id: z.string(),
  signer_id: z.string(),
  signer_name: z.string(),
  signed_at: z.string(),
  document_hash: z.string(),
  document_version: z.number(),
  method: z.literal('CANVAS'),
});

export const attachmentDBItemSchema = attachmentSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  key: z.string(),
  ttl: z.number().nullish(),
});

export const auditTrailActionSchema = z.nativeEnum(AuditTrailAction);

export const auditTrailEntrySchema = z.object({
  timestamp: z.string(),
  employee_id: z.string(),
  employee_name: z.string(),
  action: auditTrailActionSchema,
  entity_type: z.string(),
  entity_id: z.string(),
  description: z.string(),
  source: z.string(),
});

export const auditTrailPageSchema = z.object({
  entries: z.array(auditTrailEntrySchema),
  count: z.number(),
});

export const getEmployeeTimelineSchema = z.object({
  merchant_id: z.string(),
  employee_id: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  store_id: z.string().nullish(),
});

export const authTypeSchema = z.nativeEnum(AuthType);

export const cognitoAttributeDataTypeSchema = z.nativeEnum(
  CognitoAttributeDataType,
);

export const cognitoAttributeDefinitionSchema = z.object({
  AttributeDataType: cognitoAttributeDataTypeSchema.nullish(),
  Mutable: z.boolean(),
  Name: z.string(),
  Required: z.boolean().nullish(),
});

export const merchantAuthStoreSchema = z.object({
  store_id: z.string(),
  store_name: z.string(),
  merchant_id: z.string(),
  roles: z.array(z.string()),
});

export const merchantAuthStoreWithRolesSchema = z.object({
  store_id: z.string(),
  roles: z.array(z.string()),
});

export const merchantUserAttributesSchema = z.object({
  username: z.string(),
  phone_number: z.string(),
  email: z.string(),
  address: z.string(),
  family_name: z.string(),
  given_name: z.string(),
  auth_type: authTypeSchema,
  business_name: z.string(),
  created_by: z.string(),
  pin: z.string(),
  stores: z.array(merchantAuthStoreSchema),
  use_whatsapp_otp: z.boolean().nullish(),
});

export const authenticateUserRequestSchema = z.object({
  phone_number: z.string(),
  pin: z.string(),
  client_id: z.string(),
});

export const decryptCredentialsRequestBodySchema = z.object({
  encryptedCredentials: z.string(),
});

export const signOutUserRequestBodySchema = z.object({
  accessToken: z.string(),
});

export const signOutUserResponseSchema = z.object({
  message: z.string(),
});

export const createMerchantUserRequestBodySchema = z.object({
  phone_number: z.string(),
  email: z.string().nullish(),
  address: z.string().nullish(),
  family_name: z.string().nullish(),
  given_name: z.string().nullish(),
  auth_type: authTypeSchema,
  business_name: z.string(),
  created_by: z.string(),
  stores: z.array(merchantAuthStoreSchema),
  pin: z.string(),
});

export const createAdminUserRequestBodySchema = z.object({
  phone_number: z.string(),
  email: z.string(),
  address: z.string().nullish(),
  family_name: z.string().nullish(),
  given_name: z.string().nullish(),
  auth_type: authTypeSchema,
  password: z.string(),
});

export const updateAdminUserRequestBodySchema = z.object({
  user_id: z.string(),
  email: z.string(),
  address: z.string().nullish(),
  family_name: z.string().nullish(),
  given_name: z.string().nullish(),
  stores: z.array(merchantAuthStoreSchema).nullish(),
});

export const createAuthUserResponseSchema = z.object({
  message: z.string(),
  userSub: z.string().nullish(),
});

export const customerAuthStoreSchema = z.object({
  store_id: z.string(),
  store_name: z.string(),
  merchant_id: z.string(),
});

export const customerUserAttributesSchema = z.object({
  username: z.string(),
  phone_number: z.string(),
  email: z.string(),
  address: z.string(),
  family_name: z.string(),
  given_name: z.string(),
  gender: z.string(),
  profile_picture: z.string(),
  auth_type: authTypeSchema,
  created_by: z.string(),
  pin: z.string(),
  stores: z.array(customerAuthStoreSchema),
});

export const adminUserAttributesSchema = z.object({
  username: z.string(),
  phone_number: z.string(),
  email: z.string(),
  address: z.string(),
  family_name: z.string(),
  given_name: z.string(),
  auth_type: authTypeSchema,
});

export const updateMerchantUserRequestBodySchema = z.object({
  user_id: z.string(),
  email: z.string().nullish(),
  address: z.string().nullish(),
  family_name: z.string().nullish(),
  given_name: z.string().nullish(),
  business_name: z.string().nullish(),
  pin: z.string().nullish(),
  add_to_stores: z.array(merchantAuthStoreSchema).nullish(),
  remove_from_stores: z.array(merchantAuthStoreSchema).nullish(),
  is_email_verified: z.boolean().nullish(),
  add_to_roles: z.array(merchantAuthStoreWithRolesSchema).nullish(),
  remove_from_roles: z.array(merchantAuthStoreWithRolesSchema).nullish(),
});

export const createCustomerUserRequestBodySchema = z.object({
  phone_number: z.string(),
  email: z.string().nullish(),
  address: z.string().nullish(),
  family_name: z.string().nullish(),
  given_name: z.string().nullish(),
  auth_type: authTypeSchema,
  created_by: z.string(),
  stores: z.array(merchantAuthStoreSchema),
  pin: z.string(),
  gender: z.string().nullish(),
  profile_picture: z.string().nullish(),
});

export const updateCustomerUserRequestBodySchema = z.object({
  user_id: z.string(),
  email: z.string().nullish(),
  address: z.string().nullish(),
  family_name: z.string().nullish(),
  given_name: z.string().nullish(),
  stores: z.array(customerAuthStoreSchema).nullish(),
  pin: z.string().nullish(),
  gender: z.string().nullish(),
  profile_picture: z.string().nullish(),
});

export const updateAuthUserResponseSchema = z.object({
  message: z.string(),
});

export const userAttributeSchema = z.object({
  Name: z.string(),
  Value: z.string(),
});

export const resetUserPasswordRequestBodySchema = z.object({
  user_id: z.string(),
  new_pin: z.string().nullish(),
  auth_type: authTypeSchema,
  new_password: z.string().nullish(),
});

export const languageSchema = z.nativeEnum(Language);

export const sendWhatsappOtpResponseSchema = z.object({
  message: z.string(),
  whatsapp_message_id: z.string(),
});

export const updateOtpSettingsRequestSchema = z.object({
  user_id: z.string(),
  use_whatsapp_otp: z.boolean(),
});

export const updateOtpSettingsResponseSchema = z.object({
  message: z.string(),
});

export const createAuthChallengeRequestSchema = z.object({
  client_id: z.string(),
  phone_number: z.string(),
});

export const createAuthChallengeResponseSchema = z.object({
  session: z.string(),
  message: z.string(),
});

export const verifyAuthChallengeRequestSchema = z.object({
  client_id: z.string(),
  phone_number: z.string(),
  session: z.string(),
  answer: z.string(),
});

export const initiatePinRecoveryRequestSchema = z.object({
  client_id: z.string(),
  phone_number: z.string(),
});

export const initiatePinRecoveryResponseSchema = z.object({
  session: z.string(),
  message: z.string(),
});

export const completePinRecoveryRequestSchema = z.object({
  client_id: z.string(),
  phone_number: z.string(),
  session: z.string(),
  answer: z.string(),
});

export const principalSchema = z.object({
  id: z.string(),
  created_at: z.string(),
  deleted_at: z.string(),
  updated_history: z.array(z.string()),
  merchant_id: z.string(),
  role_id: z.string(),
});

export const metaSchema = z.object({
  num_read: z.number(),
  next_cursor: z.string(),
});

export const policySchema = z.object({
  id: z.string(),
  policy: z.string(),
  action_id: z.string(),
  resource_id: z.string(),
  description: z.string(),
  created_at: z.string(),
  deleted_at: z.string(),
  updated_history: z.array(z.string()),
});

export const actionSchema = z.object({
  id: z.string(),
  description: z.string(),
  verb: z.string(),
  resource_id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string(),
  update_history: z.array(z.string()),
});

export const resourceSchema = z.object({
  id: z.string(),
  description: z.string(),
  path: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string(),
  update_history: z.string(),
});

export const actionListSchema = z.object({
  actions: z.array(actionSchema),
  meta: metaSchema,
});

export const resourceListSchema = z.object({
  resources: z.array(resourceSchema),
  meta: metaSchema,
});

export const policyListSchema = z.object({
  policies: z.array(policySchema),
  meta: metaSchema,
});

export const roleSchema = z.object({
  id: z.string(),
  description: z.string(),
  policies: z.array(z.string()),
  created_at: z.string(),
  resources: z.array(z.string()),
  deleted_at: z.string(),
  updated_history: z.array(z.string()),
  role_id: z.string(),
});

export const roleListSchema = z.object({
  roles: z.array(roleSchema),
  meta: metaSchema,
});

export const multiplePolicyListSchema = z.object({
  policies: z.array(policySchema),
  meta: z.object({
    items_created: z.number(),
  }),
});

export const policyBodySchema = z.object({
  action_id: z.string(),
  resource_id: z.string(),
  description: z.string(),
});

export const resourceTypeV2Schema = z.nativeEnum(ResourceTypeV2);

export const actionV2Schema = z.nativeEnum(ActionV2);

export const resourceV2Schema = z.object({
  name: z.string(),
  type: resourceTypeV2Schema,
});

export const permissionV2Schema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    resource: resourceV2Schema,
    action: actionV2Schema,
    description: z.string(),
  });

export const createPermissionV2Schema = z.object({
  resource: resourceV2Schema,
  action: actionV2Schema,
  description: z.string(),
});

export const getPermissionV2Schema = z.object({
  id: z.string(),
});

export const softDeleteFlagSchema = z.nativeEnum(SoftDeleteFlag);

export const permissionsPageV2Schema = z.object({
  count: z.number(),
  cursor: z.string().nullish(),
  permissions: z.array(permissionV2Schema),
});

export const updatePermissionCommandV2Schema = z.nativeEnum(
  UpdatePermissionCommandV2,
);

export const updatePermissionV2Schema = z.object({
  id: z.string(),
  command: updatePermissionCommandV2Schema,
  resource: resourceV2Schema.nullish(),
  action: actionV2Schema.nullish(),
  description: z.string().nullish(),
});

export const roleV2Schema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
    permissions: z.array(permissionV2Schema),
    name: z.string(),
    description: z.string(),
  });

export const createRoleV2Schema = z.object({
  merchant_id: z.string(),
  name: z.string(),
  description: z.string(),
});

export const getRoleV2Schema = z.object({
  id: z.string(),
  include_permissions: z.boolean().nullish(),
});

export const getAllRolesV2Schema = z.object({
  merchant_id: z.string(),
  principal_id: z.string().nullish(),
  store_id: z.string().nullish(),
  by_principal: z.boolean().nullish(),
  by_principal_and_store: z.boolean().nullish(),
  by_merchant: z.boolean().nullish(),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
  include_permissions: z.boolean().nullish(),
  include_deleted: softDeleteFlagSchema,
});

export const rolesPageV2Schema = z.object({
  count: z.number(),
  cursor: z.string().nullish(),
  roles: z.array(roleV2Schema),
});

export const updateRoleCommandV2Schema = z.nativeEnum(UpdateRoleCommandV2);

export const addPrincipalToRoleSchema = z.object({
  principal_id: z.string(),
  store_id: z.string(),
});

export const updateRoleV2Schema = z.object({
  id: z.string(),
  command: updateRoleCommandV2Schema,
  permissions: z.array(z.string()).nullish(),
  principals: z.array(addPrincipalToRoleSchema).nullish(),
  description: z.string().nullish(),
  name: z.string().nullish(),
});

export const principalV2Schema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
  });

export const createPrincipalV2Schema = z.object({
  id: z.string(),
  merchant_id: z.string(),
});

export const getPrincipalV2Schema = z.object({
  id: z.string(),
});

export const updatePrincipalCommandV2Schema = z.nativeEnum(
  UpdatePrincipalCommandV2,
);

export const addRoleToPrincipalSchema = z.object({
  role_id: z.string(),
  store_id: z.string(),
});

export const updatePrincipalV2Schema = z.object({
  id: z.string(),
  command: updatePrincipalCommandV2Schema,
  roles: z.array(addRoleToPrincipalSchema),
});

export const getAllPrincipalsByRoleV2Schema = z.object({
  role_id: z.string(),
});

export const principalsPageV2Schema = z.object({
  count: z.number(),
  cursor: z.string().nullish(),
  principals: z.array(z.string()),
});

export const principalIdsPageV2Schema = z.object({
  ids: z.array(z.string()),
});

export const rolePrincipalV2Schema = z.object({
  role_id: z.string(),
  principal_id: z.string(),
  store_id: z.string(),
});

export const principalRoleV2Schema = rolePrincipalV2Schema;

export const policyV2Schema = z.object({
  principalId: z.string(),
  policyDocument: z
    .object({
      Version: z.string(),
      Statement: z.array(
        z.object({
          Action: z.string(),
          Effect: z.union([z.literal('Allow'), z.literal('Deny')]),
          Resource: z.string(),
        }),
      ),
    })
    .nullish(),
  context: z.record(z.union([z.string(), z.number(), z.boolean()])).nullish(),
});

export const policyDecisionSchema = z.nativeEnum(PolicyDecision);

export const authorizeOpenAppSchema = z.object({
  app_names: z.array(z.string()),
  principal_id: z.string(),
  store_id: z.string().nullish(),
  merchant_id: z.string().nullish(),
});

export const verifyCedarBodySchema = z.object({
  policy_string: z.string(),
  principal: z.string(),
  action: z.string(),
  resource: z.string(),
});

export const verifyCedarResultSchema = z.object({
  allow: z.boolean(),
});

export const authorizeOpenAppResultSchema = z.object({
  results: z.array(
    z.object({
      resource: z.string(),
      allow: z.boolean(),
    }),
  ),
});

export const createMerchantRoleSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
});

export const authorizeActionRequestSchema = z.object({
  action: z.string(),
  store_ids: z.array(z.string()),
});

export const authorizeActionsSchema = z.object({
  principal_id: z.string(),
  actions: z.array(authorizeActionRequestSchema),
});

export const authorizeActionDecisionSchema =
  authorizeActionRequestSchema.extend({
    allow: z.boolean(),
  });

export const authorizeActionsResultSchema = z.object({
  permissions_version: z.number(),
  results: z.array(authorizeActionDecisionSchema),
});

export const getMyActionsSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
});

export const myActionsResultSchema = z.object({
  permissions_version: z.number(),
  actions: z.array(z.string()),
});

export const getTeamActionsSchema = z.object({
  store_id: z.string(),
  principal_ids: z.array(z.string().min(1)).min(1).max(250),
});

export const getPrincipalStoreRolesSchema = z.object({
  merchant_id: z.string().trim().min(1),
  principal_id: z.string().trim().min(1),
});

export const principalStoreRolesSchema = z.object({
  stores: z.record(z.array(z.string())),
});

export const getRolePrincipalsInStoreSchema = z.object({
  merchant_id: z.string().trim().min(1),
  role_id: z.string().trim().min(1),
  store_id: z.string().trim().min(1),
});

export const rolePrincipalsInStoreSchema = z.object({
  role_id: z.string(),
  role_name: z.string(),
  principal_ids: z.array(z.string()),
});

export const teamActionsResultSchema = z.object({
  permissions_version: z.number(),
  actions: z.record(z.array(z.string())),
});

export const createCustomerSchema = z.object({
  name: z.string(),
  email: z.string().nullish(),
  phone_number: z.string().nullish(),
  address: z.string().nullish(),
  city: z.string().nullish(),
  region: z.string().nullish(),
  postal_code: z.string().nullish(),
  country_code: z.string().nullish(),
  customer_code: z.string().nullish(),
  note: z.string().nullish(),
  first_visit: z.string().nullish(),
  last_visit: z.string().nullish(),
  pin: z.string(),
  merchant_id: z.string(),
  id: z.string().nullish(),
});

export const getCustomerSchema = z.object({
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
  store_id: z.string().nullish(),
  with_debt: z.boolean().nullish(),
});

export const getCustomersSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  merchant_id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
  store_id: z.string().nullish(),
  with_debt: z.boolean().nullish(),
});

export const transactionTypeSchema = z.nativeEnum(TransactionType);

export const loyaltyTransactionItemSchema = z.object({
  product_id: z.string(),
  product_name: z.string(),
  price: z.number(),
  quantity: z.number(),
  eligible_for_points: z.boolean(),
});

export const loyaltyTransactionSchema = z.object({
  id: z.string(),
  customer_id: z.string(),
  type: transactionTypeSchema,
  items: z.array(loyaltyTransactionItemSchema),
  total_amount: z.number(),
  date: z.string(),
  merchant_id: z.string(),
});

export const loyaltyProductSchema = z.object({
  id: z.string(),
  name: z.string(),
  price: z.number(),
  eligible_for_points: z.boolean(),
  category: z.string().nullish(),
  store_id: z.string(),
});

export const updateLoyaltyAfterSaleOrRefundSchema = z.object({
  customer_id: z.string(),
  receipt_id: z.string().nullish(),
  total_spent: z.number(),
  visit_count: z.number(),
  merchant_id: z.string(),
  store_id: z.string(),
  points_earned: z.number(),
  points_deducted: z.number(),
});

export const redeemPointsSchema = z.object({
  merchant_id: z.string(),
  customer_id: z.string(),
  points_to_redeem: z.number(),
  store_id: z.string(),
});

export const redeemPointOutputSchema = z.object({
  transaction: loyaltyTransactionSchema,
  discount_amount: z.number(),
});

export const loyaltyTypeSchema = z.nativeEnum(LoyaltyType);

export const loyaltyProgramSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    loyalty_type: loyaltyTypeSchema,
    description: z.string(),
    points_per_threshold: z.number(),
    threshold_amount: z.number(),
    merchant_id: z.string(),
    store_id: z.string(),
    is_active: z.boolean(),
  });

export const createLoyaltyProgramSchema = z.object({
  name: z.string(),
  loyalty_type: loyaltyTypeSchema,
  description: z.string(),
  points_per_threshold: z.number(),
  threshold_amount: z.number(),
  merchant_id: z.string(),
  is_active: z.boolean(),
  store_id: z.string(),
});

export const updateLoyaltyProgramSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  name: z.string().nullish(),
  loyalty_type: loyaltyTypeSchema.nullish(),
  description: z.string().nullish(),
  points_per_threshold: z.number().nullish(),
  threshold_amount: z.number().nullish(),
  is_active: z.boolean().nullish(),
});

export const loyaltyProgramDBItemSchema = loyaltyProgramSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const loyaltyProgramPageSchema = z.object({
  cursor: z.string().nullish(),
  count: z.number().nullish(),
  programs: z.array(loyaltyProgramSchema),
});

export const getLoyaltyProgramsSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  merchant_id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const dailyCountItemStatusSchema = z.nativeEnum(DailyCountItemStatus);

export const dailyCountAuditEntrySchema = z.object({
  counted_by: z.string(),
  counted_by_name: z.string(),
  counted_stock: z.number(),
  expected_stock: z.number(),
  counted_at: z.string(),
  recount_reason: z.string().nullish(),
});

export const dailyCountItemSchema = z.object({
  product_id: z.string(),
  product_name: z.string(),
  status: dailyCountItemStatusSchema,
  expected_stock: z.number().nullable(),
  counted_stock: z.number().nullable(),
  counted_by: z.string().nullable(),
  counted_by_name: z.string().nullable(),
  counted_at: z.string().nullable(),
  carried_from_date: z.string().nullable(),
  is_short: z.boolean(),
  recount_reason: z.string().nullish(),
  count_audit: z.array(dailyCountAuditEntrySchema).nullish(),
});

export const dailyCountListSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    store_id: z.string(),
    merchant_id: z.string(),
    count_date: z.string(),
    items: z.array(dailyCountItemSchema),
    generated_at: z.string(),
    target_count: z.number(),
    fresh_count: z.number(),
    carried_over_count: z.number(),
  });

export const paginatedSchema = z.object({
  cursor: z.union([z.string(), z.undefined()]).nullish(),
  count: z.number(),
});

export const recordDailyCountSchema = z.object({
  store_id: z.string(),
  count_date: z.string(),
  product_id: z.string(),
  counted_by: z.string(),
  counted_stock: z.number(),
  expected_stock: z.number(),
  recount_reason: z.string().nullish(),
});

export const getDailyCountListsSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  date: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const triggerDailyCountListSchema = z.object({
  store_id: z.string(),
  force: z.boolean().nullish(),
  fresh: z.boolean().nullish(),
});

export const dailyCountListDBItemSchema = dailyCountListSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const debtOriginTypeSchema = z.nativeEnum(DebtOriginType);

export const entityTypesSchema = z.nativeEnum(EntityTypes);

export const debtStatusSchema = z.nativeEnum(DebtStatus);

export const debtTransferSchema = timestampsSchema.extend({
  id: z.string(),
  from_debt_id: z.string(),
  to_debt_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  note: z.string(),
  creator_id: z.string(),
  creator_name: z.string(),
  creator_type: entityTypesSchema,
  amount: z.number(),
});

export const paymentPlanSchema = timestampsSchema.extend({
  amount: z.number(),
  frequency: z.number(),
  store_id: z.string(),
  merchant_id: z.string(),
  note: z.string(),
  id: z.string(),
});

export const debtEventSchema = z.nativeEnum(DebtEvent);

export const changedAttributesSchema = z.record(
  z.object({
    old: z.any(),
    new: z.any(),
  }),
);

export const getDebtChangesSchema = z.object({
  by_event: z.boolean(),
  by_event_and_debt: z.boolean(),
  by_event_and_date_range: z.boolean(),
  by_debt: z.boolean(),
  by_debt_and_date_range: z.boolean(),
  by_updator: z.boolean(),
  by_updator_and_date_range: z.boolean(),
  by_updator_and_debt: z.boolean(),
  event: debtEventSchema.nullish(),
  debt_id: z.string().nullish(),
  updator_id: z.string().nullish(),
  updator_type: entityTypesSchema.nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  store_id: z.string().nullish(),
  merchant_id: z.string(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const debtPaymentSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    debt_id: z.string(),
    amount: z.number(),
    outstanding_balance: z.number(),
    initial_amount: z.number(),
    payment_type: paymentMethodTypeSchema,
    user_id: z.string(),
    payer_name: z.string(),
    payer_id: z.string(),
    payer_type: entityTypesSchema,
    store_id: z.string(),
    merchant_id: z.string(),
    note: z.string(),
    origin_type: debtOriginTypeSchema.nullish(),
    plan_id: z.string().nullish(),
    shift_id: z.string().nullish(),
    payment_type_id: z.string().nullish(),
    payment_type_name: z.string().nullish(),
    is_reversal: z.boolean().nullish(),
    reverses_payment_id: z.string().nullish(),
    reversed_by_payment_id: z.string().nullish(),
  });

export const debtChangeEventSchema = z.object({
  changes: changedAttributesSchema,
  event: debtEventSchema,
});

export const createDebtCommandPayloadSchema = z.object({
  creator_id: z.string(),
  creator_type: entityTypesSchema,
  creator_name: z.string(),
  debtor_id: z.string(),
  debtor_type: entityTypesSchema,
  debtor_name: z.string(),
  shift_id: z.string().nullish(),
  store_id: z.string(),
  merchant_id: z.string(),
  origin_type: debtOriginTypeSchema,
  principal_amount: z.number(),
  interest_rate: z.number(),
  reason: z.string(),
  payment_type_id: z.string().nullish(),
  is_due_date_auto_calculated: z.boolean().nullish(),
  initial_outstanding_balance: z.number().nullish(),
  next_due_date: z.string().nullish(),
  receipt_id: z.string().nullish(),
  payment_plan: z
    .object({
      amount: z.number(),
      frequency: z.number(),
      note: z.string().nullish(),
    })
    .nullish(),
});

export const updateDebtStatusCommandPayloadSchema = z.object({
  debt_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
  status: debtStatusSchema,
});

export const cancelDebtCommandPayloadSchema = z.object({
  debt_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
  reason: z.string(),
});

export const transferDebtCommandPayloadSchema = z.object({
  from_debt_id: z.string(),
  new_debtor_id: z.string(),
  new_debtor_type: entityTypesSchema,
  new_debtor_name: z.string(),
  amount: z.number(),
  note: z.string(),
  shift_id: z.string().nullish(),
  store_id: z.string(),
  merchant_id: z.string(),
  creator_id: z.string(),
  creator_type: entityTypesSchema,
  creator_name: z.string(),
});

export const updateDateInterestRateCommandPayloadSchema = z.object({
  debt_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
  interest_rate: z.number(),
});

export const updateDebtPrincipalCommandPayloadSchema = z.object({
  debt_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
  principal_amount: z.number(),
});

export const addDebtPaymentCommandPayloadSchema = z.object({
  debt_id: z.string(),
  amount: z.number(),
  payment_type: paymentMethodTypeSchema,
  payment_type_id: z.string().nullish(),
  payment_type_name: z.string().nullish(),
  payer_id: z.string(),
  payer_type: entityTypesSchema,
  payer_name: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  user_id: z.string(),
  note: z.string().nullish(),
  shift_id: z.string().nullish(),
});

export const updateDebtPaymentPlanCommandPayloadSchema = z.object({
  debt_id: z.string(),
  amount: z.number().nullish(),
  frequency: z.number().nullish(),
  note: z.string().nullish(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
});

export const reverseDebtPaymentCommandPayloadSchema = z.object({
  debt_id: z.string(),
  payment_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  user_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
  reason: z.string(),
  shift_id: z.string().nullish(),
});

export const reverseDebtCommandPayloadSchema = z.object({
  debt_id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  user_id: z.string(),
  updator_type: entityTypesSchema,
  updator_name: z.string(),
  reason: z.string(),
  shift_id: z.string().nullish(),
  payment_type_id: z.string(),
});

export const debtCommandTypeSchema = z.nativeEnum(DebtCommandType);

export const debtCommandSchema = z.object({
  command: debtCommandTypeSchema,
  createDebtCommandPayload: createDebtCommandPayloadSchema.nullish(),
  updateDebtStatusCommandPayload:
    updateDebtStatusCommandPayloadSchema.nullish(),
  cancelDebtCommandPayload: cancelDebtCommandPayloadSchema.nullish(),
  transferDebtCommandPayload: transferDebtCommandPayloadSchema.nullish(),
  updateDateInterestRateCommandPayload:
    updateDateInterestRateCommandPayloadSchema.nullish(),
  updateDebtPrincipalCommandPayload:
    updateDebtPrincipalCommandPayloadSchema.nullish(),
  addDebtPaymentCommandPayload: addDebtPaymentCommandPayloadSchema.nullish(),
  updateDebtPaymentPlanCommandPayload:
    updateDebtPaymentPlanCommandPayloadSchema.nullish(),
  reverseDebtPaymentCommandPayload:
    reverseDebtPaymentCommandPayloadSchema.nullish(),
  reverseDebtCommandPayload: reverseDebtCommandPayloadSchema.nullish(),
});

export const debtPaymentDBItemSchema = debtPaymentSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
});

export const getDebtAggregateSchema = z.object({
  debt_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  change_cursor: z.string().nullish(),
  payment_cursor: z.string().nullish(),
  change_limit: z.number().nullish(),
  payment_limit: z.number().nullish(),
});

export const getDebtsSchema = z.object({
  by_store: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
  by_store_and_status: z.boolean().nullish(),
  by_store_and_status_and_date_range: z.boolean().nullish(),
  by_store_and_origin: z.boolean().nullish(),
  by_store_and_origin_and_date_range: z.boolean().nullish(),
  by_creator: z.boolean().nullish(),
  by_creator_and_date_range: z.boolean().nullish(),
  by_debtor: z.boolean().nullish(),
  by_debtor_and_store: z.boolean().nullish(),
  by_debtor_and_date_range: z.boolean().nullish(),
  by_merchant: z.boolean().nullish(),
  by_merchant_and_date_range: z.boolean().nullish(),
  by_receipt: z.boolean().nullish(),
  store_id: z.string().nullish(),
  merchant_id: z.string(),
  status: debtStatusSchema.nullish(),
  origin: debtOriginTypeSchema.nullish(),
  debtor_id: z.string().nullish(),
  debtor_type: entityTypesSchema.nullish(),
  creator_id: z.string().nullish(),
  creator_type: entityTypesSchema.nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  receipt_id: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  with_debts: z.boolean().nullish(),
});

export const getDebtPaymentsSchema = z.object({
  by_debt: z.boolean().nullish(),
  by_debt_and_date_range: z.boolean().nullish(),
  by_payer: z.boolean().nullish(),
  by_payer_and_date_range: z.boolean().nullish(),
  by_merchant: z.boolean().nullish(),
  by_merchant_and_date_range: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
  debt_id: z.string().nullish(),
  payer_id: z.string().nullish(),
  payer_type: entityTypesSchema.nullish(),
  store_id: z.string().nullish(),
  merchant_id: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const debtPaymentsPageSchema = z.object({
  payments: z.array(debtPaymentSchema),
  cursor: z.string(),
  count: z.number(),
});

export const outstandingBalanceResponseSchema = z.object({
  outstanding_balance: z.number(),
  debt_count: z.number(),
});

export const getOutstandingBalanceDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  as_of: z.string(),
});

export const getDebtorSummarySchema = z.object({
  debtor_id: z.string(),
  debtor_type: entityTypesSchema,
  merchant_id: z.string(),
  store_id: z.string(),
  with_debts: z.boolean().nullish(),
  closed_debt_cursor: z.string().nullish(),
  closed_debt_limit: z.number().nullish(),
});

export const discountTypeSchema = z.nativeEnum(DiscountType);

export const discountApplicationSchema = z.nativeEnum(DiscountApplication);

export const discountSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    type: discountTypeSchema,
    name: z.string(),
    discount_amount: z.number().nullish(),
    discount_percent: z.number().nullish(),
    store_id: z.string(),
    restricted_access: z.boolean().nullish(),
    application: discountApplicationSchema.nullish(),
    valid_until: z.string().nullish(),
    product_ids: z.array(z.string()).nullish(),
    merchant_id: z.string().nullish(),
    deadline_set_by: z.string().nullish(),
    expiry_processed_at: z.string().nullish(),
    expiry_attempt_count: z.number().int().nonnegative().nullish(),
    expiry_failed_at: z.string().nullish(),
    expiry_error: z.string().nullish(),
  });

export const discountAuditSnapshotSchema = z.object({
  id: z.string(),
  name: z.string().trim().min(1).max(40),
  type: discountTypeSchema,
  discount_amount: z.number().finite().positive().optional(),
  discount_percent: z.number().finite().positive().max(100).optional(),
  valid_until: z.string().nullish(),
});

export const productDiscountChangeActionSchema = z.nativeEnum(
  ProductDiscountChangeAction,
);

export const productDiscountChangeSchema = z.object({
  action: productDiscountChangeActionSchema,
  previous_discount: discountAuditSnapshotSchema.nullish(),
  discount: discountAuditSnapshotSchema.nullish(),
  occurred_at: z.string().datetime(),
});

export const discountPageSchema = z.object({
  discounts: z.array(discountSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const createDiscountSchema = z.object({
  type: discountTypeSchema,
  name: z.string().trim().min(1).max(40),
  discount_amount: z.number().finite().positive().optional(),
  discount_percent: z.number().finite().positive().max(100).optional(),
  store_id: z.string(),
  restricted_access: z.boolean().optional(),
  application: discountApplicationSchema.nullish(),
  valid_until: z.string().nullish(),
  product_ids: z.array(z.string()).optional(),
  merchant_id: z.string().optional(),
  deadline_set_by: z.string().nullish(),
  updator_id: z.string().optional(),
});

export const updateDiscountSchema = z.object({
  id: z.string(),
  type: discountTypeSchema.optional(),
  name: z.string().trim().min(1).max(40).optional(),
  discount_amount: z.number().finite().positive().optional(),
  discount_percent: z.number().finite().positive().max(100).optional(),
  store_id: z.string(),
  restricted_access: z.boolean().optional(),
  application: discountApplicationSchema.nullish(),
  valid_until: z.string().nullish(),
  product_ids: z.array(z.string()).optional(),
  subscribe_product_ids: z.array(z.string()).nullish(),
  unsubscribe_product_ids: z.array(z.string()).nullish(),
  merchant_id: z.string().optional(),
  deadline_set_by: z.string().nullish(),
  updator_id: z.string().optional(),
});

export const setProductDiscountSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  product_id: z.string(),
  discount_id: z.string().nullable(),
  updator_id: z.string(),
});

export const productDiscountAssignmentSchema = z.object({
  product_id: z.string(),
  discount_id: z.string().nullable(),
});

export const discountDBItemSchema = discountSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI8PK: z.string().nullish(),
  GSI8SK: z.string().nullish(),
});

export const getDiscountByIdSchema = z.object({
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getDiscountsSchema = z.object({
  store_id: z.string(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
  include_manual: z.boolean().nullish(),
});

export const calculateDiscountCommandsSchema = z.nativeEnum(
  CalculateDiscountCommands,
);

export const calculateDiscountSchema = z.object({
  item_price: z.number(),
  discount_ids: z.array(z.string()),
  added_discount_id: z.string(),
  included_discount_ids: z.array(z.string()),
  command: calculateDiscountCommandsSchema,
});

export const calculateDiscountResultItemSchema = z.object({
  price: z.number(),
  finalPrice: z.number(),
  discount_value: z.number().nullish(),
  discount_ids: z.array(z.string()),
});

export const calculateDiscountResultSchema = z.object({
  discount_command: calculateDiscountCommandsSchema,
  item_price: z.number().nullish(),
  final_price: z.number().nullish(),
  discount_value: z.number().nullish(),
  total_discount: z.number().nullish(),
  total_tax: z.number().nullish(),
  items: z.array(calculateDiscountResultItemSchema).nullish(),
});

export const shopAndSmileEventSourceSchema = z.nativeEnum(
  ShopAndSmileEventSource,
);

export const eventStoreKeysSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const timeRangeSchema = z.object({
  from: z.string(),
  to: z.string(),
});

export const failedEventStatusSchema = z.union([
  z.literal('FAILED'),
  z.literal('REDRIVEN'),
  z.literal('DELETED'),
]);

export const failedEventSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  queueName: z.string(),
  sourceQueue: z.string(),
  dlqName: z.string(),
  service: z.string(),
  messageId: z.string(),
  receiptHandle: z.string(),
  body: z.string(),
  bodyParsed: z.record(z.unknown()),
  attributes: z.record(z.string()),
  messageAttributes: z.record(z.unknown()),
  failedAt: z.string(),
  receiveCount: z.number(),
  searchText: z.string(),
  status: failedEventStatusSchema,
  redrivenAt: z.string().nullish(),
  redriveMessageId: z.string().nullish(),
  redriveClaimedAt: z.string().nullish(),
  deletedAt: z.string().nullish(),
  deletedBy: z.string().nullish(),
});

export const failedEventSearchParamsSchema = z.object({
  q: z.string(),
  queueName: z.string().nullish(),
  service: z.string().nullish(),
  status: failedEventStatusSchema.nullish(),
  from: z.string().nullish(),
  to: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const failedEventPageSchema = z.object({
  query: z.string(),
  queueName: z.string().nullish(),
  service: z.string().nullish(),
  status: z.string().nullish(),
  count: z.number(),
  items: z.array(failedEventSchema),
  nextCursor: z.string().nullable(),
  redrivable: z.boolean().nullish(),
});

export const queueSummarySchema = z.object({
  queueName: z.string(),
  sourceQueue: z.string(),
  service: z.string(),
  failedCount: z.number(),
  redrivenCount: z.number(),
  lastFailedAt: z.string().nullable(),
  redrivable: z.boolean().nullish(),
});

export const queueSummaryPageSchema = z.object({
  queues: z.array(queueSummarySchema),
});

export const redriveFailedEventRequestSchema = z.object({
  queueName: z.string(),
  messageId: z.string(),
  sk: z.string(),
});

export const redriveResultSchema = z.object({
  message: z.string(),
  oldMessageId: z.string(),
  newMessageId: z.string(),
  sourceQueue: z.string(),
});

export const deleteFailedEventRequestSchema = z.object({
  queueName: z.string(),
  messageId: z.string(),
  sk: z.string(),
});

export const deleteResultSchema = z.object({
  message: z.string(),
  messageId: z.string(),
  deletedAt: z.string(),
});

export const queueWarningSchema = z.nativeEnum(QueueWarning);

export const queueConsumerSchema = z.object({
  function_name: z.string(),
  enabled: z.boolean(),
});

export const queueStatusSchema = z.object({
  name: z.string(),
  service: z.string(),
  fifo: z.boolean(),
  role: z.union([z.literal('main'), z.literal('dlq')]),
  dead_letter_queue: z.string().nullish(),
  max_receive_count: z.number().nullish(),
  source_queues: z.array(z.string()),
  archive_queue_name: z.string().nullish(),
  consumers: z.array(queueConsumerSchema),
  visible: z.number(),
  in_flight: z.number(),
  delayed: z.number(),
  oldest_message_age_seconds: z.number().nullish(),
  sent_24h: z.number().nullish(),
  deleted_24h: z.number().nullish(),
  visibility_timeout_seconds: z.number(),
  retention_seconds: z.number(),
  warnings: z.array(queueWarningSchema),
});

export const queueStatusPageSchema = z.object({
  stage: z.string(),
  retrieved_at: z.string(),
  queues: z.array(queueStatusSchema),
});

export const peekedQueueMessageSchema = z.object({
  message_id: z.string(),
  body: z.string(),
  sent_at: z.string().nullish(),
  receive_count: z.number().nullish(),
  message_group_id: z.string().nullish(),
});

export const peekedQueueMessagesSchema = z.object({
  queue_name: z.string(),
  messages: z.array(peekedQueueMessageSchema),
});

export const approvalStatusSchema = z.nativeEnum(ApprovalStatus);

export const globalProductFractionSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    parent_id: z.string(),
    fraction_id: z.string(),
    fraction: z.number(),
    fraction_name: z.string(),
    parent_name: z.string(),
  });

export const barcodeSchema = z.object({
  value: z.union([z.string(), z.number()]),
  type: z.union([z.string(), z.number()]),
  description: z.union([z.string(), z.undefined()]).nullish(),
});

export const productIssueTypeSchema = z.nativeEnum(ProductIssueType);

export const globalProductFractionPageSchema = z.object({
  fractions: z.array(globalProductFractionSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const createGlobalProductSchema = z.object({
  name: z.string(),
  description: z.string(),
  images: z.array(z.string()).nullish(),
  quantity_in_unit_package: z.number(),
  suggested_cost: z.number().finite().nonnegative().optional(),
  weight_kg: z.number(),
  unit: z.union([z.string(), z.number()]),
  unit_of_measurement: z.string(),
  country: z.string().nullish(),
  countries: z.array(z.string()).nullish(),
  barcodes: z.array(barcodeSchema).nullish(),
  tags: z.array(z.string()).nullish(),
  import_ids: z.array(z.string()).nullish(),
  parent_id: z.string().nullish(),
});

export const updateGlobalProductSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  images: z.array(z.string()).nullish(),
  parent_id: z.string().nullish(),
  quantity_in_unit_package: z.number().nullish(),
  suggested_cost: z.number().finite().nonnegative().nullish(),
  weight_kg: z.number().nullish(),
  unit: z.union([z.string(), z.number()]).nullish(),
  unit_of_measurement: z.string().nullish(),
  add_barcodes: z.array(barcodeSchema).nullish(),
  remove_barcodes: z.array(barcodeSchema).nullish(),
  add_tags: z.array(z.string()).nullish(),
  remove_tags: z.array(z.string()).nullish(),
  add_import_ids: z.array(z.string()).nullish(),
  approval_status: approvalStatusSchema.nullish(),
  add_images: z.array(z.string()).nullish(),
  remove_images: z.array(z.string()).nullish(),
  country: z.string().nullish(),
  countries: z.array(z.string()).nullish(),
});

export const getGlobalProductsSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  approval_status: approvalStatusSchema.nullish(),
  include_children: z.boolean().nullish(),
  hydrate_fractions: z.boolean().nullish(),
  country: z.string().nullish(),
});

export const getGlobalProductsByBarcodeSchema = z.object({
  barcode: z.union([z.string(), z.number()]),
  approval_status: approvalStatusSchema.nullish(),
  include_children: z.boolean().nullish(),
});

export const getGlobalProductsByTagsSchema = z.object({
  tags: z.array(z.string()),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  approval_status: approvalStatusSchema.nullish(),
  include_children: z.boolean().nullish(),
});

export const getGlobalProductFractionsSchema = z.object({
  parent_id: z.string(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const createGlobalProductFractionSchema = z.object({
  fraction_id: z.string(),
  parent_id: z.string(),
});

export const globalProductFractionDBItemSchema =
  globalProductFractionSchema.extend({
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const globalProductBarcodeIndexItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  barcode_value: z.string(),
  global_product_id: z.string(),
});

export const globalProductTagIndexItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  tag: z.string(),
  global_product_id: z.string(),
});

export const activityActionSchema = z.nativeEnum(ActivityAction);

export const activityOriginSchema = z.nativeEnum(ActivityOrigin);

export const activityChangeSchema = z.object({
  field: z.string(),
  old: z.unknown().nullish(),
  new: z.unknown().nullish(),
  truncated: z.boolean().nullish(),
});

export const activitySchema = z.object({
  id: z.string(),
  changed_at: z.string(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
  event: z.string(),
  action: activityActionSchema,
  entity_type: z.string(),
  entity_label: z.string().nullish(),
  origin: activityOriginSchema,
  changes: z.array(activityChangeSchema),
});

export const activityPageSchema = z.object({
  activities: z.array(activitySchema),
  cursor: z.string().nullish(),
});

export const getActivitiesSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  from: z.string().nullish(),
  to: z.string().nullish(),
  user_id: z.string().nullish(),
  entity_type: z.string().nullish(),
  include_automatic: z.boolean().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const imageSchema = timestampsSchema.extend({
  image_s3_url: z.string(),
  image_url: z.string(),
  image_s3_key: z.string(),
  entity_type: entityTypesSchema,
  entity_id: z.string(),
  image_id: z.string(),
  merchant_id: z.string(),
});

export const createImageSchema = z.object({
  image_id: z.string(),
  base64Image: z.string().nullish(),
  entity_type: entityTypesSchema,
  entity_id: z.string(),
  merchant_id: z.string(),
  imageUrl: z.string().nullish(),
  isGlobalImage: z.boolean().nullish(),
});

export const imagePageSchema = z.object({
  images: z.array(imageSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const imageFileTypesSchema = z.nativeEnum(ImageFileTypes);

export const uploadImageResponseSchema = z.object({
  image_s3_key: z.string(),
  image_id: z.string(),
  file_name: z.string(),
});

export const uploadImageRequestSchema = z.object({
  entity_type: entityTypesSchema,
  entity_id: z.string(),
  updator_id: z.string(),
  store_id: z.string(),
  updator_type: entityTypesSchema,
});

export const uploadPromoImageRequestSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  updator_type: entityTypesSchema,
  base64Image: z.string(),
  item_id: z.string(),
});

export const stringBooleanSchema = z.nativeEnum(StringBoolean);

export const integrationProviderSchema = z.literal('quickbooks');

export const quickBooksConnectionStatusSchema = z.union([
  z.literal('none'),
  z.literal('pending_code'),
  z.literal('connected'),
]);

export const quickBooksStoreLinkSchema = z.object({
  store_id: z.string(),
  qb_store_id: z.string(),
  qb_store_name: z.string(),
  linked_at: z.string(),
  linked_by_id: z.string(),
  linked_by_name: z.string(),
});

export const quickBooksConnectionSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    merchant_id: z.string(),
    provider: z.literal('quickbooks'),
    status: quickBooksConnectionStatusSchema,
    owner_phone_masked: z.string(),
    qb_merchant_id: z.string().nullish(),
    qb_merchant_name: z.string().nullish(),
    qb_merchant_created: z.boolean().nullish(),
    connected_at: z.string().nullish(),
    connected_by_id: z.string().nullish(),
    connected_by_name: z.string().nullish(),
    partner_token: z.string().nullish(),
    store_links: z.array(quickBooksStoreLinkSchema),
  });

export const quickBooksMappingsSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    merchant_id: z.string(),
    tax_codes: z.record(z.string()),
    units: z.record(z.string()),
  });

export const quickBooksProductLinkSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    merchant_id: z.string(),
    qb_list_id: z.string(),
    qb_unit: z.number(),
    product_id: z.string(),
    store_ids: z.array(z.string()),
    qb_item_number: z.string(),
    qb_department: z.string(),
    imported_at: z.string(),
  });

export const quickBooksProposalStatusSchema = z.union([
  z.literal('ready'),
  z.literal('imported'),
  z.literal('needs_mapping'),
  z.literal('rejected'),
]);

export const quickBooksProposedProductSchema = z.object({
  qb_unit: z.number(),
  unit_name: z.string(),
  quantity_in_unit_package: z.number(),
  price: z.number(),
  barcode: z.string(),
  barcodes: z.array(barcodeSchema),
  is_parent: z.boolean(),
  existing_product_id: z.string().nullish(),
  existing_product_name: z.string().nullish(),
  existing_in_store: z.boolean().nullish(),
});

export const quickBooksProposedFamilySchema = z.object({
  qb_list_id: z.string(),
  qb_item_number: z.string(),
  qb_item_type: z.string(),
  name: z.string(),
  description: z.string(),
  department: z.string(),
  tax_code: z.string(),
  tax_id: z.string().nullable(),
  vendor_name: z.string(),
  cost: z.number(),
  inventory: z.number(),
  low_stock_threshold: z.number(),
  allow_below_cost_sale: z.boolean(),
  parent: quickBooksProposedProductSchema,
  children: z.array(quickBooksProposedProductSchema),
  status: quickBooksProposalStatusSchema,
  reasons: z.array(z.string()),
  product_id: z.string().nullish(),
});

export const quickBooksExcludedItemSchema = z.object({
  qb_list_id: z.string(),
  name: z.string(),
});

export const quickBooksExcludedGroupSchema = z.object({
  item_type: z.string(),
  count: z.number(),
  items: z.array(quickBooksExcludedItemSchema),
});

export const quickBooksCatalogCountsSchema = z.object({
  total: z.number(),
  ready: z.number(),
  imported: z.number(),
  needs_mapping: z.number(),
  rejected: z.number(),
});

export const quickBooksCatalogPreviewSchema = z.object({
  store_id: z.string(),
  qb_store_id: z.string(),
  qb_store_name: z.string(),
  online: z.boolean(),
  items_synced_at: z.string().nullable(),
  families: z.array(quickBooksProposedFamilySchema),
  excluded: z.array(quickBooksExcludedGroupSchema),
  unmapped_tax_codes: z.array(z.string()),
  unmapped_units: z.array(z.string()),
  counts: quickBooksCatalogCountsSchema,
});

export const quickBooksCatalogPreviewStateSchema = z.union([
  z.literal('none'),
  z.literal('building'),
  z.literal('ready'),
  z.literal('failed'),
]);

export const quickBooksCatalogPreviewStatusSchema = z.object({
  status: quickBooksCatalogPreviewStateSchema,
  build_id: z.string().nullish(),
  requested_at: z.string().nullish(),
  built_at: z.string().nullish(),
  error: z.string().nullish(),
  preview: quickBooksCatalogPreviewSchema.nullish(),
});

export const quickBooksStoreOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  company_name: z.string(),
  online: z.boolean(),
  last_seen_at: z.string().nullable(),
  items_synced_at: z.string().nullable(),
  linked_store_id: z.string().nullable(),
});

export const requestQuickBooksConnectionSchema = z.object({
  requested_by: z.string(),
});

export const requestQuickBooksConnectionResponseSchema = z.object({
  connection: quickBooksConnectionSchema,
  code_sent: z.boolean(),
  resend_in_sec: z.number().nullish(),
  expires_in_min: z.number().nullish(),
});

export const verifyQuickBooksConnectionSchema = z.object({
  requested_by: z.string(),
  code: z.string(),
});

export const linkQuickBooksStoreSchema = z.object({
  requested_by: z.string(),
  qb_store_id: z.string(),
});

export const updateQuickBooksMappingsSchema = z.object({
  updated_by: z.string(),
  tax_codes: z.record(z.string()),
  units: z.record(z.string()),
});

export const quickBooksImportActionSchema = z.union([
  z.literal('create'),
  z.literal('link'),
  z.literal('skip'),
]);

export const quickBooksImportItemSchema = z.object({
  family: quickBooksProposedFamilySchema,
  action: quickBooksImportActionSchema,
});

export const createQuickBooksImportSchema = z.object({
  requested_by: z.string(),
  items: z.array(quickBooksImportItemSchema),
});

export const quickBooksImportStatusSchema = z.union([
  z.literal('queued'),
  z.literal('running'),
  z.literal('done'),
  z.literal('failed'),
]);

export const quickBooksImportErrorSchema = z.object({
  qb_list_id: z.string(),
  name: z.string(),
  message: z.string(),
});

export const quickBooksImportJobSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    status: quickBooksImportStatusSchema,
    total: z.number(),
    done: z.number(),
    failed: z.number(),
    skipped: z.number(),
    errors: z.array(quickBooksImportErrorSchema),
    requested_by_id: z.string(),
    requested_by_name: z.string(),
    started_at: z.string().nullish(),
    finished_at: z.string().nullish(),
    payload_key: z.string().nullish(),
    next_index: z.number(),
  });

export const quickBooksImportJobPageSchema = z.object({
  jobs: z.array(quickBooksImportJobSchema),
  cursor: z.string().nullish(),
});

export const quickBooksImportSQSMessageSchema = z.object({
  kind: z
    .union([z.literal('import'), z.literal('preview')])
    .nullish()
    .nullable(),
  job_id: z.string().nullish(),
  build_id: z.string().nullish(),
  merchant_id: z.string(),
  store_id: z.string(),
});

export const inventoryCountUnitLineSchema = z.object({
  product_id: z.string(),
  label: z.string(),
  quantity: z.number(),
  price: z.number(),
  cost: z.number(),
  stock: z.number(),
  stock_units: z.number(),
  is_duplicate: z.boolean(),
});

export const inventoryCountFamilySchema = z.object({
  family_id: z.string(),
  name: z.string(),
  image: z.string().nullish(),
  units: z.array(inventoryCountUnitLineSchema),
  consolidated_stock: z.number(),
  stock_value: z.number(),
});

export const inventoryCountReportSchema = z.object({
  families: z.array(inventoryCountFamilySchema),
  total_value: z.number(),
  family_count: z.number(),
});

export const inventoryCountPdfLanguageSchema = z.union([
  z.literal('en'),
  z.literal('pt'),
]);

export const inventoryTemplateStatusSchema = z.nativeEnum(
  InventoryTemplateStatus,
);

export const inventoryTemplateSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    creator_id: z.string(),
    creator_type: entityTypesSchema,
    counter_id: z.string(),
    counter_type: entityTypesSchema,
    status: inventoryTemplateStatusSchema,
    count_day: z.string(),
    id: z.string(),
    uncounted_items: z.array(z.string()),
    counted_items: z.array(z.string()),
    store_id: z.string(),
    title: z.string(),
    week_number: z.number(),
  });

export const createInventoryTemplateSchema = z.object({
  creator_id: z.string(),
  creator_type: entityTypesSchema,
  counter_id: z.string(),
  counter_type: entityTypesSchema,
  count_day: z.string(),
  uncounted_items: z.array(z.string()),
  store_id: z.string(),
  title: z.string(),
});

export const inventoryTemplatesPageSchema = paginatedSchema.extend({
  inventory_templates: z.array(inventoryTemplateSchema),
});

export const getInventoryTemplateSchema = z.object({
  store_id: z.string(),
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const updateInventoryTemplateSchema = z.object({
  store_id: z.string(),
  counter_id: z.string().nullish(),
  counter_type: entityTypesSchema.nullish(),
  id: z.string(),
  status: inventoryTemplateStatusSchema.nullish(),
  counted_items: z.array(z.string()).nullish(),
  uncounted_items: z.array(z.string()).nullish(),
  title: z.string().nullish(),
  count_day: z.string().nullish(),
});

export const deleteInventoryTemplateSchema = z.object({
  store_id: z.string(),
  id: z.string(),
});

export const getInventoryTemplatesSchema = z.object({
  by_count_day: z.boolean().nullish(),
  by_status: z.boolean().nullish(),
  by_counter: z.boolean().nullish(),
  by_year_and_week: z.boolean().nullish(),
  year: z.number().nullish(),
  week: z.number().nullish(),
  store_id: z.string().nullish(),
  counter_id: z.string().nullish(),
  status: inventoryTemplateStatusSchema.nullish(),
  count_day: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const inventoryTemplateDBItemSchema = inventoryTemplateSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const inventoryChangeReasonSchema = z.nativeEnum(InventoryChangeReason);

export const stockBucketSchema = z.nativeEnum(StockBucket);

export const stockOperationTypeSchema = z.nativeEnum(StockOperationType);

export const stockOperationReferenceSchema = z.object({
  stock_order_id: z.string().nullish(),
  transfer_id: z.string().nullish(),
  line_id: z.string().nullish(),
  purchase_order_id: z.string().nullish(),
  goods_receipt_id: z.string().nullish(),
});

export const applyStockOperationSchema = z.object({
  operation_id: z.string().trim().min(1).max(200),
  store_id: z.string(),
  product_id: z.string(),
  type: stockOperationTypeSchema,
  quantity: z.number().finite().positive(),
  from_bucket: stockBucketSchema.nullish(),
  to_bucket: stockBucketSchema.nullish(),
  reference: stockOperationReferenceSchema.nullish(),
  note: z.string().nullish(),
  occurred_at: z.string().nullish(),
  product_name: z.string().nullish(),
  reserved_quantity: z.number().finite().nonnegative().nullish(),
  unit_cost: z.number().finite().nonnegative().nullish(),
  carried_unit_cost: z.number().nullish(),
});

export const stockOperationCountersSchema = z.object({
  cumulative_quantity: z.number(),
  reserved_quantity: z.number(),
  pending_quantity: z.number(),
  blocked_quantity: z.number(),
  manual_reserved_quantity: z.number().nullish(),
});

export const inventoryValuationSchema = z.object({
  cost: z.number(),
  stock_version: z.number(),
  valued_at: z.string(),
  base_changed_at: z.string().nullish(),
});

export const manualStockReservationSchema = z.object({
  type: stockOperationTypeSchema,
  quantity: z.number().finite().positive(),
  note: z.string().trim().max(500).nullish(),
  release_any: z.boolean().nullish(),
});

export const stockOperationResultSchema = z.object({
  operation_id: z.string(),
  applied: z.boolean(),
  counters: stockOperationCountersSchema,
  unit_cost: z.number().nullish(),
});

export const countBasisSchema = z.nativeEnum(CountBasis);

export const reasonCountedSchema = z.nativeEnum(ReasonCounted);

export const inventoryChangeEventSchema = z.nativeEnum(InventoryChangeEvent);

export const fractionCountItemSchema = z.object({
  id: z.string(),
  unit: z.string(),
  fraction: z.number(),
  expectedStock: z.number(),
  qty_in_package: z.number(),
  is_sold_by_weight: z.boolean(),
  unit_of_measurement: z.string(),
});

export const supplierSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    contact: z.string().nullish(),
    email: z.string().nullish(),
    phone_number: z.string().nullish(),
    website: z.string().nullish(),
    address_1: z.string(),
    address_2: z.string().nullish(),
    city: z.string().nullish(),
    region: z.string().nullish(),
    postal_code: z.string().nullish(),
    country_code: z.string().nullish(),
    note: z.string().nullish(),
    merchant_id: z.string(),
  });

export const currentInventorySchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    store_id: z.string(),
    product_id: z.string(),
    cumulative_quantity: z.number(),
    merchant_id: z.string(),
    type: z.literal('CURRENT'),
    cost: z.number(),
    price: z.number(),
    inventory_value_change: z.number(),
    retail_value_change: z.number(),
    change_fraction: z.number(),
    change_quantity: z.number(),
    processed_at: z.string().nullish(),
    product_name: z.string().nullish(),
    reserved_quantity: z.number().nullish(),
    manual_reserved_quantity: z.number().nullish(),
    pending_quantity: z.number().nullish(),
    blocked_quantity: z.number().nullish(),
    valuation_cost: z.number().nullish(),
    valuation_at: z.string().nullish(),
    valuation_base_changed_at: z.string().nullish(),
  });

export const stockBreakdownSchema = z.object({
  on_hand: z.number(),
  reserved: z.number(),
  pending: z.number(),
  blocked: z.number(),
  manual_reserved: z.number().nullish(),
});

export const currentInventoryDBItemSchema = currentInventorySchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const sortOrderSchema = z.nativeEnum(SortOrder);

export const getInventoryChangesAppliedLateSchema = z.object({
  start_date: z.string(),
  applied_after: z.string(),
  applied_until: z.string(),
});

export const inventoryChangesAppliedLateSchema = z.object({
  store_id: z.string(),
  start_date: z.string(),
  applied_after: z.string(),
  applied_until: z.string(),
  count: z.number(),
  inventory_value_change: z.number(),
  retail_value_change: z.number(),
});

export const repairInventoryChangesProcessedIndexSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  dry_run: z.boolean().nullish(),
});

export const repairInventoryChangesProcessedIndexResultSchema = z.object({
  dry_run: z.boolean(),
  scanned: z.number(),
  missing: z.number(),
  written: z.number(),
  cursor: z.string().nullable(),
});

export const getStoreInventoriesSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
});

export const storeInventoriesResponseSchema = z.object({
  inventories: z.array(currentInventorySchema),
  count: z.number(),
});

export const invoiceStatusSchema = z.nativeEnum(InvoiceStatus);

export const paymentAttemptStatusSchema = z.nativeEnum(PaymentAttemptStatus);

export const billingRunStatusSchema = z.nativeEnum(BillingRunStatus);

export const billingTriggerTypeSchema = z.nativeEnum(BillingTriggerType);

export const invoiceCollectionMethodSchema = z.nativeEnum(
  InvoiceCollectionMethod,
);

export const invoiceLineSchema = z.object({
  label: z.string(),
  amount: z.number(),
  metadata: z.record(z.unknown()).nullish(),
});

export const pricingTypeSchema = z.nativeEnum(PricingType);

export const billingPeriodSchema = z.nativeEnum(BillingPeriod);

export const walletDebitResultForBillingSchema = z.object({
  balance: z.number(),
  transaction_id: z.string(),
  transaction_version: z.number(),
  reference_type: z.string(),
  reference_id: z.string(),
  amount: z.number(),
  currency: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  created_at: z.string(),
});

export const invoiceTypeSchema = z.nativeEnum(InvoiceType);

export const invoicePeriodLockDBItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  invoice_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  agreement_id: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  created_at: z.string(),
});

export const invoicePaymentAttemptSchema = z.object({
  id: z.string(),
  invoice_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  amount: z.number(),
  currency: z.string(),
  collection_method: invoiceCollectionMethodSchema,
  status: paymentAttemptStatusSchema,
  wallet_reference_type: z.string(),
  wallet_reference_id: z.string(),
  wallet_id: z.string().nullish(),
  payment_method_id: z.string().nullish(),
  payment_method_name: z.string().nullish(),
  payment_method_type: paymentMethodTypeSchema.nullish(),
  wallet_transaction_version: z.number().nullish(),
  wallet_balance_after: z.number().nullish(),
  error_code: z.string().nullish(),
  error_message: z.string().nullish(),
  attempted_at: z.string(),
  created_by: z.string().nullish(),
});

export const invoicePaymentAttemptDBItemSchema =
  invoicePaymentAttemptSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const billingRunErrorSchema = z.object({
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
  message: z.string(),
});

export const billingRunSchema = versionedSchema.extend({
  id: z.string(),
  trigger_type: billingTriggerTypeSchema,
  status: billingRunStatusSchema,
  period_start: z.string().nullish(),
  period_end: z.string().nullish(),
  merchant_ids: z.array(z.string()).nullish(),
  store_ids: z.array(z.string()).nullish(),
  total_merchants: z.number(),
  total_stores: z.number().nullish(),
  invoices_created: z.number(),
  invoices_paid: z.number(),
  invoices_partially_paid: z.number().nullish(),
  invoices_unpaid: z.number(),
  invoices_skipped: z.number(),
  errors_count: z.number(),
  errors: z.array(billingRunErrorSchema).nullish(),
  started_at: z.string(),
  completed_at: z.string().nullish(),
  created_by: z.string().nullish(),
});

export const billingRunDBItemSchema = billingRunSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const generateInvoiceSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  store_prefix: z.string().nullish(),
  credit_limit: z.number().nullish(),
  store_name: z.string().nullish(),
  due_date: z.string().nullish(),
  usage: z
    .object({
      receipts: z.number().nullish(),
      transactions: z.number().nullish(),
    })
    .nullish(),
  auto_collect: z.boolean().nullish(),
  created_by: z.string().nullish(),
  replaces_invoice_id: z.string().nullish(),
  notification_fee: z
    .object({
      amount: z.number(),
      service_month: z.string(),
      source_amount_usd: z.number().nullish(),
      exchange_rate: z.number().nullish(),
      exchange_rate_date: z.string().nullish(),
      exchange_rate_source: z.string().nullish(),
    })
    .nullish(),
});

export const generateInvoicesForMerchantSchema = z.object({
  merchant_id: z.string(),
  store_ids: z.array(z.string()).nullish(),
  auto_collect: z.boolean().nullish(),
  created_by: z.string().nullish(),
});

export const runBillingSchema = z.object({
  merchant_ids: z
    .union([z.array(z.string()), z.undefined()])
    .nullish()
    .nullable(),
  store_ids: z
    .union([z.array(z.string()), z.undefined()])
    .nullish()
    .nullable(),
  trigger_type: billingTriggerTypeSchema,
  created_by: z.union([z.string(), z.undefined()]).nullish(),
});

export const collectInvoiceSchema = z.object({
  invoice_id: z.string(),
  collected_by: z.union([z.string(), z.undefined()]).nullish(),
});

export const payOutstandingStoreInvoicesSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  collected_by: z.union([z.string(), z.undefined()]).nullish(),
});

export const retryInvoicePaymentSchema = z.object({
  invoice_id: z.string(),
  retried_by: z.string().nullish(),
});

export const cancelInvoiceSchema = z.object({
  invoice_id: z.string(),
  cancelled_by: z.string(),
  reason: z.string(),
});

export const getInvoiceSchema = z.object({
  id: z.string(),
});

export const getInvoicesSchema = z.object({
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
  status: invoiceStatusSchema.nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getInvoicePaymentAttemptsSchema = z.object({
  invoice_id: z.string(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getBillingRunSchema = z.object({
  id: z.string(),
});

export const getBillingRunsSchema = z.object({
  status: billingRunStatusSchema.nullish(),
  trigger_type: billingTriggerTypeSchema.nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const invoiceSummaryMonthSchema = z.object({
  month: z.string(),
  billed: z.number(),
  collected: z.number(),
});

export const invoiceArAgingBucketSchema = z.object({
  bucket: z.string(),
  amount: z.number(),
});

export const invoiceSummarySchema = z.object({
  currency: z.string(),
  monthly_revenue: z.array(invoiceSummaryMonthSchema),
  billed_trailing_30d: z.number(),
  collected_trailing_30d: z.number(),
  billed_trailing_12m: z.number(),
  mom_growth_pct: z.number().nullable(),
  collection_rate_pct_90d: z.number().nullable(),
  ar_outstanding: z.number(),
  ar_overdue: z.number(),
  ar_aging: z.array(invoiceArAgingBucketSchema),
  failed_invoice_count: z.number(),
  failed_invoice_amount: z.number(),
  invoice_count: z.number(),
  generated_at: z.string(),
});

export const invoicePaymentAttemptsPageSchema = z.object({
  attempts: z.array(invoicePaymentAttemptSchema),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const billingRunsPageSchema = z.object({
  runs: z.array(billingRunSchema),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const loanStatusSchema = z.nativeEnum(LoanStatus);

export const commonEmployeeAsCreatorAttributesSchema = z.object({
  creator_id: z.string(),
  creator_type: entityTypesSchema,
  creator_name: z.string(),
});

export const loanHistoryEventSchema = z.nativeEnum(LoanHistoryEvent);

export const getLoansByCreatorDtoSchema = paginatedSchema.extend({
  creator_id: z.string(),
  by_creator_id: z.boolean().nullish(),
  is_borrower_loan: z.boolean().nullish(),
});

export const getLoansByBorrowerIdDtoSchema = paginatedSchema.extend({
  borrower_id: z.string(),
  by_borrower_id: z.boolean().nullish(),
  is_borrower_loan: z.boolean().nullish(),
});

export const getLoanByLoanIdDtoSchema = z.object({
  loan_id: z.string(),
  by_loan_id: z.boolean().nullish(),
  by_borrower_loan_id: z.boolean().nullish(),
  borrower_loan_id: z.string().nullish(),
});

export const getLoansByStatusesDtoSchema = paginatedSchema.extend({
  statuses: z.array(loanStatusSchema),
  by_statuses: z.boolean().nullish(),
  by_borrower_id_and_status: z.boolean().nullish(),
  by_statuses_and_borrower_loan_id: z.boolean().nullish(),
  is_borrower_loan: z.boolean().nullish(),
  borrower_id: z.string().nullish(),
  borrower_loan_id: z.string().nullish(),
  borrower_type: entityTypesSchema.nullish(),
});

export const createLoanDtoSchema =
  commonEmployeeAsCreatorAttributesSchema.extend({
    borrower_id: z.string(),
    borrower_type: entityTypesSchema,
    total_amount: z.number(),
    reason: z.string(),
  });

export const createLoanAfterFailureDtoSchema = z.object({
  creator: commonEmployeeAsCreatorAttributesSchema,
  borrower_id: z.string(),
  borrower_type: entityTypesSchema,
  total_amount: z.number(),
  reason: z.string(),
  previousEventId: z.string(),
});

export const updateLoanDtoSchema = z.object({
  borrower_id: z.string(),
  borrower_type: entityTypesSchema,
  status: loanStatusSchema,
});

export const uiLanguageSchema = z.nativeEnum(UiLanguage);

export const moduleStatusSchema = z.nativeEnum(ModuleStatus);

export const ordersTransfersModuleSchema = z.object({
  status: moduleStatusSchema,
  status_changed_at: z.string().nullish(),
  price_approval_required: z.boolean().nullish(),
  order_expiry_days: z.number().nullish(),
});

export const setOrdersTransfersModuleStatusSchema = z.object({
  status: moduleStatusSchema,
});

export const updateOrdersTransfersSettingsSchema = z.object({
  price_approval_required: z.boolean().nullish(),
  order_expiry_days: z.number().nullish(),
});

export const drainOpenItemSchema = z.object({
  source: z.string(),
  description: z.string(),
  count: z.number(),
});

export const drainStatusSchema = z.object({
  merchant_id: z.string(),
  is_drained: z.boolean(),
  open_items: z.array(drainOpenItemSchema),
  checked_at: z.string(),
});

export const createMerchantSchema = z.object({
  business_name: z.string(),
  email: z.string(),
  country: z.string(),
  currency: currencySchema,
  phone_number: z.string(),
  address: z.string(),
  contact_person: z.string(),
  stores: z.array(z.string()),
});

export const updateMerchantSchema = z.object({
  business_name: z.string().nullish(),
  email: z.string().nullish(),
  country: z.string().nullish(),
  currency: currencySchema.nullish(),
  phone_number: z.string().nullish(),
  address: z.string().nullish(),
  contact_person: z.string().nullish(),
  id: z.string(),
  add_stores: z.array(z.string()).nullish(),
  remove_stores: z.array(z.string()).nullish(),
  monthly_fee: z.number().nullish(),
});

export const merchantPaymentStatusSchema = z.nativeEnum(MerchantPaymentStatus);

export const monthSchema = z.any();

export const createMerchantPaymentSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  amount_paid: z.number(),
  payment_month: monthSchema,
  payer_name: z.string(),
  payer_phone_number: z.union([z.string(), z.number()]),
  payment_type: paymentMethodTypeSchema,
  note: z.string().nullish(),
  receiver_name: z.string(),
});

export const getAllMerchantPaymentsSchema = z.object({
  by_merchant: z.boolean().nullish(),
  by_date: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  month: monthSchema.nullish(),
});

export const notificationEventsSchema = z.nativeEnum(NotificationEvents);

export const iftttSmsReceivedEventDataSchema = z.object({
  id: z.string(),
  sender: z.string(),
  sender_name: z.string().nullish(),
  message_content: z.string().nullish(),
  received_at: z.string().nullish(),
  device_name: z.string().nullish(),
  created_at: z.string(),
});

export const emailCharsetSchema = z.nativeEnum(EmailCharset);

export const getWhatsappEventsSchema = z.object({
  phone_number_id: z.string().nullish(),
  event_type: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  count: z.coerce.number().int().min(1).max(100).nullish(),
});

export const whatsappWebhookChangeSchema = z.object({
  field: z.string(),
  value: z.record(z.unknown()),
});

export const iftttSmsWebhookPayloadSchema = z.record(z.unknown());

export const iftttSmsMessageSchema = z.object({
  id: z.string().nullish(),
  sender: z.string(),
  sender_name: z.string().nullish(),
  message_content: z.string().nullish(),
  received_at: z.string().nullish(),
  device_name: z.string().nullish(),
  raw_body: z.string(),
  payload: z.record(z.unknown()).nullish(),
  created_at: z.string(),
});

export const getIftttSmsMessagesSchema = z.object({
  sender: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  count: z.coerce.number().int().min(1).max(100).nullish(),
});

export const iftttSmsMessagesPageSchema = z.object({
  messages: z.array(iftttSmsMessageSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const notificationRequestTypeSchema = z.nativeEnum(
  NotificationRequestType,
);

export const notificationTriggerSchema = z.nativeEnum(NotificationTrigger);

export const notificationRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  type: notificationRequestTypeSchema,
  trigger: notificationTriggerSchema,
  event_id: z.string().nullish(),
  period_key: z.string().nullish(),
  payload: z.record(z.unknown()),
  recipient_employee_ids: z.array(z.string()).nullish(),
});

export const notificationKindSchema = z.nativeEnum(NotificationKind);

export const notificationStatusSchema = z.nativeEnum(NotificationStatus);

export const notificationMediaSchema = z.object({
  jpeg_url: z.string(),
  pdf_url: z.string(),
  jpeg_key: z.string(),
  pdf_key: z.string(),
});

export const notificationRecipientSchema = z.object({
  message_id: z.string(),
  recipient_id: z.string(),
  kind: notificationKindSchema,
  entity_id: z.string(),
  phone_number: z.string(),
  status: notificationStatusSchema,
  whatsapp_message_id: z.string().nullish(),
  wa_id_invalid: z.boolean().nullish(),
  created_at: z.string(),
});

export const notificationRecipientDBItemSchema =
  notificationRecipientSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const notificationDedupeMarkerSchema = z.object({
  dedupe_key: z.string(),
  created_at: z.string(),
});

export const notificationDedupeMarkerDBItemSchema =
  notificationDedupeMarkerSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
    ttl: z.number().nullish(),
    lease_until: z.string().nullish(),
  });

export const notificationSubscriptionSchema = versionedSchema.extend({
  store_id: z.string(),
  type: notificationRequestTypeSchema,
  enabled: z.boolean().nullish(),
  language: languageSchema.nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const notificationSubscriptionDBItemSchema =
  notificationSubscriptionSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const notificationSubscriberSchema = z.object({
  store_id: z.string(),
  type: notificationRequestTypeSchema,
  user_id: z.string(),
  kind: z
    .union([
      z.literal(NotificationKind.EMPLOYEE),
      z.literal(NotificationKind.INDEPENDENT),
    ])
    .nullish(),
  subscribed_at: z.string(),
});

export const notificationSubscriberDBItemSchema =
  notificationSubscriberSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const sendNotificationTaskSchema = z.object({
  message_id: z.string(),
  recipient_id: z.string(),
  kind: notificationKindSchema,
  entity_id: z.string(),
  phone_number: z.string(),
  type: notificationRequestTypeSchema,
  language: languageSchema,
  merchant_id: z.string(),
  store_id: z.string(),
  payload: z.record(z.unknown()),
  currency: currencySchema.nullish(),
  timezone: z.string().nullish(),
  notification_created_at: z.string(),
});

export const notificationScheduleFrequencySchema = z.nativeEnum(
  NotificationScheduleFrequency,
);

export const notificationScheduleSchema = versionedSchema.extend({
  store_id: z.string(),
  type: notificationRequestTypeSchema,
  frequency: notificationScheduleFrequencySchema,
  time_min: z.number(),
  weekday: z.number().nullish(),
  month_day: z.number().nullish(),
  timezone: z.string(),
  enabled: z.boolean(),
  schedule_name: z.string().nullish(),
  last_run_at: z.string().nullish(),
  last_period_key: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const notificationScheduleDBItemSchema =
  notificationScheduleSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const notificationScheduleInputSchema = z.object({
  frequency: notificationScheduleFrequencySchema,
  time_min: z.number(),
  weekday: z.number().nullish(),
  month_day: z.number().nullish(),
});

export const updateNotificationSettingsSchema = z.object({
  enabled: z.boolean(),
  subscriber_ids: z.array(z.string()),
  contact_ids: z.array(z.string()).nullish(),
  language: languageSchema.nullish(),
  schedule: notificationScheduleInputSchema.nullish(),
});

export const notificationTypeSettingsSchema = z.object({
  type: notificationRequestTypeSchema,
  enabled: z.boolean(),
  language: languageSchema.nullish(),
  subscribers: z.array(notificationSubscriberSchema),
  schedulable: z.boolean(),
  event_driven: z.boolean(),
  schedule: notificationScheduleSchema.nullish(),
  next_runs: z.array(z.string()),
});

export const notificationBillingStatusSchema = z.object({
  blocked: z.boolean(),
  reason: z.literal('OVERDUE_NOTIFICATION_INVOICE').nullish(),
  overdue_invoice_id: z.string().nullish(),
  overdue_invoice_number: z.string().nullish(),
  due_date: z.string().nullish(),
});

export const notificationContactSchema = versionedSchema.extend({
  id: z.string(),
  merchant_id: z.string(),
  name: z.string(),
  phone_number: z.string(),
  is_number_verified: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const notificationContactDBItemSchema = notificationContactSchema.extend(
  {
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  },
);

export const notificationContactsResponseSchema = z.object({
  contacts: z.array(notificationContactSchema),
});

export const createNotificationContactSchema = z.object({
  name: z.string(),
  phone_number: z.string(),
});

export const updateNotificationContactSchema = z.object({
  name: z.string(),
  phone_number: z.string(),
});

export const sendNotificationContactVerificationResponseSchema = z.object({
  expires_at: z.string(),
});

export const verifyNotificationContactSchema = z.object({
  code: z.string(),
});

export const notificationContactVerificationSchema = z.object({
  merchant_id: z.string(),
  contact_id: z.string(),
  challenge_id: z.string().nullish(),
  phone_number: z.string().nullish(),
  code_hash: z.string(),
  expires_at: z.string(),
  attempts: z.number(),
  created_at: z.string(),
  ttl: z.number(),
});

export const notificationUsageSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  month: z.string(),
  activated_at: z.string(),
});

export const notificationUsageDBItemSchema = notificationUsageSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const getNotificationsHistorySchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  type: notificationRequestTypeSchema.nullish(),
  from: z.string().nullish(),
  to: z.string().nullish(),
  cursor: z.string().nullish(),
  count: z.coerce.number().int().min(1).max(100).nullish(),
});

export const resendNotificationRecipientSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  message_id: z.string(),
  recipient_id: z.string(),
});

export const resendNotificationRecipientResponseSchema = z.object({
  message: z.string(),
  message_id: z.string(),
  recipient_id: z.string(),
});

export const scheduledNotificationInvocationSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  type: notificationRequestTypeSchema,
});

export const notificationMoneyLineSchema = z.object({
  name: z.string(),
  amount: z.number(),
});

export const notificationPaymentMethodBreakdownSchema = z.object({
  name: z.string(),
  sales: z.number(),
  refunds: z.number(),
  net: z.number(),
});

export const businessSummaryPayloadSchema = z.object({
  period_label: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  gross_sales: z.number(),
  refunds: z.number(),
  discounts: z.number(),
  net_sales: z.number(),
  cost_of_goods: z.number(),
  gross_profit: z.number(),
  expenses: z.number(),
  net_profit: z.number(),
  by_payment_method: z.array(notificationPaymentMethodBreakdownSchema),
  by_employee: z.array(notificationMoneyLineSchema),
});

export const shiftCountLineSchema = z.object({
  name: z.string(),
  payment_type: paymentMethodTypeSchema,
  expected: z.number(),
  counted: z.number(),
  difference: z.number(),
});

export const shiftReportPayloadSchema = z.object({
  shift_id: z.string(),
  opened_by: z.string(),
  opened_at: z.string(),
  closed_by: z.string(),
  closed_at: z.string(),
  duration_minutes: z.number(),
  gross_sales: z.number(),
  refunds: z.number(),
  discounts: z.number(),
  net_sales: z.number(),
  payment_methods: z.array(notificationMoneyLineSchema),
  counts: z.array(shiftCountLineSchema),
  total_difference: z.number(),
  closing_note: z.string().nullish(),
});

export const lowStockItemSchema = z.object({
  product_id: z.string(),
  name: z.string(),
  in_stock: z.number(),
  threshold: z.number(),
});

export const lowStockPayloadSchema = z.object({
  period_label: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  items: z.array(lowStockItemSchema),
  total_below_threshold: z.number(),
});

export const expiringProductItemSchema = z.object({
  product_id: z.string(),
  name: z.string(),
  po_id: z.string(),
  expiry_date: z.string(),
  days_left: z.number(),
  quantity: z.number(),
  in_stock: z.number(),
});

export const expiringProductsPayloadSchema = z.object({
  period_label: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  items: z.array(expiringProductItemSchema),
  total_expiring: z.number(),
});

export const inventoryCountDifferenceItemSchema = z.object({
  product_id: z.string(),
  name: z.string(),
  quantity_change: z.number(),
  quantity_label: z.string().nullish(),
  value_change: z.number(),
});

export const inventoryCountSummaryPayloadSchema = z.object({
  period_label: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  report_date: z.string(),
  counted_by: z.array(z.string()),
  items_with_changes: z.number(),
  total_difference_value: z.number(),
  largest_negative: z.array(inventoryCountDifferenceItemSchema),
  largest_positive: z.array(inventoryCountDifferenceItemSchema),
  net_difference_value: z.number(),
});

export const priceChangeItemSchema = z.object({
  product_id: z.string(),
  name: z.string(),
  old_price: z.number(),
  new_price: z.number(),
  changed_by: z.string().nullish(),
  changed_at: z.string().nullish(),
});

export const priceChangesPayloadSchema = z.object({
  date_label: z.string().nullish(),
  changed_by: z.string().nullish(),
  changes: z.array(priceChangeItemSchema),
});

export const purchaseOrderNotificationEventSchema = z.nativeEnum(
  PurchaseOrderNotificationEvent,
);

export const purchaseOrderNotificationItemSchema = z.object({
  name: z.string(),
  quantity: z.number(),
  cost: z.number(),
  total: z.number(),
});

export const purchaseOrderChangesPayloadSchema = z.object({
  po_id: z.string(),
  event: purchaseOrderNotificationEventSchema,
  ordered_by: z.string(),
  supplier_name: z.string(),
  purchase_date: z.string(),
  items: z.array(purchaseOrderNotificationItemSchema),
  total_cost: z.number(),
  paid: z.number(),
  amount_due: z.number(),
  status: z.string(),
  note: z.string().nullish(),
});

export const receiptNotificationDiscountSchema = z.object({
  name: z.string(),
  amount: z.number(),
});

export const receiptNotificationLineItemSchema = z.object({
  name: z.string(),
  quantity: z.number(),
  price: z.number(),
  total: z.number(),
  is_sold_by_weight: z.boolean().nullish(),
  note: z.string().nullish(),
  discounts: z.array(receiptNotificationDiscountSchema).nullish(),
});

export const receiptNotificationTaxSchema = z.object({
  name: z.string(),
  amount: z.number(),
  type: z.union([z.literal('INCLUDED'), z.literal('ADDED')]),
});

export const receiptNotificationPaymentSchema = z.object({
  name: z.string(),
  payment_type: paymentMethodTypeSchema,
  amount: z.number(),
  total_given: z.number().nullish(),
  change: z.number().nullish(),
});

export const receiptNotificationDebtSchema = z.object({
  starting: z.number(),
  refunded: z.number(),
  borrowed: z.number(),
  ending: z.number(),
  due_date: z.string().nullish(),
});

export const receiptNotificationPointsSchema = z.object({
  earned: z.number(),
  deducted: z.number(),
  balance: z.number(),
});

export const receiptPayloadSchema = z.object({
  receipt_number: z.string(),
  custom_receipt_number: z.string(),
  receipt_type: z.union([z.literal('SALE'), z.literal('REFUND')]),
  created_at: z.string(),
  customer_id: z.string().nullish(),
  customer_name: z.string().nullish(),
  employee_name: z.string(),
  pos_device_name: z.string(),
  refund_for: z.string().nullish(),
  associated_refunds: z.array(z.string()).nullish(),
  line_items: z.array(receiptNotificationLineItemSchema),
  subtotal: z.number(),
  total_discount: z.number(),
  tip: z.number(),
  surcharge: z.number(),
  total: z.number(),
  taxes: z.array(receiptNotificationTaxSchema),
  payments: z.array(receiptNotificationPaymentSchema),
  debt: receiptNotificationDebtSchema.nullish(),
  points: receiptNotificationPointsSchema.nullish(),
});

export const debtNotificationEventSchema = z.nativeEnum(DebtNotificationEvent);

export const debtNotificationItemSchema = z.object({
  name: z.string(),
  quantity: z.number(),
  price: z.number(),
  total: z.number(),
});

export const debtsPayloadSchema = z.object({
  event: debtNotificationEventSchema,
  debt_id: z.string(),
  customer_id: z.string().nullish(),
  customer_name: z.string(),
  employee_name: z.string(),
  receipt_number: z.string().nullish(),
  date: z.string(),
  items: z.array(debtNotificationItemSchema).nullish(),
  purchase_total: z.number().nullish(),
  paid_today: z.number().nullish(),
  new_debt: z.number().nullish(),
  payment_amount: z.number().nullish(),
  payment_method: z.string().nullish(),
  previous_balance: z.number(),
  total_outstanding: z.number(),
  due_date: z.string().nullish(),
});

export const debtReminderTierSchema = z.nativeEnum(DebtReminderTier);

export const debtPaymentReminderPayloadSchema = z.object({
  tier: debtReminderTierSchema,
  debt_id: z.string(),
  customer_id: z.string().nullish(),
  customer_name: z.string(),
  due_date: z.string(),
  days_remaining: z.number().nullish(),
  days_overdue: z.number().nullish(),
  outstanding_balance: z.number(),
  supplier_contact: z.string().nullish(),
});

export const expensePayloadSchema = z.object({
  transaction_id: z.string(),
  recorded_by: z.string(),
  date: z.string(),
  shift_id: z.string().nullish(),
  amount: z.number(),
  paid_from: z.string(),
  comments: z.string().nullish(),
});

export const inventoryUpdateFailedPayloadSchema = z.object({
  product_id: z.string(),
  product_name: z.string(),
  reason: z.string(),
  quantity: z.number(),
  actor_name: z.string(),
  occurred_at: z.string(),
  failed_at: z.string(),
  source: z.string().nullish(),
  error: z.string(),
  status_code: z.number().nullish(),
});

export const availableMoneyAccountSchema = z.object({
  owner_name: z.string(),
  balances: z.array(notificationMoneyLineSchema),
});

export const availableMoneyPayloadSchema = z.object({
  snapshot_at: z.string(),
  snapshot_label: z.string(),
  accounts: z.array(availableMoneyAccountSchema),
  totals: z.array(notificationMoneyLineSchema),
});

export const invoicePayloadSchema = z.object({
  invoice_id: z.string(),
  invoice_number: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  due_date: z.string(),
  subscription_fee: z.number(),
  discounts: z.number(),
  total: z.number(),
  amount_due: z.number(),
  status: z.string(),
  currency: z.string().nullish(),
  top_up_amount: z.number().nullish(),
});

export const taskAssignedPayloadSchema = z.object({
  task_id: z.string(),
  title: z.string(),
  description: z.string().nullish(),
  has_audio: z.boolean().nullish(),
  attachment_count: z.number().nullish(),
  due_at: z.string().nullish(),
  created_by: z.string(),
  assigned_to: z.string(),
  created_at: z.string(),
});

export const topupPayloadSchema = z.object({
  transaction_id: z.string(),
  operator: z.string(),
  sender: z.string(),
  receiver_number: z.string(),
  amount: z.number(),
  status: z.string(),
  claimed_by: z.string().nullish(),
  wallet_credited: z.string().nullish(),
  date: z.string(),
});

/**
 * Observability helpers, maintained in postProcessZod.js.
 *
 * Every partition key on the backend is sliced out of `occurred_at`, and the
 * readers rebuild those keys from UTC ISO strings, so any timestamp the device
 * sends is normalised to UTC ISO here. An unparsable value falls back to the
 * ingest time rather than rejecting telemetry from an old build.
 */
const observabilityIsoTimestamp = z.string().transform((value) => {
  const parsed = Date.parse(value);
  return Number.isNaN(parsed)
    ? new Date().toISOString()
    : new Date(parsed).toISOString();
});

/** Truncate rather than reject: half a stack trace beats a 400. */
const observabilityBoundedString = (max: number) =>
  z
    .string()
    .transform((value) =>
      value.length > max
        ? `${value.slice(0, max)}…[truncated ${value.length - max}]`
        : value,
    );

/**
 * API Gateway hands query strings over as strings, and `z.coerce.boolean()`
 * would turn the literal "false" into true. Only the two literals count.
 */
const observabilityQueryBoolean = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .transform((value) => value === true || value === 'true');

export const observabilityLevelSchema = z.union([
  z.literal('trace'),
  z.literal('debug'),
  z.literal('info'),
  z.literal('warning'),
  z.literal('error'),
  z.literal('fatal'),
]);

export const observabilityFeedLevelSchema = z.union([
  observabilityLevelSchema,
  z.literal('all'),
]);

export const observabilityKindSchema = z.union([
  z.literal('log'),
  z.literal('error'),
  z.literal('action'),
  z.literal('navigation'),
  z.literal('network'),
  z.literal('database'),
  z.literal('sync'),
  z.literal('print'),
  z.literal('device'),
  z.literal('business'),
  z.literal('lifecycle'),
  z.literal('trace'),
]);

export const observabilityPayloadLocationSchema = z.union([
  z.literal('inline'),
  z.literal('s3'),
  z.literal('dropped'),
]);

export const observabilityCompressionSchema = z.union([
  z.literal('gzip'),
  z.literal('none'),
]);

export const observabilityContextSchema = z.object({
  merchant_id: z.string().min(1),
  store_id: z.string().optional(),
  pos_device_id: z.string().min(1),
  pos_device_name: z.string().optional(),
  fingerprint: z.string().optional(),
  user_id: z.string().optional(),
  user_name: z.string().optional(),
  session_id: z.string().min(1),
  app_version: z.string().optional(),
  build_number: z.string().optional(),
  platform: z.string().optional(),
  os_version: z.string().optional(),
  device_model: z.string().optional(),
  stage: z.string().optional(),
  locale: z.string().optional(),
});

export const observabilityEventInputSchema = z.object({
  id: z.string(),
  seq: z.number(),
  kind: observabilityKindSchema,
  level: observabilityLevelSchema,
  name: observabilityBoundedString(200),
  message: observabilityBoundedString(20_000).optional(),
  occurred_at: observabilityIsoTimestamp,
  trace_id: z.string().optional(),
  parent_id: z.string().optional(),
  duration_ms: z.number().optional(),
  ok: z.boolean().optional(),
  error_type: observabilityBoundedString(200).optional(),
  stack_trace: observabilityBoundedString(20_000).optional(),
  attributes: z
    .record(z.union([z.boolean(), z.number(), z.string()]).nullable())
    .optional(),
  payload: observabilityBoundedString(5_000_000).optional(),
  screen: z.string().optional(),
  signal: z.boolean().optional(),
});

export const observabilityIngestBatchSchema = z.object({
  batch_id: z.string().min(1),
  context: observabilityContextSchema,
  events: z.array(observabilityEventInputSchema),
  created_at: observabilityIsoTimestamp,
  dropped_count: z.number().optional(),
  schema_version: z.number(),
});

export const observabilityIngestRequestSchema = z.object({
  batch_id: z.string().min(1),
  context: observabilityContextSchema,
  created_at: observabilityIsoTimestamp,
  dropped_count: z.number().optional(),
  schema_version: z.number(),
  events: z.array(observabilityEventInputSchema).optional(),
  events_gz: z.string().max(8 * 1024 * 1024).optional(),
}).refine(
  (body) => body.events !== undefined || body.events_gz !== undefined,
  { message: 'events or events_gz is required' },
);

export const observabilityIngestResponseSchema = z.object({
  batch_id: z.string(),
  received: z.number(),
  signals: z.number(),
  duplicate: z.boolean(),
});

export const observabilityEventSchema = z.object({
  id: z.string(),
  batch_id: z.string(),
  seq: z.number(),
  kind: observabilityKindSchema,
  level: observabilityLevelSchema,
  name: z.string(),
  message: z.string().optional(),
  occurred_at: z.string(),
  received_at: z.string(),
  trace_id: z.string().optional(),
  parent_id: z.string().optional(),
  duration_ms: z.number().optional(),
  ok: z.boolean().optional(),
  error_type: z.string().optional(),
  stack_trace: z.string().optional(),
  attributes: z
    .record(z.union([z.string(), z.number(), z.boolean()]).nullable())
    .optional(),
  screen: z.string().optional(),
  merchant_id: z.string(),
  store_id: z.string().optional(),
  pos_device_id: z.string(),
  pos_device_name: z.string().optional(),
  fingerprint: z.string().optional(),
  user_id: z.string().optional(),
  user_name: z.string().optional(),
  session_id: z.string(),
  app_version: z.string().optional(),
  build_number: z.string().optional(),
  platform: z.string().optional(),
  os_version: z.string().optional(),
  device_model: z.string().optional(),
  stage: z.string().optional(),
  payload_bytes: z.number().optional(),
  payload_location: observabilityPayloadLocationSchema.optional(),
  payload: z.string().optional(),
});

export const observabilityBatchSchema = z.object({
  batch_id: z.string(),
  created_at: z.string(),
  received_at: z.string(),
  event_count: z.number(),
  dropped_count: z.number(),
  signal_count: z.number(),
  first_seq: z.number(),
  last_seq: z.number(),
  compressed_bytes: z.number(),
  payload_location: observabilityPayloadLocationSchema,
  context: observabilityContextSchema,
  events: z.array(observabilityEventInputSchema).optional(),
});

export const observabilityEventsPageSchema = z.object({
  events: z.array(observabilityEventSchema),
  count: z.number(),
  cursor: z.string().optional(),
});

export const observabilityBatchesPageSchema = z.object({
  batches: z.array(observabilityBatchSchema),
  count: z.number(),
  cursor: z.string().optional(),
});

export const observabilityListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).optional(),
  cursor: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  descending: observabilityQueryBoolean.optional(),
});

export const listObservabilityByDeviceSchema =
  observabilityListQuerySchema.extend({
    pos_device_id: z.string(),
    entity: z.union([z.literal('events'), z.literal('batches')]).optional(),
  });

export const listObservabilityBySessionSchema =
  observabilityListQuerySchema.extend({
    session_id: z.string(),
  });

export const listObservabilityByTraceSchema = z.object({
  trace_id: z.string(),
  limit: z.coerce.number().int().min(1).max(200).optional(),
  cursor: z.string().optional(),
});

export const listObservabilityByLevelSchema =
  observabilityListQuerySchema.extend({
    level: observabilityFeedLevelSchema,
    hours: z.coerce.number().int().min(1).max(2160).optional(),
  });

export const listObservabilityByMerchantSchema =
  observabilityListQuerySchema.extend({
    merchant_id: z.string(),
    date: z.string().optional(),
    days: z.coerce.number().int().min(1).max(31).optional(),
  });

export const getObservabilityEventSchema = z.object({
  pos_device_id: z.string(),
  id: z.string(),
  occurred_at: z.string(),
});

export const getObservabilityBatchSchema = z.object({
  pos_device_id: z.string(),
  batch_id: z.string(),
  created_at: z.string(),
});

export const listObservabilityIssuesSchema = z.object({
  level: observabilityFeedLevelSchema.optional(),
  hours: z.coerce.number().int().min(1).max(2160).optional(),
  merchant_id: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

export const observabilityIssueSchema = z.object({
  fingerprint: z.string(),
  kind: observabilityKindSchema,
  level: observabilityLevelSchema,
  title: z.string(),
  count: z.number(),
  first_seen: z.string(),
  last_seen: z.string(),
  affected_devices: z.number(),
  affected_users: z.number(),
  sample_event_id: z.string(),
  sample_pos_device_id: z.string(),
});

export const observabilityIssuesPageSchema = z.object({
  issues: z.array(observabilityIssueSchema),
  count: z.number(),
  from: z.string(),
  to: z.string(),
  truncated: z.boolean(),
});

export const listObservabilityBackendMetricsSchema = z.object({
  hours: z.coerce.number().int().min(1).max(2160).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  cursor: z.string().optional(),
});

export const observabilityMetricPointSchema = z.object({
  service: z.string(),
  function_name: z.string(),
  name: z.string(),
  unit: z.string(),
  kind: z.union([z.literal('sum'), z.literal('histogram')]),
  window_start: z.string(),
  window_end: z.string(),
  sum: z.number(),
  count: z.number().optional(),
  min: z.number().optional(),
  max: z.number().optional(),
  bounds: z.array(z.number()).optional(),
  bucket_counts: z.array(z.number()).optional(),
  attributes: z
    .record(z.union([z.string(), z.number(), z.boolean()]))
    .optional(),
});

export const observabilityFunctionMetricsSchema = z.object({
  service: z.string(),
  function_name: z.string(),
  invocations: z.number(),
  errors: z.number(),
  timeouts: z.number(),
  cold_starts: z.number(),
  duration_avg_ms: z.number().optional(),
  duration_max_ms: z.number().optional(),
  duration_p95_ms: z.number().optional(),
  init_duration_avg_ms: z.number().optional(),
  billed_ms: z.number(),
  max_memory_used_mb: z.number().optional(),
  duration_bounds: z.array(z.number()).optional(),
  duration_bucket_counts: z.array(z.number()).optional(),
  last_seen: z.string(),
});

export const observabilityBackendTimeseriesPointSchema = z.object({
  bucket: z.string(),
  service: z.string(),
  function_name: z.string(),
  invocations: z.number(),
  errors: z.number(),
  timeouts: z.number(),
  cold_starts: z.number(),
  duration_avg_ms: z.number().optional(),
  duration_p95_ms: z.number().optional(),
  duration_max_ms: z.number().optional(),
  billed_ms: z.number(),
  duration_count: z.number().optional(),
  duration_sum_ms: z.number().optional(),
  duration_bounds: z.array(z.number()).optional(),
  duration_bucket_counts: z.array(z.number()).optional(),
  init_count: z.number().optional(),
  init_sum_ms: z.number().optional(),
  max_memory_used_mb: z.number().optional(),
  last_seen: z.string().optional(),
});

export const observabilityBackendCustomTimeseriesPointSchema = z.object({
  bucket: z.string(),
  service: z.string().optional(),
  function_name: z.string(),
  name: z.string(),
  unit: z.string(),
  kind: z.union([z.literal('sum'), z.literal('histogram')]),
  sum: z.number(),
  count: z.number(),
  min: z.number().optional(),
  max: z.number().optional(),
  attributes: z
    .record(z.union([z.string(), z.number(), z.boolean()]))
    .optional(),
});

export const observabilityBackendTimeseriesPageSchema = z.object({
  from: z.string(),
  to: z.string(),
  buckets: z.array(z.string()),
  points: z.array(observabilityBackendTimeseriesPointSchema),
  custom: z.array(observabilityBackendCustomTimeseriesPointSchema),
  cursor: z.string().optional(),
  total_buckets: z.number().optional(),
});

export const observabilityCustomMetricSchema = z.object({
  service: z.string(),
  function_name: z.string(),
  name: z.string(),
  unit: z.string(),
  kind: z.union([z.literal('sum'), z.literal('histogram')]),
  sum: z.number(),
  count: z.number(),
  min: z.number().optional(),
  max: z.number().optional(),
  attributes: z
    .record(z.union([z.string(), z.number(), z.boolean()]))
    .optional(),
});

export const observabilityBackendMetricsPageSchema = z.object({
  from: z.string(),
  to: z.string(),
  functions: z.array(observabilityFunctionMetricsSchema),
  custom: z.array(observabilityCustomMetricSchema),
  partial: z.boolean().optional(),
});

export const observabilityMetricDBItemSchema =
  observabilityMetricPointSchema.extend({
    PK: z.string(),
    SK: z.string(),
    ttl: z.number(),
  });

export const lambdaInvocationStatusSchema = z.union([
  z.literal('success'),
  z.literal('error'),
  z.literal('failure'),
  z.literal('timeout'),
]);

export const lambdaLogLineSchema = z.object({
  time: z.string(),
  level: observabilityLevelSchema.nullish(),
  message: z.string(),
});

export const lambdaInvocationSchema = z.object({
  request_id: z.string(),
  service: z.string(),
  function_name: z.string(),
  started_at: z.string(),
  ended_at: z.string().nullish(),
  status: lambdaInvocationStatusSchema,
  ok: z.boolean(),
  duration_ms: z.number().nullish(),
  billed_ms: z.number().nullish(),
  max_memory_used_mb: z.number().nullish(),
  memory_size_mb: z.number().nullish(),
  cold_start: z.boolean().nullish(),
  init_duration_ms: z.number().nullish(),
  error_type: z.string().nullish(),
  error_message: z.string().nullish(),
  trace_id: z.string().nullish(),
  line_count: z.number(),
  error_line_count: z.number(),
  dropped_lines: z.number().nullish(),
  stage: z.string().nullish(),
});

export const lambdaInvocationsPageSchema = z.object({
  invocations: z.array(lambdaInvocationSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const listLambdaInvocationsSchema = z.object({
  function_name: z.string().min(1),
  from: z.string().nullish(),
  to: z.string().nullish(),
  status: z.union([z.literal('all'), z.literal('errors')]).nullish(),
  limit: z.coerce.number().int().min(1).max(200).nullish(),
  cursor: z.string().nullish(),
});

export const lambdaInvocationLogsSchema = z.object({
  invocation: lambdaInvocationSchema.nullish(),
  lines: z.array(lambdaLogLineSchema),
  truncated: z.boolean(),
});

export const observabilitySettingsSchema = z.object({
  success_sample_percent: z.number(),
  updated_at: z.string().nullish(),
  updated_by_name: z.string().nullish(),
});

export const updateObservabilitySettingsSchema = z.object({
  success_sample_percent: z.number().finite().min(0).max(100),
});

export const paymentTypeSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    payment_type: paymentMethodTypeSchema,
    stores: z.array(z.string()),
    merchant_id: z.string(),
  });

export const createPaymentTypeSchema = z.object({
  name: z.string(),
  payment_type: paymentMethodTypeSchema,
  stores: z.array(z.string()),
  merchant_id: z.string(),
});

export const updatePaymentTypeSchema = z.object({
  name: z.string().nullish(),
  payment_type: paymentMethodTypeSchema.nullish(),
  add_stores: z.array(z.string()).nullish(),
  remove_stores: z.array(z.string()).nullish(),
  id: z.string(),
});

export const paymentTypePageSchema = z.object({
  payment_types: z.array(paymentTypeSchema),
  count: z.number(),
  cursor: z.string(),
});

export const getPaymentTypeSchema = z.object({
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getPaymentTypesSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  merchant_id: z.string(),
  stores: z.array(z.string()).nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const paymentTypeDBItemSchema = timestampsSchema
  .extend(paymentTypeSchema.shape)
  .extend({
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const paymentReasonSchema = z.nativeEnum(PaymentReason);

export const receiptPaymentSchema = timestampsSchema.extend({
  payment_type_id: z.string(),
  payment_type: paymentMethodTypeSchema,
  money_amount: z.number(),
  note: z.string().nullish(),
  total_given: z.number().nullish(),
  change: z.number().nullish(),
});

export const refundReceiptPaymentDetailsSchema = z.object({
  receipt_id: z.string(),
  payment: receiptPaymentSchema,
  customer_id: z.string(),
  refund_for: z.string(),
});

export const loanPaymentDetailsSchema = z.object({
  borrower_id: z.string(),
  borrower_type: entityTypesSchema,
  borrower_loan_id: z.string(),
});

export const debtPaymentDetailsSchema = z.object({
  customer_id: z.string(),
  customer_debt_id: z.string(),
});

export const commonPaymentAttributesSchema = z.object({
  amount: z.number(),
  reason: paymentReasonSchema,
  employee: commonEmployeeAsCreatorAttributesSchema,
  note: z.string(),
  payer_id: z.string(),
  payer_type: entityTypesSchema,
  store_id: z.string(),
  shift_id: z.string().nullish(),
});

export const allocationSchema = timestampsSchema.extend({
  allocation_entity_type: entityTypesSchema,
  allocation_entity_id: z.string(),
  amount: z.number(),
});

export const createLoanPaymentDtoSchema = commonPaymentAttributesSchema.extend({
  borrower_loan_id: z.string(),
});

export const createDebtPaymentDtoSchema = commonPaymentAttributesSchema.extend({
  customer_debt_id: z.string(),
});

export const createRefundReceiptPaymentDtoSchema =
  commonPaymentAttributesSchema.extend(refundReceiptPaymentDetailsSchema.shape);

export const paginationParamsSchema = z.object({
  cursor: z.union([z.string(), z.undefined()]).nullish(),
  limit: z.number().nullish(),
});

export const getPaymentsByPayerAndDateRangeDtoSchema =
  paginationParamsSchema.extend({
    payer_id: z.string(),
    payer_type: entityTypesSchema,
    from: z.string(),
    to: z.string(),
  });

export const getPaymentsByCreatorDtoSchema = paginationParamsSchema.extend({
  creator_id: z.string(),
  creator_type: entityTypesSchema,
});

export const getPaymentsByOwnerDtoSchema = paginationParamsSchema.extend({
  owner_id: z.string(),
  owner_type: entityTypesSchema,
});

export const getPaymentByIdDtoSchema = z.object({
  payment_id: z.string(),
});

export const getPaymentsByEntityDtoSchema = paginationParamsSchema.extend({
  entity_id: z.string(),
  entity_type: entityTypesSchema,
});

export const dateRangeSchema = z.object({
  to: z.string(),
  from: z.string(),
});

export const getPaymentsByReasonDtoSchema = paginationParamsSchema.extend({
  reason: paymentReasonSchema,
});

export const getPaymentsByOwnerAndReasonDtoSchema =
  getPaymentsByOwnerDtoSchema.extend({
    reason: paymentReasonSchema,
  });

export const getPaymentsByOwnerAndDateRangeDtoSchema =
  getPaymentsByOwnerDtoSchema.extend(dateRangeSchema.shape);

export const getPaymentsByCreatorAndDateRangeDtoSchema =
  getPaymentsByCreatorDtoSchema.extend(dateRangeSchema.shape);

export const getPaymentsByDateRangeDtoSchema = paginationParamsSchema.extend(
  dateRangeSchema.shape,
);

export const updatePaymentAllocationsSchema =
  commonEmployeeAsCreatorAttributesSchema.extend({
    allocations: z.array(allocationSchema),
    payment_id: z.string(),
  });

export const permissionVisibilitySchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    group_order: z.array(z.string()),
    visible_permissions: z.array(z.string()),
  });

export const updatePermissionVisibilitySchema = z.object({
  group_order: z.array(z.string()),
  visible_permissions: z.array(z.string()),
  version: z.number().nullish(),
});

export const merchantRoleGrantsMessageSchema = z.object({
  cursor: z.string().nullish(),
  actor_id: z.string(),
  actor_name: z.string(),
});

export const permissionVisibilityResponseSchema = z.object({
  setting: permissionVisibilitySchema.nullable(),
});

export const permissionVisibilityDBItemSchema =
  permissionVisibilitySchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const platformFinanceCategorySchema = z.nativeEnum(
  PlatformFinanceCategory,
);

export const platformFinanceAssignmentStatusSchema = z.nativeEnum(
  PlatformFinanceAssignmentStatus,
);

export const platformFinanceAllocationStatusSchema = z.nativeEnum(
  PlatformFinanceAllocationStatus,
);

export const platformFinanceSplitSchema = z.object({
  id: z.string(),
  amount: z.number(),
  category: platformFinanceCategorySchema,
  store_id: z.string().nullish(),
  store_name: z.string().nullish(),
  employee_id: z.string().nullish(),
  recipient_name: z.string().nullish(),
  posted_at: z.string().nullish(),
  posted_reference_id: z.string().nullish(),
});

export const platformFinanceAllocationSchema = versionedSchema.extend({
  receiver_number: z.string(),
  transaction_id: z.string(),
  direction: z.union([
    z.literal(WalletTransferDirection.IN),
    z.literal(WalletTransferDirection.OUT),
  ]),
  category: platformFinanceCategorySchema,
  merchant_id: z.string().nullish(),
  merchant_name: z.string().nullish(),
  splits: z.array(platformFinanceSplitSchema),
  note: z.string().nullish(),
  status: platformFinanceAllocationStatusSchema,
  error: z.string().nullish(),
  collected_invoice_ids: z.array(z.string()).nullish(),
  occurred_at: z.string(),
  total_amount: z.number(),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  updated_by_id: z.string().nullish(),
  updated_by_name: z.string().nullish(),
  deleted_at: z.string().nullish(),
  deleted_by_id: z.string().nullish(),
  deleted_by_name: z.string().nullish(),
  moved_to: z.string().nullish(),
});

export const platformFinanceAllocationDBItemSchema =
  platformFinanceAllocationSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const platformFinancePhoneEntitySchema = z.nativeEnum(
  PlatformFinancePhoneEntity,
);

export const platformFinancePhoneStatusSchema = z.nativeEnum(
  PlatformFinancePhoneStatus,
);

export const platformFinancePhoneAssociationSchema = versionedSchema.extend({
  phone_number: z.string(),
  entity_type: platformFinancePhoneEntitySchema,
  entity_id: z.string(),
  merchant_id: z.string().nullish(),
  confirmations: z.number(),
  conflicts: z.number(),
  confidence: z.number(),
  status: platformFinancePhoneStatusSchema,
  first_seen_at: z.string(),
  last_confirmed_at: z.string(),
});

export const platformFinancePhoneAssociationDBItemSchema =
  platformFinancePhoneAssociationSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const platformFinanceWaiverReasonSchema = z.nativeEnum(
  PlatformFinanceWaiverReason,
);

export const platformFinanceWaiverStatusSchema = z.nativeEnum(
  PlatformFinanceWaiverStatus,
);

export const platformFinanceWaiverSchema = versionedSchema.extend({
  invoice_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  amount: z.number(),
  reason: platformFinanceWaiverReasonSchema,
  note: z.string().nullish(),
  status: platformFinanceWaiverStatusSchema,
  waived_by: z.string(),
  waived_at: z.string(),
  removed_by: z.string().nullish(),
  removed_at: z.string().nullish(),
  replacement_invoice_id: z.string().nullish(),
});

export const platformFinanceWaiverDBItemSchema =
  platformFinanceWaiverSchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
  });

export const platformFinanceAuditActionSchema = z.nativeEnum(
  PlatformFinanceAuditAction,
);

export const platformFinanceAuditEntrySchema = z.object({
  id: z.string(),
  action: platformFinanceAuditActionSchema,
  record_type: z.string(),
  record_id: z.string(),
  old_value: z.string().nullish(),
  new_value: z.string().nullish(),
  reason: z.string().nullish(),
  actor_id: z.string(),
  actor_name: z.string(),
  created_at: z.string(),
});

export const platformFinanceAuditEntryDBItemSchema =
  platformFinanceAuditEntrySchema.extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const platformFinanceReconciliationStatusSchema = z.nativeEnum(
  PlatformFinanceReconciliationStatus,
);

export const platformFinanceSuggestionSchema = z.object({
  category: platformFinanceCategorySchema.nullish(),
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
  employee_id: z.string().nullish(),
  reason: z.string().nullish(),
});

export const messageOperatorSchema = z.nativeEnum(MessageOperator);

export const txSubtypeSchema = z.nativeEnum(TxSubtype);

export const claimStatusSchema = z.nativeEnum(ClaimStatus);

export const topupNumberStatusSchema = z.nativeEnum(TopupNumberStatus);

export const platformFinanceBillingStatusSchema = z.nativeEnum(
  PlatformFinanceBillingStatus,
);

export const platformFinanceClientSchema = z.object({
  merchant_id: z.string(),
  merchant_name: z.string(),
  store_id: z.string(),
  store_name: z.string(),
  phone_number: z.string().nullish(),
  billing_status: platformFinanceBillingStatusSchema,
  subscription_amount: z.number(),
  payment_day: z.number().nullish(),
  current_invoice_id: z.string().nullish(),
  current_invoice_number: z.string().nullish(),
  current_invoice_status: z.string().nullish(),
  current_due_date: z.string().nullish(),
  current_expected: z.number(),
  current_paid: z.number(),
  current_outstanding: z.number(),
  current_waived: z.number(),
  is_paid: z.boolean(),
  is_overdue: z.boolean(),
  is_waived: z.boolean(),
  waiver_reason: platformFinanceWaiverReasonSchema.nullish(),
  waiver_note: z.string().nullish(),
  assigned_agent_name: z.string().nullish(),
});

export const platformFinanceEmployeeSchema = z.object({
  id: z.string(),
  name: z.string(),
  phone_number: z.string().nullish(),
  cost_this_month: z.number(),
});

export const platformFinanceReportBucketSchema = z.object({
  period: z.string(),
  money_in: z.number(),
  money_out: z.number(),
  expenses: z.number(),
  material_purchases: z.number(),
  net: z.number(),
});

export const platformFinanceSystemSchema = z.object({
  last_sms_at: z.string().nullish(),
  reconciliation_gaps: z.number(),
  reconciliation_review: z.number(),
  pending_setup_numbers: z.number(),
  unassigned_devices: z.number().nullish(),
});

export const getPlatformFinanceBootstrapSchema = z.object({
  receiver_number: z.string().nullish(),
});

export const getPlatformFinanceTransactionSchema = z.object({
  receiver_number: z.string(),
  transaction_id: z.string(),
});

export const platformFinanceIncomeSplitInputSchema = z.object({
  store_id: z.string(),
  amount: z.number(),
});

export const assignPlatformFinanceIncomeSchema = z.object({
  receiver_number: z.string(),
  transaction_id: z.string(),
  category: platformFinanceCategorySchema,
  merchant_id: z.string().nullish(),
  splits: z.array(platformFinanceIncomeSplitInputSchema).nullish(),
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const platformFinanceExpenseSplitInputSchema = z.object({
  employee_id: z.string().nullish(),
  recipient_name: z.string().nullish(),
  category: platformFinanceCategorySchema,
  amount: z.number(),
});

export const assignPlatformFinanceExpenseSchema = z.object({
  receiver_number: z.string(),
  transaction_id: z.string(),
  splits: z.array(platformFinanceExpenseSplitInputSchema),
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const getPlatformFinanceClientSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
});

export const waivePlatformFinanceInvoiceSchema = z.object({
  invoice_id: z.string(),
  reason: platformFinanceWaiverReasonSchema,
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const removePlatformFinanceWaiverSchema = z.object({
  invoice_id: z.string(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const getPlatformFinanceEmployeeSchema = z.object({
  employee_id: z.string(),
  month: z.string().nullish(),
});

export const platformFinanceEmployeeLineSchema = z.object({
  transaction_id: z.string(),
  receiver_number: z.string(),
  occurred_at: z.string(),
  category: platformFinanceCategorySchema,
  amount: z.number(),
  note: z.string().nullish(),
});

export const platformFinanceEmployeeDetailSchema = z.object({
  employee: platformFinanceEmployeeSchema,
  totals: z.array(
    z.object({
      category: platformFinanceCategorySchema,
      amount: z.number(),
    }),
  ),
  lines: z.array(platformFinanceEmployeeLineSchema),
});

export const getPlatformFinanceReconciliationSchema = z.object({
  receiver_number: z.string(),
});

export const replayPlatformFinanceSmsSchema = z.object({
  start_date: z.string(),
  end_date: z.string(),
  device_name: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const mergePlatformFinanceAccountSchema = z.object({
  from_phone_number: z.string(),
  to_phone_number: z.string(),
  dry_run: z.boolean().nullish(),
  use_from_payment_type: z.boolean().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const topupNumberMergeResultSchema = z.object({
  dry_run: z.boolean(),
  pending_phone_number: z.string(),
  phone_number: z.string(),
  device_label: z.string().nullish(),
  topup_requests: z.number(),
  transfer_outs: z.number(),
  wallet_messages: z.number(),
  operator_corrections: z.number(),
  operator: messageOperatorSchema.nullish(),
  platform_payment_type_id: z.string().nullish(),
});

export const assignPlatformFinanceDeviceSchema = z.object({
  device_label: z.string(),
  phone_number: z.string(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const replayPlatformFinanceSmsResultSchema = z.object({
  scanned: z.number(),
  published: z.number(),
});

export const getPlatformFinanceAuditLogSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const platformFinanceAuditLogPageSchema = z.object({
  items: z.array(platformFinanceAuditEntrySchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const platformFounderSchema = versionedSchema
  .extend(timestampsSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    emails: z.array(z.string()),
    created_by_id: z.string().nullish(),
    created_by_name: z.string().nullish(),
  });

export const platformFounderDBItemSchema = platformFounderSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const platformExpenseStatusSchema = z.nativeEnum(PlatformExpenseStatus);

export const platformExpenseSourceSchema = z.nativeEnum(PlatformExpenseSource);

export const platformFinanceReceiptSchema = z.object({
  key: z.string(),
  file_name: z.string(),
  content_type: z.string(),
  size: z.number().nullish(),
});

export const platformExpenseSchema = versionedSchema
  .extend(timestampsSchema.shape)
  .extend({
    id: z.string(),
    provider: z.string(),
    account: z.string().nullish(),
    description: z.string().nullish(),
    category: platformFinanceCategorySchema,
    amount: z.number(),
    currency: z.string(),
    status: platformExpenseStatusSchema,
    occurred_at: z.string(),
    due_date: z.string().nullish(),
    source: platformExpenseSourceSchema,
    paid_by_founder_id: z.string().nullish(),
    paid_by_name: z.string().nullish(),
    invoice_number: z.string().nullish(),
    receipt: platformFinanceReceiptSchema.nullish(),
    reimbursed_at: z.string().nullish(),
    reimbursed_by_name: z.string().nullish(),
    note: z.string().nullish(),
    created_by_id: z.string().nullish(),
    created_by_name: z.string().nullish(),
  });

export const platformExpenseDBItemSchema = platformExpenseSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const platformIncomeSchema = versionedSchema
  .extend(timestampsSchema.shape)
  .extend({
    id: z.string(),
    source_name: z.string(),
    description: z.string().nullish(),
    category: platformFinanceCategorySchema,
    amount: z.number(),
    currency: z.string(),
    received_at: z.string(),
    receipt: platformFinanceReceiptSchema.nullish(),
    note: z.string().nullish(),
    created_by_id: z.string().nullish(),
    created_by_name: z.string().nullish(),
  });

export const platformIncomeDBItemSchema = platformIncomeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const platformFinanceCategoryAmountSchema = z.object({
  category: platformFinanceCategorySchema.nullish(),
  amount: z.number(),
});

export const platformMobileMoneyMonthSchema = z.object({
  period: z.string(),
  money_in: z.array(platformFinanceCategoryAmountSchema),
  money_out: z.array(platformFinanceCategoryAmountSchema),
});

export const platformBusinessFinanceSchema = z.object({
  year: z.number(),
  mobile_money_currency: z.string(),
  mobile_money: z.array(platformMobileMoneyMonthSchema),
  mobile_money_capped: z.boolean(),
  mobile_money_errors: z.array(z.string()),
  founders: z.array(platformFounderSchema),
  expenses: z.array(platformExpenseSchema),
  owed_expenses: z.array(platformExpenseSchema),
  incomes: z.array(platformIncomeSchema),
  generated_at: z.string(),
});

export const getPlatformBusinessFinanceSchema = z.object({
  year: z.number().nullish(),
});

export const createPlatformFounderSchema = z.object({
  name: z.string(),
  emails: z.array(z.string()).nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const updatePlatformFounderSchema = z.object({
  id: z.string(),
  version: z.number().nullish(),
  name: z.string(),
  emails: z.array(z.string()).nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const deletePlatformFounderSchema = z.object({
  id: z.string(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const createPlatformExpenseSchema = z.object({
  provider: z.string(),
  account: z.string().nullish(),
  description: z.string().nullish(),
  category: platformFinanceCategorySchema,
  amount: z.number(),
  currency: z.string(),
  status: platformExpenseStatusSchema.nullish(),
  occurred_at: z.string(),
  due_date: z.string().nullish(),
  paid_by_founder_id: z.string().nullish(),
  invoice_number: z.string().nullish(),
  receipt: platformFinanceReceiptSchema.nullish(),
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const updatePlatformExpenseSchema = z.object({
  id: z.string(),
  version: z.number().nullish(),
  provider: z.string(),
  account: z.string().nullish(),
  description: z.string().nullish(),
  category: platformFinanceCategorySchema,
  amount: z.number(),
  currency: z.string(),
  status: platformExpenseStatusSchema,
  occurred_at: z.string(),
  due_date: z.string().nullish(),
  paid_by_founder_id: z.string().nullish(),
  invoice_number: z.string().nullish(),
  receipt: platformFinanceReceiptSchema.nullish(),
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const deletePlatformExpenseSchema = z.object({
  id: z.string(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const reimbursePlatformExpensesSchema = z.object({
  expense_ids: z.array(z.string()),
  reimbursed: z.boolean(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const reimbursePlatformExpensesResultSchema = z.object({
  expenses: z.array(platformExpenseSchema),
});

export const createPlatformIncomeSchema = z.object({
  source_name: z.string(),
  description: z.string().nullish(),
  category: platformFinanceCategorySchema,
  amount: z.number(),
  currency: z.string(),
  received_at: z.string(),
  receipt: platformFinanceReceiptSchema.nullish(),
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const updatePlatformIncomeSchema = z.object({
  id: z.string(),
  version: z.number().nullish(),
  source_name: z.string(),
  description: z.string().nullish(),
  category: platformFinanceCategorySchema,
  amount: z.number(),
  currency: z.string(),
  received_at: z.string(),
  receipt: platformFinanceReceiptSchema.nullish(),
  note: z.string().nullish(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const deletePlatformIncomeSchema = z.object({
  id: z.string(),
  actor_id: z.string().nullish(),
  actor_name: z.string().nullish(),
});

export const createPlatformFinanceReceiptUploadSchema = z.object({
  file_name: z.string(),
  content_type: z.string(),
  size: z.number(),
});

export const platformFinanceReceiptUploadSchema = z.object({
  upload_url: z.string(),
  receipt: platformFinanceReceiptSchema,
  expires_at: z.string(),
});

export const getPlatformFinanceReceiptUrlSchema = z.object({
  key: z.string(),
});

export const platformFinanceReceiptUrlSchema = z.object({
  url: z.string(),
  expires_at: z.string(),
});

export const platformPaymentTypeSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    payment_type: paymentMethodTypeSchema,
    description: z.string().nullish(),
  });

export const createPlatformPaymentTypeSchema = z.object({
  name: z.string(),
  payment_type: paymentMethodTypeSchema,
  description: z.union([z.string(), z.undefined()]).nullish(),
});

export const updatePlatformPaymentTypeSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  payment_type: paymentMethodTypeSchema.nullish(),
  description: z.string().nullish(),
});

export const platformPaymentTypePageSchema = z.object({
  payment_types: z.array(platformPaymentTypeSchema),
  count: z.number(),
  cursor: z.string(),
});

export const getPlatformPaymentTypesSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const platformPaymentTypeDBItemSchema = timestampsSchema
  .extend(platformPaymentTypeSchema.shape)
  .extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const posDeviceFeatureFlagsSchema = z.object({
  weighted_sales_enabled: z.boolean().nullish(),
  favourites_tab_enabled: z.boolean().nullish(),
});

export const posDeviceGeofenceSchema = z.object({
  latitude: z.number().finite().min(-90).max(90),
  longitude: z.number().finite().min(-180).max(180),
  radius_meters: z.number().int().min(20).max(5000),
});

export const locationSourceSchema = z.union([
  z.literal('gps'),
  z.literal('ip'),
  z.literal('unknown'),
]);

export const posAppPlatformSchema = z.union([
  z.literal('android'),
  z.literal('windows'),
]);

export const updatePosDeviceGeofenceRequestSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  geofence: posDeviceGeofenceSchema.nullable(),
});

export const updatePosDeviceFeatureFlagsRequestSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  feature_flags: posDeviceFeatureFlagsSchema,
});

export const createPosDeviceSchema = z.object({
  name: z.string(),
  store_id: z.string(),
  activated: z.boolean(),
  merchant_id: z.string(),
  prefix: z.string(),
  mac_address: z.string().nullish(),
});

export const updatePosDeviceSchema = z.object({
  name: z.string().nullish(),
  activated: z.boolean().nullish(),
  prefix: z.string().nullish(),
  mac_address: z.string().nullish(),
  merchant_id: z.string(),
  current_user_id: z.string().nullish(),
  id: z.string(),
  fingerprint: z.string().nullish(),
  device_label: z.string().nullish(),
  force: z.boolean().nullish(),
});

export const getPosDevicesSchema = z.object({
  store_id: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getPosDevicesByMerchantSchema = getPosDevicesSchema.extend({
  merchant_id: z.string(),
});

export const getPosDeviceSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const claimPosDeviceRequestSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  current_user_id: z.string(),
  fingerprint: z.string(),
  device_label: z.string(),
  force: z.boolean().nullish(),
  latitude: z.union([z.number(), z.undefined()]).nullish(),
  longitude: z.union([z.number(), z.undefined()]).nullish(),
  accuracy_meters: z.union([z.number(), z.undefined()]).nullish(),
});

export const posDeviceConflictSchema = z.object({
  id: z.string(),
  name: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  current_user_claimed_at: z.string().nullish(),
  current_user_device_label: z.string().nullish(),
  current_user_last_seen_at: z.string().nullish(),
  current_user_latitude: z
    .union([z.number(), z.undefined()])
    .nullish()
    .nullable(),
  current_user_longitude: z
    .union([z.number(), z.undefined()])
    .nullish()
    .nullable(),
  current_user_accuracy_meters: z
    .union([z.number(), z.undefined()])
    .nullish()
    .nullable(),
  current_user_location_source: locationSourceSchema.nullish(),
});

export const claimPosDeviceConflictResponseSchema = z.object({
  message: z.string(),
  conflicting_devices: z.array(posDeviceConflictSchema),
});

export const posDeviceSessionSchema = z.object({
  device_id: z.string(),
  name: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  current_user_id: z.string(),
  current_user_fingerprint: z.string().nullish(),
  current_user_device_label: z.string().nullish(),
  current_user_claimed_at: z.string().nullish(),
  current_user_last_seen_at: z.string().nullish(),
  current_user_latitude: z
    .union([z.number(), z.undefined()])
    .nullish()
    .nullable(),
  current_user_longitude: z
    .union([z.number(), z.undefined()])
    .nullish()
    .nullable(),
  current_user_accuracy_meters: z
    .union([z.number(), z.undefined()])
    .nullish()
    .nullable(),
  current_user_location_source: locationSourceSchema.nullish(),
});

export const getPosDeviceSessionsByUserSchema = z.object({
  user_id: z.string(),
});

export const posDeviceSessionsPageSchema = z.object({
  sessions: z.array(posDeviceSessionSchema),
  count: z.number(),
});

export const posDeviceHeartbeatRequestSchema = z.object({
  device_id: z.string(),
  merchant_id: z.string(),
  user_id: z.string(),
  fingerprint: z.string(),
  latitude: z.union([z.number(), z.undefined()]).nullish(),
  longitude: z.union([z.number(), z.undefined()]).nullish(),
  accuracy_meters: z.union([z.number(), z.undefined()]).nullish(),
  app_version: z.union([z.string(), z.undefined()]).nullish(),
  app_platform: z.union([z.string(), z.undefined()]).nullish(),
});

export const posDeviceHeartbeatReasonSchema = z.union([
  z.literal('OK'),
  z.literal('NOT_FOUND'),
  z.literal('NOT_HOLDER'),
  z.literal('FINGERPRINT_MISMATCH'),
  z.literal('EVICTED'),
]);

export const posDeviceHeartbeatResponseSchema = z.object({
  still_valid: z.boolean(),
  reason: posDeviceHeartbeatReasonSchema.nullish(),
});

export const evictPosDeviceRequestSchema = z.object({
  device_id: z.string(),
  merchant_id: z.string(),
  latitude: z.union([z.number(), z.undefined()]).nullish(),
  longitude: z.union([z.number(), z.undefined()]).nullish(),
  accuracy_meters: z.union([z.number(), z.undefined()]).nullish(),
});

export const evictUserFromAllDevicesRequestSchema = z.object({
  user_id: z.string(),
});

export const posSessionEventTypeSchema = z.union([
  z.literal('CLAIM'),
  z.literal('EVICT'),
  z.literal('HEARTBEAT_FAIL'),
  z.literal('OFFLINE_SIGN_IN'),
  z.literal('OFFLINE_SIGN_OUT'),
]);

export const posSessionEventSchema = z.object({
  id: z.string(),
  event_type: posSessionEventTypeSchema,
  occurred_at: z.string(),
  op_id: z.string().nullish(),
  merchant_id: z.string(),
  store_id: z.string(),
  pos_device_id: z.string(),
  pos_device_name: z.string(),
  user_id: z.string(),
  fingerprint: z.string(),
  device_label: z.string(),
  evicted_by_fingerprint: z.string().nullish(),
  evicted_by_device_label: z.string().nullish(),
  reason: z.string().nullish(),
  latitude: z.union([z.number(), z.undefined()]).nullish(),
  longitude: z.union([z.number(), z.undefined()]).nullish(),
  accuracy_meters: z.union([z.number(), z.undefined()]).nullish(),
  location_source: locationSourceSchema.nullish(),
});

export const posSessionEventDBItemSchema = posSessionEventSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const posSessionEventsPageSchema = z.object({
  events: z.array(posSessionEventSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const listPosSessionEventsByUserSchema = z.object({
  user_id: z.string(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const listPosSessionEventsByStoreSchema = z.object({
  store_id: z.string(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const listPosSessionEventsByDeviceSchema = z.object({
  merchant_id: z.string(),
  pos_device_id: z.string(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const posSessionReplayEventSchema = z.object({
  op_id: z.string(),
  event_type: z.union([
    z.literal('OFFLINE_SIGN_IN'),
    z.literal('OFFLINE_SIGN_OUT'),
  ]),
  user_id: z.string(),
  fingerprint: z.string(),
  device_label: z.string(),
  occurred_at: z.string().datetime(),
  pos_device_id: z.string().nullish(),
  store_id: z.string().nullish(),
});

export const posSessionReplayRequestSchema = z.object({
  merchant_id: z.string(),
  device_id: z.string(),
  events: z.array(posSessionReplayEventSchema).max(100),
});

export const posSessionReplayRefusalSchema = z.object({
  op_id: z.string(),
  reason: z.string(),
});

export const posSessionReplayResponseSchema = z.object({
  recorded: z.number(),
  duplicates: z.number(),
  refused: z.array(posSessionReplayRefusalSchema).nullish(),
});

export const getPosDeviceOfflineCredentialsSchema = z.object({
  merchant_id: z.string(),
  id: z.string(),
});

export const pricingPlanStatusSchema = z.nativeEnum(PricingPlanStatus);

export const pricingDiscountTypeSchema = z.nativeEnum(PricingDiscountType);

export const receiptTierSchema = z.object({
  max_receipts: z.number().nullable(),
  amount: z.number(),
});

export const transactionTierSchema = z.object({
  max_transactions: z.number().nullable(),
  amount: z.number(),
});

export const pricingDiscountSchema = z.object({
  type: pricingDiscountTypeSchema,
  value: z.number(),
  description: z.string().nullish(),
});

export const createPricingPlanSchema = z.object({
  name: z.string(),
  description: z.string().nullish(),
  currency: z.string(),
  pricing_type: pricingTypeSchema,
  billing_period: billingPeriodSchema,
  fixed_amount: z.number().nullish(),
  per_receipt_amount: z.number().nullish(),
  receipt_tiers: z.array(receiptTierSchema).nullish(),
  per_transaction_amount: z.number().nullish(),
  transaction_tiers: z.array(transactionTierSchema).nullish(),
  custom_billing_period_in_hours: z.number().nullish(),
  default_next_bill_date: z.string().nullish(),
});

export const updatePricingPlanSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  billing_period: billingPeriodSchema.nullish(),
  fixed_amount: z.number().nullish(),
  per_receipt_amount: z.number().nullish(),
  receipt_tiers: z.array(receiptTierSchema).nullish(),
  per_transaction_amount: z.number().nullish(),
  transaction_tiers: z.array(transactionTierSchema).nullish(),
  custom_billing_period_in_hours: z.number().nullish(),
  default_next_bill_date: z.string().nullish(),
});

export const getPricingPlanSchema = z.object({
  id: z.string(),
});

export const archivePricingPlanSchema = z.object({
  id: z.string(),
});

export const getPricingPlansSchema = z.object({
  status: pricingPlanStatusSchema.nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const pricingPlanSnapshotSchema = z.object({
  plan_id: z.string(),
  plan_version: z.number(),
  name: z.string(),
  pricing_type: pricingTypeSchema,
  billing_period: billingPeriodSchema,
  currency: z.string(),
  fixed_amount: z.number().nullish(),
  per_receipt_amount: z.number().nullish(),
  receipt_tiers: z.array(receiptTierSchema).nullish(),
  per_transaction_amount: z.number().nullish(),
  transaction_tiers: z.array(transactionTierSchema).nullish(),
  store_id: z.string().nullish(),
  custom_billing_period_in_hours: z.number().nullish(),
  next_bill_date: z.string().nullish(),
});

export const freeMonthsGrantSchema = z.object({
  id: z.string(),
  months: z.number(),
  reason: z.string().nullish(),
  previous_next_bill_date: z.string(),
  next_bill_date: z.string(),
  waived_notification_months: z.array(z.string()),
  granted_at: z.string(),
  granted_by_id: z.string(),
  granted_by_name: z.string(),
});

export const activeAgreementPointerDBItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  agreement_id: z.string(),
  plan_id: z.string(),
  created_on: z.string(),
});

export const createCustomerAgreementSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  plan_id: z.string(),
  discounts: z.array(pricingDiscountSchema).nullish(),
  active_from: z.string().nullish(),
  active_to: z.string().nullish(),
  custom_billing_period_in_hours: z.number().nullish(),
  next_bill_date: z.string().nullish(),
});

export const getCustomerAgreementSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
});

export const getActiveCustomerAgreementSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
});

export const getCustomerAgreementsSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  status: customerAgreementStatusSchema.nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const agreementChurnMonthSchema = z.object({
  month: z.string(),
  churned: z.number(),
  active_at_start: z.number(),
  churn_rate_pct: z.number().nullable(),
  new_stores: z.number().nullish(),
  net_new_stores: z.number().nullish(),
});

export const agreementsSummarySchema = z.object({
  active_agreements: z.number(),
  paying_stores: z.number(),
  free_stores: z.number(),
  paying_share_pct: z.number().nullable(),
  monthly_churn: z.array(agreementChurnMonthSchema),
  churn_rate_last_month_pct: z.number().nullable(),
  agreement_count: z.number(),
  generated_at: z.string(),
  mrr: z.number().nullish(),
  mrr_currency: z.string().nullish(),
  mrr_agreements: z.number().nullish(),
  usage_based_agreements: z.number().nullish(),
  excluded_mrr_by_currency: z.record(z.number()).nullish(),
  from: z.string().nullish(),
  to: z.string().nullish(),
});

export const getAgreementsSummarySchema = z.object({
  from: z.string().datetime({ offset: true }).nullish(),
  to: z.string().datetime({ offset: true }).nullish(),
}).refine(
  (range) =>
    !range.from ||
    !range.to ||
    new Date(range.from).getTime() <= new Date(range.to).getTime(),
  { message: 'from must not be after to', path: ['from'] },
);

export const cancelCustomerAgreementSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
});

export const switchCustomerAgreementSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  plan_id: z.string(),
  discounts: z.array(pricingDiscountSchema).nullish(),
  active_from: z.string(),
  active_to: z.string().nullish(),
  next_bill_date: z.string().nullish(),
});

export const grantFreeMonthsSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  months: z.number().int().min(1).max(3),
  reason: z.string().trim().max(500).nullish(),
  grant_id: z.string().trim().min(1).max(64).nullish(),
});

export const editablePlanSnapshotFieldsSchema = z.object({
  currency: z
    .string()
    .regex(/^[A-Za-z]{3}$/, 'currency must be a three-letter ISO code')
    .optional(),
  billing_period: billingPeriodSchema.optional(),
  fixed_amount: z.number().min(0).nullish(),
  per_receipt_amount: z.number().min(0).nullish(),
  receipt_tiers: z
    .array(
      z.object({
        max_receipts: z.number().positive().nullable(),
        amount: z.number().min(0),
      }),
    )
    .min(1)
    .nullish(),
  per_transaction_amount: z.number().min(0).nullish(),
  transaction_tiers: z
    .array(
      z.object({
        max_transactions: z.number().positive().nullable(),
        amount: z.number().min(0),
      }),
    )
    .min(1)
    .nullish(),
  custom_billing_period_in_hours: z.number().min(24).max(8760).nullish(),
});

export const updateCustomerAgreementSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  expected_next_bill_date: z.string().nullish(),
  active_from: z.string().optional(),
  active_to: z.string().nullish(),
  next_bill_date: z.string().nullish(),
  custom_billing_period_in_hours: z.number().min(24).max(8760).nullish(),
  plan_snapshot: editablePlanSnapshotFieldsSchema.nullish(),
});

export const customerAgreementAuditSchema = z.object({
  agreement_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  changed_at: z.string(),
  changed_by: z.string().nullish(),
  previous_snapshot: pricingPlanSnapshotSchema,
  changed_fields: z.array(z.string()),
});

export const customerAgreementAuditPageSchema = z.object({
  items: z.array(customerAgreementAuditSchema),
  cursor: z.string().nullish(),
});

export const pricingUsageSchema = z.object({
  receipts: z.number(),
  users: z.number().nullish(),
  locations: z.number().nullish(),
  transactions: z.number().nullish(),
});

export const pricingCalculationRequestSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  period_start: z.string(),
  period_end: z.string(),
  usage: pricingUsageSchema,
});

export const previewPricingRequestSchema = z.object({
  plan_id: z.string(),
  store_id: z.string().nullish(),
  period_start: z.string(),
  period_end: z.string(),
  usage: pricingUsageSchema,
  discounts: z.array(pricingDiscountSchema).nullish(),
});

export const pricingBreakdownLineSchema = z.object({
  label: z.string(),
  amount: z.number(),
  kind: z.union([z.literal('base'), z.literal('discount')]),
});

export const pricingCalculationResultSchema = z.object({
  base_amount: z.number(),
  discount_amount: z.number(),
  final_amount: z.number(),
  currency: z.string(),
  billing_period: billingPeriodSchema,
  is_billable: z.boolean(),
  plan_id: z.string(),
  agreement_id: z.string().nullish(),
  period_start: z.string(),
  period_end: z.string(),
  breakdown: z.array(pricingBreakdownLineSchema),
  reason: z.string().nullish(),
});

export const productExpiryDismissReasonSchema = z.nativeEnum(
  ProductExpiryDismissReason,
);

export const productExpirySchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    product_id: z.string(),
    product_name: z.string(),
    po_id: z.string(),
    item_id: z.string(),
    expiry_date: z.string(),
    quantity: z.number(),
    warning_days: z.number(),
    dismissed_at: z.string().nullish(),
    dismissed_by_id: z.string().nullish(),
    dismissed_by_name: z.string().nullish(),
    dismiss_reason: productExpiryDismissReasonSchema.nullish(),
    notified_at: z.string().nullish(),
  });

export const dynamoDBItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string().nullish(),
  GSI1SK: z.string().nullish(),
  GSI2PK: z.string().nullish(),
  GSI2SK: z.string().nullish(),
  GSI3PK: z.string().nullish(),
  GSI3SK: z.string().nullish(),
  GSI4PK: z.string().nullish(),
  GSI4SK: z.string().nullish(),
  GSI5PK: z.string().nullish(),
  GSI5SK: z.string().nullish(),
  GSI6PK: z.string().nullish(),
  GSI6SK: z.string().nullish(),
  GSI7PK: z.string().nullish(),
  GSI7SK: z.string().nullish(),
});

export const activeProductExpirySchema = productExpirySchema.extend({
  in_stock: z.number(),
  days_left: z.number(),
});

export const getProductExpiriesSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  due_by: z.string().nullish(),
  timezone: z.string().nullish(),
});

export const activeProductExpiryPageSchema = z.object({
  expiries: z.array(activeProductExpirySchema),
  count: z.number(),
});

export const dismissProductExpirySchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  po_id: z.string(),
  item_id: z.string(),
  updator_id: z.string(),
});

export const storeProductCostUpdatedEventDetailDataSchema = z.object({
  parentStoreProduct: z.any(),
});

export const productFractionSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    parent_id: z.string(),
    fraction_id: z.string(),
    fraction: z.number(),
    fraction_name: z.string(),
    parent_name: z.string(),
    merchant_id: z.string(),
    deleted_by_id: z.string().nullish(),
    deleted_by_name: z.string().nullish(),
  });

export const getProductsSchema = z.object({
  merchant_id: z.string(),
  is_parent: z.boolean().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
  include_fractions: z.boolean().nullish(),
});

export const createProductSchema = z.object({
  creator_id: z.string(),
  name: z.string(),
  description: z.string(),
  image: z.string(),
  barcode: z.union([z.string(), z.number()]),
  quantity_in_unit_package: z.number(),
  weight_kg: z.number(),
  unit: z.union([z.string(), z.number()]),
  category_id: z.string().nullish(),
  merchant_id: z.string(),
  unit_of_measurement: z.string(),
  taxes: z.array(z.string()),
  barcodes: z.array(barcodeSchema).nullish(),
  countries: z.array(z.string()).nullish(),
});

export const updateProductSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  unit_of_measurement: z.string().nullish(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  image: z.string().nullish(),
  barcode: z.union([z.string(), z.number()]).nullish(),
  quantity_in_unit_package: z.number().nullish(),
  global_sku: z.number().nullish(),
  weight_kg: z.number().nullish(),
  unit: z.union([z.string(), z.number()]).nullish(),
  category_id: z.string().nullish(),
  add_taxes: z.array(z.string()).nullish(),
  remove_taxes: z.array(z.string()).nullish(),
  add_barcodes: z.array(barcodeSchema).nullish(),
  remove_barcodes: z.array(barcodeSchema).nullish(),
});

export const getStoreProductsSchema = z.object({
  store_id: z.string(),
  is_parent: z.boolean().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getStoreProductSchema = z.object({
  store_id: z.string(),
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getStoreProductsByMerchantSchema = getStoreProductsSchema.extend({
  merchant_id: z.string(),
});

export const storeProductExportTriggerSchema = z.union([
  z.literal('manual'),
  z.literal('scheduled'),
]);

export const createStoreProductsExportJobSchema = z.object({
  include_deleted: z.boolean().nullish(),
  requested_by: z.string().nullish(),
  triggered_by: storeProductExportTriggerSchema.nullish(),
});

export const storeProductsExportJobResponseSchema = z.object({
  job_id: z.string(),
  s3_key: z.string(),
  requested_at: z.string(),
  triggered_by: storeProductExportTriggerSchema,
  include_deleted: z.boolean(),
  requested_by: z.string().nullish(),
});

export const storeProductExportRecordSchema = z.object({
  key: z.string(),
  file_name: z.string(),
  job_id: z.string(),
  requested_at: z.string(),
  triggered_by: storeProductExportTriggerSchema,
  include_deleted: z.boolean(),
  download_url: z.string(),
  requested_by: z.string().nullish(),
  size_in_bytes: z.number().nullish(),
  last_modified: z.string().nullish(),
  pdf_key: z.string().nullish(),
  pdf_download_url: z.string().nullish(),
  pdf_size_in_bytes: z.number().nullish(),
});

export const storeProductExportsResponseSchema = z.object({
  exports: z.array(storeProductExportRecordSchema),
  next_cursor: z.string().nullish(),
});

export const exportStoreProductsSQSMessageSchema = z.object({
  job_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  include_deleted: z.boolean().nullish(),
  triggered_by: storeProductExportTriggerSchema,
  requested_at: z.string(),
  requested_by: z.string().nullish(),
});

export const createStoreProductSchema = z.object({
  creator_id: z.string(),
  product_id: z.string(),
  store_id: z.string(),
  inventory: z.number(),
  is_available_for_sale: z.boolean(),
  is_sold_by_range: z.boolean(),
  max_selling_price: z.number(),
  min_selling_price: z.number(),
  is_manually_controlled: z.boolean(),
  is_sold_by_weight: z.boolean(),
  is_sold_online: z.boolean(),
  loyalty_programs: z.array(z.string()),
  price: z.number(),
  cost: z.number(),
  low_stock_threshold: z.number(),
  merchant_id: z.string(),
});

export const getStoreProductByMerchantSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getProductSchema = z.object({
  merchant_id: z.string(),
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const costUpdateOriginSchema = z.nativeEnum(CostUpdateOrigin);

export const weightedReceiveSchema = z.object({
  quantity_before: z.number(),
  quantity: z.number(),
  cost: z.number(),
});

export const updateStoreProductInventorySchema = z.object({
  id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  source_id: z.string(),
  source_type: entityTypesSchema,
  inventory: z.number(),
  stock_breakdown: stockBreakdownSchema.nullish(),
  stock_version: z.number().nullish(),
});

export const productFractionPageSchema = z.object({
  fractions: z.array(productFractionSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const getProductFractionsSchema = z.object({
  parent_id: z.string().nullish(),
  fraction_id: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getProductFractionsByMerchantSchema = z.object({
  merchant_id: z.string(),
  parent_id: z.string().nullish(),
  fraction_id: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getProductFractionSchema = z.object({
  merchant_id: z.string(),
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const createProductFractionSchema = z.object({
  fraction_id: z.string(),
  parent_id: z.string(),
  merchant_id: z.string(),
  creator_id: z.string(),
});

export const updateProductFractionSchema = z.object({
  id: z.string(),
  parent_id: z.string().nullish(),
  fraction_name: z.string().nullish(),
  parent_name: z.string().nullish(),
  merchant_id: z.string(),
  updator_id: z.string(),
});

export const repairParentFractionsSchema = z.object({
  parent_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
});

export const repairParentFractionsResultSchema = z.object({
  parent_id: z.string(),
  parent_name: z.string(),
  parent_quantity_in_unit_package: z.number(),
  children_repaired: z.number(),
  children_already_correct: z.number(),
  store_fractions_repaired: z.number(),
  stores_notified: z.number(),
});

export const skuSchema = timestampsSchema.extend({
  global_sku: z.number(),
  merchant_id: z.string(),
  unique_by_merchant: z.string(),
  product_id: z.string(),
});

export const storeProductChangeEventsSchema = z.nativeEnum(
  StoreProductChangeEvents,
);

export const productFractionDBItemSchema = productFractionSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const sKUDBItemSchema = skuSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const productChangeEventsSchema = z.nativeEnum(ProductChangeEvents);

export const productChangeSchema = timestampsSchema.extend({
  event: productChangeEventsSchema,
  version: z.string(),
  updator_id: z.string(),
  changed_attributes: changedAttributesSchema,
  change_reason: z.string(),
  id: z.string(),
  merchant_id: z.string(),
  updator_name: z.string(),
  product_name: z.string(),
});

export const productChangeDBItemSchema = productChangeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const productChangesPageSchema = z.object({
  changes: z.array(productChangeSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const getProductChangesSchema = z.object({
  by_user: z.boolean().nullish(),
  by_user_and_date_range: z.boolean().nullish(),
  by_user_and_product: z.boolean().nullish(),
  by_user_product_and_date_range: z.boolean().nullish(),
  by_user_and_event: z.boolean().nullish(),
  by_user_and_product_and_event_and_date_range: z.boolean().nullish(),
  by_product: z.boolean().nullish(),
  by_merchant: z.boolean().nullish(),
  by_merchant_and_product: z.boolean().nullish(),
  by_merchant_and_date_range: z.boolean().nullish(),
  by_merchant_product_and_date_range: z.boolean().nullish(),
  by_merchant_and_event: z.boolean().nullish(),
  by_merchant_event_and_date_range: z.boolean().nullish(),
  by_merchant_event_and_product: z.boolean().nullish(),
  by_merchant_event_product_and_date_range: z.boolean().nullish(),
  by_product_and_version_range: z.boolean().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  merchant_id: z.string(),
  product_id: z.string().nullish(),
  event: productChangeEventsSchema.nullish(),
  updator_id: z.string().nullish(),
  sort_order: z.union([z.literal('ASC'), z.literal('DESC')]).nullish(),
  version: z.number().nullish(),
  start_version: z.string().nullish(),
  end_version: z.string().nullish(),
});

export const getStoreProductChangesSchema = z.object({
  by_user: z.boolean().nullish(),
  by_user_and_date_range: z.boolean().nullish(),
  by_user_and_store_product: z.boolean().nullish(),
  by_user_store_product_and_date_range: z.boolean().nullish(),
  by_user_and_event: z.boolean().nullish(),
  by_user_and_store_product_and_event: z.boolean().nullish(),
  by_user_and_store_product_and_event_and_date_range: z.boolean().nullish(),
  by_store_product: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  by_store_and_store_product: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
  by_store_and_store_product_and_date_range: z.boolean().nullish(),
  by_store_and_event: z.boolean().nullish(),
  by_store_and_event_and_date_range: z.boolean().nullish(),
  by_store_event_and_store_product: z.boolean().nullish(),
  by_store_event_store_product_and_date_range: z.boolean().nullish(),
  by_store_product_and_version_range: z.boolean().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  store_id: z.string().nullish(),
  product_id: z.string().nullish(),
  event: z
    .union([productChangeEventsSchema, storeProductChangeEventsSchema])
    .nullish(),
  updator_id: z.string().nullish(),
  sort_order: z.union([z.literal('ASC'), z.literal('DESC')]).nullish(),
  version: z.number().nullish(),
  start_version: z.number().nullish(),
  end_version: z.number().nullish(),
});

export const storeProductChangeSchema = timestampsSchema.extend({
  event: storeProductChangeEventsSchema,
  version: z.number(),
  updator_id: z.string(),
  changed_attributes: changedAttributesSchema,
  change_reason: z.string(),
  id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_name: z.string(),
  product_name: z.string(),
  inventory_at_change: z.number().nullish(),
  inventory_value_change: z.number().nullish(),
});

export const storeProductChangeDBItemSchema = storeProductChangeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const bulkImportStoreProductSchema = z.object({
  store_id: z.string(),
  products: z.array(z.string()),
  merchant_id: z.string(),
  creator_id: z.string(),
  creator_type: entityTypesSchema,
});

export const bulkCreateStoreProductsResponseSchema = z.object({
  message: z.string(),
});

export const getDeletedStoreProductIdsSchema = z.object({
  ids: z.array(z.string()),
});

export const deletedStoreProductSchema = z.object({
  id: z.string(),
  deleted_at: z.string(),
});

export const deletedStoreProductsSchema = z.object({
  deleted: z.array(deletedStoreProductSchema),
});

export const promotionTypesSchema = z.nativeEnum(PromotionTypes);

export const promotionStatusSchema = z.nativeEnum(PromotionStatus);

export const createPromotionRequestSchema = z.object({
  title: z.string(),
  description: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  product_id: z.string(),
  image_url: z.string(),
  promotion_type: promotionTypesSchema,
  promotion_value: z.number(),
  promotion_code: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
});

export const updatePromotionRequestSchema = z.object({
  id: z.string(),
  title: z.string().nullish(),
  description: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  product_id: z.string().nullish(),
  image_url: z.string().nullish(),
  promotion_type: promotionTypesSchema.nullish(),
  promotion_value: z.number().nullish(),
  promotion_code: z.string().nullish(),
  promotion_status: promotionStatusSchema.nullish(),
  is_manual: z.boolean().nullish(),
  store_id: z.string(),
  merchant_id: z.string(),
});

export const getPromotionsRequestSchema = z.object({
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
  cursor: z.string().nullish(),
  by_status: z.boolean().nullish(),
  by_start_date_range: z.boolean().nullish(),
  by_start_date_range_and_status: z.boolean().nullish(),
  by_end_date_range: z.boolean().nullish(),
  by_end_date_range_and_status: z.boolean().nullish(),
  by_item: z.boolean().nullish(),
  by_item_and_status: z.boolean().nullish(),
  item_id: z.string().nullish(),
  status: promotionStatusSchema.nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  merchant_id: z.string(),
  store_id: z.string(),
});

export const promotionDiscountSchema = z.object({
  id: z.string(),
  type: discountTypeSchema,
  name: z.string(),
  discount_amount: z.number(),
  discount_percent: z.number(),
  stores: z.array(z.string()),
  restricted_access: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string().nullable(),
});

export const updatePromotionDiscountSchema = z.object({
  id: z.string(),
  type: discountTypeSchema,
  name: z.string(),
  discount_amount: z.number(),
  discount_percent: z.number(),
  stores: z.array(z.string()),
  restricted_access: z.boolean(),
});

export const createPromotionDiscountSchema = z.object({
  type: discountTypeSchema,
  name: z.string(),
  discount_amount: z.number(),
  discount_percent: z.number(),
  stores: z.array(z.string()),
  restricted_access: z.boolean(),
});

export const promotionDiscountPageSchema = z.object({
  discounts: z.array(promotionDiscountSchema),
  cursor: z.string(),
});

export const purchaseStatusSchema = z.nativeEnum(PurchaseStatus);

export const purchaseOrderPaymentStatusSchema = z.nativeEnum(
  PurchaseOrderPaymentStatus,
);

export const cancelPurchaseOrderItemFractionSchema = z.object({
  id: z.string(),
  parent_id: z.string(),
  fraction: z.number(),
  cancelled: z.number(),
});

export const cancelPurchaseOrderItemSchema = z.object({
  id: z.string(),
  cancelled: z.number(),
  fractions: z.array(cancelPurchaseOrderItemFractionSchema).nullish(),
});

export const purchaseOrderPaymentSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    purchase_order_id: z.string(),
    amount_paid: z.number(),
    amount_refunded: z.number(),
    payment_location: z.string(),
    payment_method_id: z.string().nullish(),
    payment_method_type: paymentMethodTypeSchema.nullish(),
    merchant_id: z.string(),
    store_id: z.string(),
    supplier_id: z.string(),
    amount_due: z.number(),
    total_paid: z.number(),
    total_refunded: z.number(),
    total_amount: z.number(),
    final_amount: z.number(),
    creator_id: z.string(),
    creator_name: z.string(),
    refund_note: z.string().nullish(),
    total_cancelled_amount: z.number(),
    shift_id: z.string().nullish(),
    reverses_payment_id: z.string().nullish(),
    reversed_by_payment_id: z.string().nullish(),
    is_reversal: z.boolean().nullish(),
  });

export const createPurchaseOrderPaymentSchema = z.object({
  amount_paid: z.number(),
  payment_location: z.string(),
  merchant_id: z.string(),
  purchase_order_id: z.string(),
  payment_method_id: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  store_id: z.string(),
  creator_id: z.string(),
  refund_note: z.string().nullish(),
  shift_id: z.string().nullish(),
  reverses_payment_id: z.string().nullish(),
});

export const getAllPurchaseOrderPaymentsSchema = z.object({
  by_merchant: z.boolean().nullish(),
  by_supplier: z.boolean().nullish(),
  by_date: z.boolean().nullish(),
  by_purchase_order: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  supplier_id: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  merchant_id: z.string().nullish(),
  purchase_order_id: z.string().nullish(),
  store_id: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  fetch_all: z.boolean().nullish(),
});

export const purchaseOrderPaymentSummarySchema = z.object({
  total_money: z.number(),
  total_due: z.number(),
  total_paid: z.number(),
  total_refunded: z.number(),
  total_cancelled_amount: z.number(),
  final_amount: z.number(),
  count: z.number(),
});

export const purchaseOrderEstimateStatusSchema = z.nativeEnum(
  PurchaseOrderEstimateStatus,
);

export const purchaseOrderEstimateMemberSchema = z.object({
  id: z.string(),
  name: z.string(),
  quantity_in_unit_package: z.number(),
  cost: z.number(),
  price: z.number(),
  possible_sales: z.number(),
  profit: z.number(),
});

export const purchaseOrderItemEstimateSchema = z.object({
  status: purchaseOrderEstimateStatusSchema,
  received_quantity: z.number(),
  unit_cost: z.number(),
  members: z.array(purchaseOrderEstimateMemberSchema),
  min_profit: z.number(),
  max_profit: z.number(),
  saved_at: z.string().nullish(),
  saved_by_id: z.string().nullish(),
  saved_by_name: z.string().nullish(),
});

export const savePurchaseOrderItemEstimateMemberSchema = z.object({
  id: z.string(),
  price: z.number(),
});

export const savePurchaseOrderItemEstimateSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  id: z.string(),
  item_id: z.string(),
  members: z.array(savePurchaseOrderItemEstimateMemberSchema),
  expiry_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD').refine((d) => new Date(`${d}T00:00:00Z`).toISOString().startsWith(d), 'Invalid calendar date').nullish(),
  updator_id: z.string(),
});

export const purchaseOrderItemFractionSchema = z.object({
  id: z.string(),
  parent_id: z.string(),
  quantity: z.number(),
  purchase_cost: z.number(),
  fraction: z.number(),
  name: z.string(),
  received: z.number(),
  cancelled: z.number(),
});

export const updatePurchaseOrderItemSchema = z.object({
  quantity: z.number(),
  id: z.string(),
  purchase_cost: z.number().nullish(),
  fractions: z.array(purchaseOrderItemFractionSchema).nullish(),
});

export const receivePurchaseOrderItemFractionSchema = z.object({
  quantity: z.number(),
  id: z.string(),
  parent_id: z.string(),
  fraction: z.number(),
});

export const receivePurchaseOrderItemSchema = z.object({
  quantity: z.number(),
  id: z.string(),
  cost: z.number(),
  fractions: z.array(receivePurchaseOrderItemFractionSchema).nullish(),
});

export const createPurchaseOrderSchema = z.object({
  purchase_date: z.string(),
  ordered_by: z.string(),
  note: z.string(),
  supplier_id: z.string(),
  items: z.array(updatePurchaseOrderItemSchema),
  store_id: z.string(),
  merchant_id: z.string(),
  shift_id: z.string().nullish(),
  idempotency_key: z.string().nullish(),
});

export const updatePurchaseOrderCommandSchema = z.nativeEnum(
  UpdatePurchaseOrderCommand,
);

export const refundItemSchema = z.object({
  id: z.string(),
  amount: z.number(),
  merchant_id: z.string(),
  store_id: z.string(),
  updator_id: z.string(),
});

export const updatePurchaseOrderSchema = z.object({
  store_id: z.string(),
  id: z.string(),
  items: z.array(updatePurchaseOrderItemSchema),
  command: updatePurchaseOrderCommandSchema,
  cancellations: z.array(cancelPurchaseOrderItemSchema).nullish(),
  refunds: z.array(refundItemSchema).nullish(),
  updator_id: z.string(),
  note: z.string().nullish(),
  shift_id: z.string().nullish(),
});

export const receivePurchaseOrderSchema = z.object({
  id: z.string(),
  items: z.array(receivePurchaseOrderItemSchema),
  creator_id: z.string(),
  store_id: z.string(),
  shift_id: z.string().nullish(),
  received_at: z.string().nullish(),
});

export const getAllPurchaseOrdersSchema = z.object({
  by_merchant: z.boolean().nullish(),
  by_supplier: z.boolean().nullish(),
  by_date: z.boolean().nullish(),
  by_payment_status: z.boolean().nullish(),
  by_purchase_status: z.boolean().nullish(),
  by_payment_status_and_date: z.boolean().nullish(),
  by_purchase_status_and_date: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  by_store_and_date: z.boolean().nullish(),
  supplier_id: z.string().nullish(),
  merchant_id: z.string(),
  cursor: z.string().nullish(),
  purchase_status: purchaseStatusSchema.nullish(),
  payment_status: purchaseOrderPaymentStatusSchema.nullish(),
  store_id: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  limit: z.number().nullish(),
});

export const getPurchaseOrderSchema = z.object({
  id: z.string(),
});

export const deletePurchaseOrderSchema = z.object({
  id: z.string(),
});

export const purchaseOrderPaymentDBItemSchema =
  purchaseOrderPaymentSchema.extend(dynamoDBItemSchema.shape);

export const reconcilePaymentFieldsResponseSchema = z.object({
  updated_count: z.number(),
  errors: z.array(z.string()),
});

export const supplierValuationPeriodMetricsSchema = z.object({
  total_money: z.number(),
  total_cancelled_amount: z.number(),
  final_amount: z.number(),
  total_paid: z.number(),
  total_refunded: z.number(),
  total_due: z.number(),
});

export const supplierValuationPerSupplierSchema = z.object({
  supplier_id: z.string(),
  supplier_name: z.string().nullish(),
  supplier_due_start: z.number(),
  supplier_due_end: z.number(),
  total_money: z.number(),
  total_cancelled_amount: z.number(),
  final_amount: z.number(),
  total_paid: z.number(),
  total_refunded: z.number(),
  total_due: z.number(),
  paid_in_period: z.number(),
  count: z.number(),
});

export const getSupplierValuationSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  start_date: z.string(),
  end_date: z.string(),
});

export const pOPaymentStoreSnapshotSchema = z.object({
  id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  supplier_id: z.string(),
  po_id: z.string(),
  total_money: z.number(),
  total_cancelled_amount: z.number(),
  final_amount: z.number(),
  total_paid: z.number(),
  total_refunded: z.number(),
  total_due: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const getStoreSnapshotAtTimeSchema = z.object({
  store_id: z.string(),
  datetime: z.string(),
  po_id: z.string().nullish(),
  supplier_id: z.string().nullish(),
});

export const getSupplierSnapshotsInRangeSchema = z.object({
  supplier_id: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  po_id: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const getSupplierSnapshotAtTimeSchema = z.object({
  supplier_id: z.string(),
  datetime: z.string(),
  po_id: z.string().nullish(),
});

export const getStoreSnapshotsInRangeSchema = z.object({
  store_id: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  po_id: z.string().nullish(),
  supplier_id: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const pOPaymentSupplierSnapshotSchema = z.object({
  id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  supplier_id: z.string(),
  po_id: z.string(),
  total_money: z.number(),
  total_cancelled_amount: z.number(),
  final_amount: z.number(),
  total_paid: z.number(),
  total_refunded: z.number(),
  total_due: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const pOPaymentStoreSnapshotDBItemSchema =
  pOPaymentStoreSnapshotSchema.extend(dynamoDBItemSchema.shape);

export const pOPaymentSupplierSnapshotDBItemSchema =
  pOPaymentSupplierSnapshotSchema.extend(dynamoDBItemSchema.shape);

export const pOPaymentStoreSnapshotPageSchema = z.object({
  snapshots: z.array(pOPaymentStoreSnapshotSchema),
  cursor: z.union([z.string(), z.undefined()]).nullable(),
  count: z.number(),
});

export const pOPaymentSupplierSnapshotPageSchema = z.object({
  snapshots: z.array(pOPaymentSupplierSnapshotSchema),
  cursor: z.union([z.string(), z.undefined()]).nullable(),
  count: z.number(),
});

export const purchaseOrderReceiveEventSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  supplier_id: z.string(),
  po_id: z.string(),
  item_id: z.string(),
  product_name: z.string(),
  quantity_received: z.number(),
  cost: z.number(),
  value: z.number(),
  creator_id: z.string(),
  creator_name: z.string(),
  shift_id: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const purchaseOrderReceiveEventDBItemSchema =
  purchaseOrderReceiveEventSchema.extend(dynamoDBItemSchema.shape);

export const purchaseOrderReceiveEventPageSchema = z.object({
  receive_events: z.array(purchaseOrderReceiveEventSchema),
  cursor: z.union([z.string(), z.undefined()]).nullable(),
  count: z.number(),
});

export const getPurchaseOrderReceiveEventsSchema = z.object({
  merchant_id: z.string(),
  by_po: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
  po_id: z.string().nullish(),
  store_id: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const getSnapshotAtTimeSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  supplier_id: z.string().nullish(),
  datetime: z.string(),
  po_id: z.string().nullish(),
});

export const getSnapshotsInRangeSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  supplier_id: z.string().nullish(),
  start_date: z.string(),
  end_date: z.string(),
  po_id: z.string().nullish(),
});

export const backfillPOPaymentSnapshotsRequestSchema = z.object({
  purchase_order_id: z.string(),
  store_id: z.string(),
});

export const paymentSnapshotBackfillResultSchema = z.object({
  payment_id: z.string(),
  payment_created_at: z.string(),
  reason: z.string().nullish(),
});

export const backfillPOPaymentSnapshotsResponseSchema = z.object({
  po_id: z.string(),
  store_id: z.string(),
  supplier_id: z.string(),
  total_payments: z.number(),
  created: z.array(paymentSnapshotBackfillResultSchema),
  skipped: z.array(paymentSnapshotBackfillResultSchema),
  failed: z.array(paymentSnapshotBackfillResultSchema),
  validation_warning: z.string().nullish(),
});

export const reasonMissingSchema = z.nativeEnum(ReasonMissing);

export const receiptStatusSchema = z.nativeEnum(ReceiptStatus);

export const missingItemSchema = z.object({
  quantity: z.number(),
  reason: reasonMissingSchema,
  employee_id: z.string(),
  employee_name: z.string(),
  item_id: z.string(),
});

export const cartItemSchema = timestampsSchema.extend({
  item_id: z.string(),
  item_name: z.string(),
  quantity: z.number(),
  missing: missingItemSchema,
  is_confirmed: z.boolean(),
});

export const employeeSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const receiptHistoryItemTypeSchema = z.nativeEnum(
  ReceiptHistoryItemType,
);

export const historyPaymentTypeSchema = z.object({
  payment_type_id: z.string(),
  payment_type_name: z.string(),
  payment_type: paymentMethodTypeSchema,
  amount: z.number(),
  total_given: z.number().nullish(),
  change: z.number().nullish(),
});

export const saleReceiptHistoryItemSchema = z.object({
  history_item_type: z.literal(ReceiptHistoryItemType.SALE),
  event: z.string(),
  value: z.number(),
  remaining_debt: z.number(),
  payments: z.array(historyPaymentTypeSchema),
  comment: z.string().nullish(),
  date: z.string(),
  receipt_number: z.string(),
});

export const debtPaymentHistoryItemSchema = z.object({
  history_item_type: z.literal(ReceiptHistoryItemType.DEBT_PAYMENT),
  event: z.string(),
  paid_amount: z.number(),
  remaining_debt: z.number(),
  payment_id: z.string(),
  comment: z.string().nullish(),
  date: z.string(),
  received_by: employeeSummarySchema,
});

export const refundReceiptHistoryItemSchema = z.object({
  history_item_type: z.literal(ReceiptHistoryItemType.REFUND),
  event: z.string(),
  refund_receipt_number: z.string(),
  refunded_payments: z.array(historyPaymentTypeSchema),
  amount_refunded: z.number(),
  comment: z.string().nullish(),
  remaining_debt: z.number(),
  date: z.string(),
  refunded_by: employeeSummarySchema,
});

export const receiptHistoryUpdateCustomerItemSchema = z.object({
  history_item_type: z.literal(ReceiptHistoryItemType.UPDATE_CUSTOMER),
  event: z.string(),
  previous_customer_id: z.string(),
  new_customer_id: z.string(),
  date: z.string(),
  updated_by: employeeSummarySchema,
});

export const receiptHistoryCommentItemSchema = z.object({
  history_item_type: z.literal(ReceiptHistoryItemType.COMMENT),
  event: z.string(),
  comment: z.string(),
  date: z.string(),
  commented_by: employeeSummarySchema,
});

export const receiptDiscountSchema = discountSchema.extend({
  money_amount: z.number(),
});

export const confirmedQuantityTracebackSchema = timestampsSchema.extend({
  quantity: z.number(),
  confirmed_by: z.string(),
  note: z.string(),
});

export const missingItemTracebackSchema = timestampsSchema.extend({
  quantity: z.number(),
  reported_by: z.string(),
  note: z.string(),
});

export const receiptTypeSchema = z.nativeEnum(ReceiptType);

export const confirmationTypeSchema = z.nativeEnum(ConfirmationType);

export const commentSchema = timestampsSchema.extend({
  comment: z.string(),
  employee_id: z.string(),
  employee_name: z.string(),
});

export const clientSchema = timestampsSchema.extend({
  id: z.string(),
  name: z.string(),
  phone_number: z.string(),
  email: z.string().nullish(),
  address: z.string().nullish(),
  business_name: z.string().nullish(),
});

export const customerUpdateTracebackSchema = timestampsSchema.extend({
  customer: z.string(),
  updator: z.string(),
  note: z.string(),
});

export const receiptFailedChecksSchema = z.object({
  note: z.string(),
  check_type: z.any(),
  created_at: z.string(),
});

export const thresholdSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    min_quantity: z.number(),
    min_total_money: z.number(),
    updated_by: z.array(employeeSummarySchema),
    store_id: z.string(),
    merchant_id: z.string(),
  });

export const getReceiptsSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  receipt_status: receiptStatusSchema.nullish(),
  customer_id: z.string().nullish(),
  store_id: z.string().nullish(),
  confirmation_type: confirmationTypeSchema.nullish(),
  pos_device_id: z.string().nullish(),
  by_status: z.boolean().nullish(),
  by_date_range: z.boolean().nullish(),
  by_date_range_and_status: z.boolean().nullish(),
  by_customer: z.boolean().nullish(),
  by_customer_and_date_range: z.boolean().nullish(),
  by_date_range_and_status_and_missing: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
  by_store_and_status: z.boolean().nullish(),
  by_store_and_date_range_and_status: z.boolean().nullish(),
  by_store_and_confirmation_type: z.boolean().nullish(),
  by_pos_device: z.boolean().nullish(),
  sort_order: sortOrderSchema.nullish(),
  with_debt: z.boolean().nullish(),
});

export const updateReceiptCommandSchema = z.nativeEnum(UpdateReceiptCommand);

export const updateReceiptSchema = z.object({
  receipt_number: z.string(),
  merchant_id: z.string(),
  command: updateReceiptCommandSchema,
  waiter: employeeSummarySchema.nullish(),
  comments: z.array(commentSchema).nullish(),
  receipt_status: z
    .object({
      receipt_status: receiptStatusSchema,
      updator: employeeSummarySchema,
    })
    .nullish(),
  customer: z
    .object({
      customer_id: z.string(),
      updator_id: z.string(),
    })
    .nullish(),
  shift_id: z.string().nullish(),
});

export const confirmReceiptSchema = z.object({
  receipt_number: z.string(),
  updator: employeeSummarySchema,
  confirmation_type: confirmationTypeSchema,
  command: updateReceiptCommandSchema,
  merchant_id: z.string(),
});

export const thresholdItemSchema = timestampsSchema
  .extend(thresholdSchema.shape)
  .extend({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const createThresholdSchema = z.object({
  min_quantity: z.number(),
  min_total_money: z.number(),
  updated_by: employeeSummarySchema,
  store_id: z.string(),
  merchant_id: z.string(),
});

export const updateThresholdSchema = z.object({
  min_quantity: z.number().nullish(),
  min_total_money: z.number().nullish(),
  updated_by: employeeSummarySchema,
  store_id: z.string(),
  merchant_id: z.string(),
});

export const receiptEventsSchema = z.nativeEnum(ReceiptEvents);

export const getReceiptEventsSchema = z.object({
  merchant_id: z.string(),
  type: receiptTypeSchema.nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  count: z.number().nullish(),
});

export const getReceiptEventSchema = z.object({
  request_id: z.string(),
  merchant_id: z.string(),
});

export const salesReportSchema = timestampsSchema.extend({
  gross_sales: z.number(),
  refunds: z.number(),
  discounts: z.number(),
  cost_of_products: z.number(),
  expenses: z.number(),
  entity_type: entityTypesSchema,
  sale_receipt_count: z.number(),
  refund_receipt_count: z.number(),
  expense_count: z.number(),
  source_entity_id: z.string(),
  source_entity_type: entityTypesSchema,
  version: z.number(),
  merchant_id: z.string(),
  store_id: z.string(),
  shift_id: z.string().nullish(),
});

export const storeSalesReportSchema = salesReportSchema.extend({
  store_id: z.string(),
});

export const employeeSalesReportSchema = salesReportSchema.extend({
  employee_id: z.string(),
  employee_name: z.string(),
});

export const productSalesReportSchema = salesReportSchema.extend({
  product_id: z.string(),
  quantity: z.number(),
  product_name: z.string(),
  sku: z.string(),
});

export const salesReportDBItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const storeSalesReportDBItemSchema = storeSalesReportSchema.extend(
  salesReportDBItemSchema.shape,
);

export const employeeSalesReportDBItemSchema = employeeSalesReportSchema.extend(
  salesReportDBItemSchema.shape,
);

export const productSalesReportDBItemSchema = productSalesReportSchema.extend(
  salesReportDBItemSchema.shape,
);

export const salesReportExtensionsSchema = z.object({
  net_sales: z.number(),
  gross_profit: z.number(),
  net_profit: z.number(),
  gross_margin: z.number(),
  net_margin: z.number(),
});

export const getSalesReportSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  products: z.array(z.string()).nullish(),
  from: z.string().nullish(),
  to: z.string().nullish(),
  date: z.string().nullish(),
  by_date: z.boolean().nullish(),
  by_date_range: z.boolean().nullish(),
  by_products_and_date: z.boolean().nullish(),
  by_products_and_date_range: z.boolean().nullish(),
  include_employees: z.boolean().nullish(),
  include_products: z.boolean().nullish(),
});

export const getReportEventsSchema = z.object({
  merchant_id: z.string(),
  by_source_entity: z.boolean().nullish(),
  source_entity_type: entityTypesSchema.nullish(),
  source_entity_id: z.string().nullish(),
});

export const reportEventsPageSchema = z.object({
  events: z.union([
    z.array(productSalesReportSchema),
    z.array(storeSalesReportSchema),
    z.array(employeeSalesReportSchema),
  ]),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const getInventoryValueSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  date: z.string().nullish(),
});

export const getProductsInventoryValueSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  date: z.string(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const productInventoryValueSchema = z.object({
  price: z.number(),
  cost: z.number(),
  inventory_value: z.number(),
  retail_value: z.number(),
  potential_profit: z.number(),
  margin: z.number(),
  created_at: z.string(),
  product_id: z.string(),
  product_name: z.string(),
  store_id: z.string(),
  in_stock: z.number(),
  merchant_id: z.string(),
  pending_quantity: z.number().nullish(),
  pending_value: z.number().nullish(),
  blocked_quantity: z.number().nullish(),
  blocked_value: z.number().nullish(),
});

export const productInventoryValuePageSchema = z.object({
  inventory_values: z.array(productInventoryValueSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const storeInventoryValueSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  inventory_value: z.number(),
  potential_profit: z.number(),
  retail_value: z.number(),
  margin: z.number(),
  created_at: z.string(),
  pending_value: z.number().nullish(),
  blocked_value: z.number().nullish(),
});

export const merchantInventoryValueSchema = z.object({
  merchant_id: z.string(),
  merchant_name: z.string(),
  inventory_value: z.number(),
  potential_profit: z.number(),
  retail_value: z.number(),
  margin: z.number(),
  created_at: z.string(),
});

export const storeValueSnapshotDBItemSchema = storeInventoryValueSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const getStoreInventoryValueDateRangeSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  from: z.string(),
  to: z.string(),
  max_points: z.number().nullish(),
});

export const storeInventoryValueDateRangePageSchema = z.object({
  inventory_values: z.array(storeInventoryValueSchema),
  count: z.number(),
});

export const updateStoreInventorySQSMessageSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
});

export const inventoryValueChangeSQSMessageSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  inventory_value_delta: z.number().nullish(),
  retail_value_delta: z.number().nullish(),
});

export const salesReportIntervalSchema = z.nativeEnum(SalesReportInterval);

export const getSalesReportByDateRangeIntervalOptionsSchema = z.object({
  entityType: entityTypesSchema,
  entityId: z.string(),
  from: z.string(),
  to: z.string(),
  interval: salesReportIntervalSchema.nullish(),
  is_cumulative: z.boolean().nullish(),
});

export const inventoryValueExportTriggerSchema = z.union([
  z.literal('manual'),
  z.literal('scheduled'),
]);

export const generateInventoryValueExportRequestSchema = z.object({
  date: z.string().nullish(),
  requested_by: z.string().nullish(),
});

export const inventoryValueExportRecordSchema = z.object({
  key: z.string(),
  file_name: z.string(),
  job_id: z.string(),
  requested_at: z.string(),
  triggered_by: inventoryValueExportTriggerSchema,
  download_url: z.string(),
  requested_by: z.string().nullish(),
  size_in_bytes: z.number().nullish(),
  last_modified: z.string().nullish(),
  pdf_key: z.string().nullish(),
  pdf_download_url: z.string().nullish(),
  pdf_size_in_bytes: z.number().nullish(),
});

export const generateInventoryValueExportJobResponseSchema = z.object({
  job_id: z.string(),
  requested_at: z.string(),
  triggered_by: inventoryValueExportTriggerSchema,
  csv_key: z.string(),
  requested_by: z.string().nullish(),
});

export const inventoryValueExportsResponseSchema = z.object({
  exports: z.array(inventoryValueExportRecordSchema),
  next_cursor: z.string().nullish(),
});

export const inventoryValueExportSQSMessageSchema = z.object({
  job_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  triggered_by: inventoryValueExportTriggerSchema,
  requested_at: z.string(),
  date: z.string(),
  requested_by: z.string().nullish(),
});

export const salesAgentSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    phone_number: z.string(),
    email: z.string().nullish(),
    store_ids: z.array(z.string()),
    notes: z.string().nullish(),
  });

export const salesAgentPageSchema = z.object({
  sales_agents: z.array(salesAgentSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const createSalesAgentSchema = z.object({
  name: z.string(),
  phone_number: z.string(),
  email: z.string().nullish(),
  store_ids: z.array(z.string()).nullish(),
  notes: z.string().nullish(),
});

export const updateSalesAgentSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  phone_number: z.string().nullish(),
  email: z.string().nullish(),
  notes: z.string().nullish(),
  add_store_ids: z.array(z.string()).nullish(),
  remove_store_ids: z.array(z.string()).nullish(),
});

export const getSalesAgentsSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  store_id: z.string().nullish(),
});

export const salesAgentDBItemSchema = salesAgentSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const fullScreenSchema = z.object({
  mustBeFullScreen: z.boolean(),
  isFullScreen: z.boolean(),
});

export const breakdownItemSchema = z.object({
  name: z.string(),
  fraction: z.number(),
  units: z.number(),
  id: z.string(),
});

export const webWorkerActionsSchema = z.nativeEnum(WebWorkerActions);

export const inventoryLevelSchema = z.object({
  variant_id: z.string(),
  store_id: z.string(),
  in_stock: z.number(),
  updated_at: z.string(),
  update_id: z.string().nullish(),
});

export const inventoryLevelsOutputSchema = z.object({
  inventory_levels: z.array(inventoryLevelSchema),
});

export const inventoryLevelPropsSchema = z.object({
  variant_id: z.string(),
  store_id: z.string(),
  stock_after: z.number(),
});

export const inventoryLevelsPropsSchema = z.object({
  inventory_levels: z.array(inventoryLevelPropsSchema),
});

export const shopAndSmileImagePropsSchema = z.object({
  image_url: z.string(),
  item_id: z.string(),
});

export const shopAndSmileOkResponseSchema = z.object({
  OK: z.boolean(),
  message: z.string().nullish(),
});

export const backupDtoSchema = z.object({
  sku: z.string(),
  name: z.string(),
  price: z.number(),
  inventory: z.number(),
  image_s3_key: z.string(),
  old_image_url: z.string(),
  merchant_id: z.string(),
  trigger_image_backup: z.boolean(),
  new_image_url: z.string().nullish(),
});

export const backupItemSchema = z.object({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  EntityType: entityTypesSchema,
  sku: z.string(),
  name: z.string(),
  price: z.number(),
  inventory: z.number(),
  image_s3_key: z.string(),
  merchant_id: z.string(),
  old_image_url: z.string(),
  trigger_image_backup: z.boolean(),
  new_image_url: z.string().nullish(),
});

export const merchantInfoSchema = z.object({
  id: z.string(),
  business_name: z.string(),
  email: z.string(),
  country: z.string(),
  currency: currencySchema,
  created_at: z.string(),
});

export const writeResponseSchema = z.object({
  message: z.string(),
  isSuccessful: z.boolean(),
});

export const gsiDescriptorsSchema = z.nativeEnum(GSI_DESCRIPTORS);

export const relationshipTypesSchema = z.nativeEnum(RelationshipTypes);

export const defaultPricingTypeSchema = z.nativeEnum(DefaultPricingType);

export const formSchema = z.nativeEnum(Form);

export const colorSchema = z.nativeEnum(Color);

export const componentSchema = z.object({
  variant_id: z.string(),
  quantity: z.number(),
});

export const updateAvailabilityPropsStoreSchema = z.object({
  store_id: z.string(),
  available_for_sale: z.boolean(),
});

export const updateAvailabilityPropsVariantSchema = z.object({
  variant_id: z.string(),
  item_id: z.string(),
  stores: z.array(updateAvailabilityPropsStoreSchema),
});

export const authUserSchema = z.union([
  customerUserAttributesSchema,
  merchantUserAttributesSchema,
  adminUserAttributesSchema,
]);

export const errorCodesSchema = z.nativeEnum(ErrorCodes);

export const totalMoneyRangeSchema = z.object({
  to: z.number(),
  from: z.number(),
});

export const eventBusDtoSchema = z.object({
  data: z.any(),
  metadata: z.record(z.unknown()),
});

export const uploadImageToItemPropsSchema = z.object({
  item_id: z.string(),
  image_url: z.string(),
});

export const connectionSchema = z.object({
  entityId: z.string(),
  entityType: entityTypesSchema,
  connectionId: z.string(),
  connected: z.boolean(),
  stage: z.string(),
  domainName: z.string(),
});

export const connectionItemSchema = connectionSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
});

export const sSMParameterConfigSchema = z.object({
  path: z.string(),
  outputKey: z.string(),
  description: z.string().nullish(),
  secure: z.boolean().nullish(),
});

export const userRoleSchema = z.nativeEnum(UserRole);

export const paymentNameSchema = z.nativeEnum(PaymentName);

export const userSchema = z.object({
  name: z.string(),
  surname: z.string(),
  phonenumber: z.string(),
  code: z.string(),
  user_id: z.string(),
  role: userRoleSchema,
  auth_type: authTypeSchema.nullish(),
  is_number_verified: z.boolean().nullish(),
});

export const createUserPropsSchema = z.object({
  name: z.string(),
  surname: z.string(),
  phonenumber: z.string().nullish(),
  code: z.string(),
  role: userRoleSchema,
  merchant_id: z.string(),
  stores: z.array(z.string()),
});

export const receiptQueryParamsSchema = paginationParamsSchema.extend({
  receipt_numbers: z.string().nullish(),
  since_receipt_number: z.string().nullish(),
  before_receipt_number: z.string().nullish(),
  store_id: z.string().nullish(),
  order: z.string().nullish(),
  updated_at_min: z.string().nullish(),
  updated_at_max: z.string().nullish(),
  created_at_min: z.string().nullish(),
  created_at_max: z.string().nullish(),
});

export const userStoreSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  user_id: z.string(),
});

export const cognitoStoresAttributeSchema = timestampsSchema.extend({
  stores: z.array(userStoreSchema),
});

export const lambdaFunctionLoggingStatusSchema = z.object({
  name: z.string(),
  arn: z.string(),
  loggingAllowed: z.boolean(),
  loggingSource: z.union([
    z.literal('explicit_env'),
    z.literal('stage_default'),
    z.literal('unknown'),
  ]),
  rawLoggingValue: z.string().nullable(),
  stage: z.string().nullish(),
});

export const lambdaFunctionsListResponseSchema = z.object({
  stage: z.string().nullish(),
  total: z.number(),
  retrievedAt: z.string(),
  functions: z.array(lambdaFunctionLoggingStatusSchema),
});

export const bulkLambdaLoggingRequestSchema = z.object({
  functions: z.array(z.string()),
  allow: z.boolean(),
});

export const bulkLambdaLoggingResponseSchema = z.object({
  allow: z.boolean(),
  requestedCount: z.number(),
  updatedCount: z.number(),
  failedCount: z.number(),
  updated: z.array(lambdaFunctionLoggingStatusSchema),
  failed: z.array(
    z.object({
      identifier: z.string(),
      error: z.string(),
    }),
  ),
  status: z.union([z.literal('completed'), z.literal('completed_with_errors')]),
});

export const toggleLoggingResponseSchema = z.object({
  allow: z.boolean(),
  updatedCount: z.number(),
  failedCount: z.number(),
  updatedFunctions: z.array(z.string()),
  failedFunctions: z.array(
    z.object({
      name: z.string(),
      error: z.string(),
    }),
  ),
  status: z.union([z.literal('completed'), z.literal('completed_with_errors')]),
});

export const liteAppUrlSettingsSchema = z.object({
  stage: z.string(),
  url: z.string().nullable(),
  version: z.number().nullable(),
  lastModifiedAt: z.string().nullable(),
});

export const updateLiteAppUrlRequestSchema = z.object({
  url: z.string(),
});

export const appBuildSchema = z.object({
  version: z.string(),
  releaseDate: z.string(),
  platform: z.string(),
  downloadUrl: z.string(),
  archiveUrl: z.string(),
  size: z.string(),
  description: z.string(),
  prerelease: z.boolean(),
});

export const appBuildsResponseSchema = z.object({
  android: z.array(appBuildSchema),
  windows: z.array(appBuildSchema),
  lite: z
    .object({
      android: z.array(appBuildSchema),
      windows: z.array(appBuildSchema),
    })
    .nullish(),
  backoffice: z
    .object({
      android: z.array(appBuildSchema),
    })
    .nullish(),
});

export const androidVersionInfoSchema = z.object({
  apkSize: z.string().nullish(),
  zipSize: z.string().nullish(),
  lastModified: z.date(),
});

export const windowsVersionInfoSchema = z.object({
  exeSize: z.string().nullish(),
  zipSize: z.string().nullish(),
  lastModified: z.date(),
});

export const releaseVersionSchema = z.object({
  version: z.string(),
  releaseDate: z.string(),
  platform: z.string(),
});

export const releasesVersionsResponseSchema = z.object({
  android: z.array(releaseVersionSchema),
  windows: z.array(releaseVersionSchema),
});

export const shiftCommandTypeSchema = z.nativeEnum(ShiftCommandType);

export const closeShiftStepEventSchema = z.nativeEnum(CloseShiftStepEvent);

export const shiftStatusSchema = z.nativeEnum(ShiftStatus);

export const reconciliationStatusSchema = z.nativeEnum(ReconciliationStatus);

export const shiftReportPaymentMethodSchema = timestampsSchema.extend({
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  opening_balance: z.number(),
  note: z.union([z.string(), z.undefined()]).nullish(),
});

export const shiftReportPaymentMethodWithReconciliationSchema =
  shiftReportPaymentMethodSchema.extend({
    reconciliation_status: reconciliationStatusSchema,
    reconciliation_note: z
      .union([z.string(), z.undefined()])
      .nullish()
      .nullable(),
    total_inflows: z.number(),
    total_outflows: z.number(),
    expected_balance: z.number(),
    actual_balance: z.number(),
    difference: z.number(),
    verified_by: z.union([z.string(), z.undefined()]).nullish(),
    verified_by_name: z
      .union([z.string(), z.undefined()])
      .nullish()
      .nullable(),
    verified_user_type: entityTypesSchema.nullish(),
  });

export const shiftCommentSchema = timestampsSchema.extend({
  id: z.string(),
  shift_id: z.string(),
  user_id: z.string(),
  user_name: z.string(),
  user_type: entityTypesSchema,
  comment: z.string(),
});

export const closingAuditTrailActorSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: entityTypesSchema,
});

export const closingAuditTrailExpectedBalanceSchema = z.object({
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  expected_amount: z.number(),
});

export const closingAuditTrailDifferenceSchema = z.object({
  payment_method_id: z.string(),
  difference: z.number(),
  reconciliation_status: reconciliationStatusSchema,
});

export const paymentBalanceSchema = z.object({
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  balance: z.number(),
  note: z.union([z.string(), z.undefined()]).nullish(),
});

export const recordCloseAuditEntrySchema = z.object({
  event: closeShiftStepEventSchema,
  actor: closingAuditTrailActorSchema,
  entered_balances: z.array(paymentBalanceSchema),
  client_step_index: z.number(),
  note: z.union([z.string(), z.undefined()]).nullish(),
});

export const attemptToCloseShiftSchema = z.object({
  closing_balances: z.array(paymentBalanceSchema),
  closing_note: z.union([z.string(), z.undefined()]).nullish(),
  closed_by: z.string(),
  closed_by_name: z.string(),
  closed_user_type: entityTypesSchema,
});

export const createShiftSchema = z.object({
  pos_id: z.union([z.string(), z.undefined()]).nullish(),
  opening_balances: z.array(paymentBalanceSchema),
  opening_note: z.union([z.string(), z.undefined()]).nullish(),
  merchant_id: z.string(),
  store_id: z.string(),
  opened_by: z.string(),
  opened_by_name: z.string(),
  opened_user_type: entityTypesSchema,
});

export const instantCloseShiftSchema = z.object({
  closing_balances: z.array(paymentBalanceSchema),
  closed_by: z.string(),
  closed_by_name: z.string(),
  closed_user_type: entityTypesSchema,
  reason: z.string(),
});

export const addShiftCommentSchema = z.object({
  shift_id: z.string(),
  user_id: z.string(),
  user_name: z.string(),
  user_type: entityTypesSchema,
  comment: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
});

export const getShiftsSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  cursor: z.union([z.string(), z.undefined()]).nullish(),
  limit: z.number().nullish(),
  status: shiftStatusSchema.nullish(),
  opened_by: z.union([z.string(), z.undefined()]).nullish(),
  opened_user_type: entityTypesSchema.nullish(),
  pos_id: z.union([z.string(), z.undefined()]).nullish(),
  from: z.union([z.string(), z.undefined()]).nullish(),
  to: z.union([z.string(), z.undefined()]).nullish(),
  by_date_range: z.boolean().nullish(),
  by_status: z.boolean().nullish(),
  by_status_and_date_range: z.boolean().nullish(),
  by_user: z.boolean().nullish(),
  by_user_and_date_range: z.boolean().nullish(),
  by_pos: z.boolean().nullish(),
  by_pos_and_date_range: z.boolean().nullish(),
  by_store: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
});

export const shiftReportTriggerSchema = z.union([
  z.literal('manual'),
  z.literal('auto-on-close'),
]);

export const shiftReportRecordSchema = z.object({
  key: z.string(),
  file_name: z.string(),
  shift_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  store_name: z.string(),
  employee_name: z.string(),
  shift_status: shiftStatusSchema,
  closed_at: z.string(),
  requested_at: z.string(),
  triggered_by: shiftReportTriggerSchema,
  download_url: z.string(),
  requested_by: z.union([z.string(), z.undefined()]).nullish(),
  size_in_bytes: z.number().nullish(),
  last_modified: z.string().nullish(),
});

export const shiftReportsResponseSchema = z.object({
  reports: z.array(shiftReportRecordSchema),
  next_cursor: z.string().nullish(),
});

export const generateShiftReportRequestSchema = z.object({
  force: z.boolean().nullish(),
});

export const generateShiftReportResponseSchema = z.object({
  record: shiftReportRecordSchema,
  created: z.boolean(),
});

export const shiftEventsSchema = z.nativeEnum(ShiftEvents);

export const shiftClosedEventDetailSchema = z.object({
  shift_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  status: shiftStatusSchema,
  closed_at: z.string(),
  closed_by: z.union([z.string(), z.undefined()]).nullish(),
  closed_by_name: z.union([z.string(), z.undefined()]).nullish(),
});

export const stockOrderStatusSchema = z.nativeEnum(StockOrderStatus);

export const stockOrderLineSchema = z.object({
  line_id: z.string(),
  product_id: z.string(),
  product_name: z.string(),
  requested: z.number(),
  allocated: z.number(),
  cancelled: z.number(),
  entered_quantity: z.number().nullish(),
  entered_fraction_id: z.string().nullish(),
  fraction_factor: z.number().nullish(),
});

export const stockOrderAllocationSchema = z.object({
  allocation_id: z.string(),
  source_type: z.literal('STORE'),
  source_store_id: z.string(),
  transfer_id: z.string(),
  lines: z.array(
    z.object({
      line_id: z.string(),
      quantity: z.number(),
    }),
  ),
  request_id: z.string().nullish(),
  created_at: z.string(),
  created_by_id: z.string(),
  created_by_name: z.string(),
});

export const stockOrderRevisionSchema = z.object({
  revision_id: z.string(),
  request_id: z.string().nullish(),
  revised_at: z.string(),
  revised_by_id: z.string(),
  revised_by_name: z.string(),
  reason: z.string(),
  lines: z.array(
    z.object({
      line_id: z.string(),
      product_id: z.string(),
      product_name: z.string(),
      old_requested: z.number(),
      new_requested: z.number(),
    }),
  ),
});

export const stockOrderSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    reference: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    status: stockOrderStatusSchema,
    lines: z.array(stockOrderLineSchema),
    allocations: z.array(stockOrderAllocationSchema),
    note: z.string().nullish(),
    actionable_since: z.string().nullish(),
    revisions: z.array(stockOrderRevisionSchema).nullish(),
    expires_at: z.string().nullish(),
    remind_at: z.string().nullish(),
    reminded_at: z.string().nullish(),
    expired_at: z.string().nullish(),
    ageing_done_at: z.string().nullish(),
    balance_closed_at: z.string().nullish(),
    balance_closed_by_id: z.string().nullish(),
    balance_closed_by_name: z.string().nullish(),
    balance_close_reason: z.string().nullish(),
    cancel_requested_at: z.string().nullish(),
    cancelled_at: z.string().nullish(),
    cancel_reason: z.string().nullish(),
    created_by_id: z.string(),
    created_by_name: z.string(),
  });

export const createStockOrderLineSchema = z.object({
  product_id: z.string(),
  quantity: z.number().finite().positive(),
  entered_quantity: z.number().nullish(),
  entered_fraction_id: z.string().nullish(),
});

export const createStockOrderSchema = z.object({
  store_id: z.string(),
  lines: z.array(createStockOrderLineSchema).min(1).max(200),
  note: z.string().trim().max(500).nullish(),
});

export const planStockOrderAllocationSchema = z.object({
  source_store_id: z.string(),
  lines: z.array(
    z.object({
      line_id: z.string(),
      quantity: z.number(),
    }),
  ),
});

export const planStockOrderSchema = z.object({
  allocations: z.array(planStockOrderAllocationSchema).min(1).max(20),
});

export const reviseStockOrderSchema = z.object({
  reason: z.string().trim().min(1).max(500),
  lines: z.array(z.object({ line_id: z.string(), requested: z.number().finite().nonnegative() })).max(200).nullish(),
  add_lines: z.array(createStockOrderLineSchema).max(200).nullish(),
});

export const cancelStockOrderSchema = z.object({
  reason: z.string().trim().min(1).max(500),
});

export const transferLogisticsStatusSchema = z.nativeEnum(
  TransferLogisticsStatus,
);

export const transferReconciliationStatusSchema = z.nativeEnum(
  TransferReconciliationStatus,
);

export const transferValuationStatusSchema = z.nativeEnum(
  TransferValuationStatus,
);

export const transferOverallStatusSchema = z.nativeEnum(TransferOverallStatus);

export const transferCustodySchema = z.nativeEnum(TransferCustody);

export const transferUnresolvedCustodySchema = z.object({
  rejected_awaiting_return: transferCustodySchema.nullish(),
  missing_awaiting_settlement: transferCustodySchema.nullish(),
  no_space_awaiting_redirect: transferCustodySchema.nullish(),
  return_shortage_awaiting_settlement: transferCustodySchema.nullish(),
});

export const transferUnresolvedSchema = z.object({
  rejected_awaiting_return: z.number(),
  missing_awaiting_settlement: z.number(),
  no_space_awaiting_redirect: z.number(),
  return_shortage_awaiting_settlement: z.number(),
});

export const transferExtraResolutionSchema = z.nativeEnum(
  TransferExtraResolution,
);

export const transferLinePriceApprovalSchema = z.object({
  price: z.number(),
  cost: z.number().nullish(),
  valuation_adjustment: z.number().nullish(),
  price_write_error: z.string().nullish(),
});

export const stockOperationIntentStepSchema = z.nativeEnum(
  StockOperationIntentStep,
);

export const stockOperationIntentStatusSchema = z.nativeEnum(
  StockOperationIntentStatus,
);

export const stockOperationIntentSchema = z.object({
  operation_id: z.string(),
  line_id: z.string(),
  step: stockOperationIntentStepSchema,
  status: stockOperationIntentStatusSchema,
  store_id: z.string(),
  product_id: z.string(),
  quantity: z.number(),
  reserved_quantity: z.number().nullish(),
  unit_cost: z.number().nullish(),
  to_bucket: stockBucketSchema.nullish(),
  carried_unit_cost: z.number().nullish(),
  attempts: z.number(),
  created_at: z.string(),
  finalized_at: z.string().nullish(),
  result_unit_cost: z.number().nullish(),
});

export const transferPreparationRecordSchema = z.object({
  prepared_at: z.string(),
  prepared_by_id: z.string(),
  prepared_by_name: z.string(),
});

export const transferDispatchRecordSchema = z.object({
  dispatched_at: z.string(),
  dispatched_by_id: z.string(),
  dispatched_by_name: z.string(),
  driver_name: z.string().nullish(),
  vehicle_plate: z.string().nullish(),
  signature_attachment_ids: z.array(z.string()).nullish(),
});

export const transferReceiptRecordSchema = z.object({
  received_at: z.string(),
  received_by_id: z.string(),
  received_by_name: z.string(),
  note: z.string().nullish(),
  signature_attachment_ids: z.array(z.string()).nullish(),
});

export const transferSettlementRecordSchema = z.object({
  kind: z.union([
    z.literal('SEND_BACK'),
    z.literal('RETURN_CHECK'),
    z.literal('SETTLE'),
    z.literal('REDIRECT'),
  ]),
  at: z.string(),
  by_id: z.string(),
  by_name: z.string(),
  note: z.string().nullish(),
  child_transfer_id: z.string().nullish(),
  request_id: z.string().nullish(),
  signature_attachment_ids: z.array(z.string()).nullish(),
  lines: z.array(
    z.record(z.union([z.number(), z.string()])).and(
      z.object({
        line_id: z.string(),
      }),
    ),
  ),
});

export const transferPriceApprovalRecordSchema = z.object({
  approved_at: z.string(),
  approved_by_id: z.string(),
  approved_by_name: z.string(),
});

export const inTransitTransferSchema = z.object({
  transfer_id: z.string(),
  reference: z.string(),
  source_store_id: z.string(),
  destination_store_id: z.string(),
  overall_status: transferOverallStatusSchema,
  dispatched_at: z.string().nullish(),
  products: z.number(),
  units: z.number(),
  value: z.number().nullish(),
});

export const inTransitSideSchema = z.object({
  units: z.number(),
  value: z.number().nullish(),
  transfers: z.array(inTransitTransferSchema),
});

export const storeInTransitSchema = z.object({
  store_id: z.string(),
  as_of: z.string(),
  outgoing: inTransitSideSchema,
  incoming: inTransitSideSchema,
});

export const dispatchTransferLineSchema = z.object({
  line_id: z.string(),
  quantity: z.number().finite().nonnegative(),
  shortfall_reason: z.string().nullish(),
});

export const prepareTransferSchema = z.object({
  lines: z.array(dispatchTransferLineSchema).min(1).max(200),
});

export const dispatchTransferSchema = z.object({
  lines: z.array(dispatchTransferLineSchema).min(1).max(200),
  driver_name: z.string().nullish(),
  vehicle_plate: z.string().nullish(),
  signature_attachment_ids: z.array(z.string()).nullish(),
});

export const receiveTransferLineSchema = z.object({
  line_id: z.string(),
  accepted: z.number().finite().nonnegative(),
  rejected: z.number().nullish(),
  missing: z.number().nullish(),
  no_space: z.number().nullish(),
  extra: z.number().nullish(),
});

export const receiveTransferSchema = z.object({
  lines: z.array(receiveTransferLineSchema).min(1).max(200),
  note: z.string().nullish(),
  signature_attachment_ids: z.array(z.string()).nullish(),
});

export const sendBackTransferSchema = z.object({
  lines: z.array(
    z.object({
      line_id: z.string(),
      rejected: z.boolean().nullish(),
      no_space: z.boolean().nullish(),
    }),
  ),
  note: z.string().nullish(),
});

export const returnCheckTransferSchema = z.object({
  lines: z.array(z.object({ line_id: z.string(), good: z.number().finite().nonnegative(), damaged: z.number().finite().nonnegative() })).min(1).max(200),
  note: z.string().nullish(),
  signature_attachment_ids: z.array(z.string()).nullish(),
});

export const settleExtraDecisionSchema = z.nativeEnum(SettleExtraDecision);

export const settleTransferSchema = z.object({
  lines: z.array(
    z.object({
      line_id: z.string(),
      missing_lost: z.number().nullish(),
      missing_found: z.number().nullish(),
      shortage_lost: z.number().nullish(),
      shortage_found: z.number().nullish(),
      extra: settleExtraDecisionSchema.nullish(),
    }),
  ),
  note: z.string().trim().min(1).max(500),
});

export const redirectTransferSchema = z.object({
  destination_store_id: z.string(),
  lines: z.array(z.object({ line_id: z.string(), quantity: z.number().finite().positive() })).min(1).max(200),
  note: z.string().nullish(),
});

export const approveTransferPricesSchema = z.object({
  lines: z.array(z.object({ line_id: z.string(), price: z.number().finite().nonnegative(), cost: z.number().finite().nonnegative().nullish() })).min(1).max(200),
});

export const closeStockOrderBalanceSchema = z.object({
  reason: z.string().trim().min(1).max(500),
});

export const cancelTransferSchema = z.object({
  reason: z.string().trim().min(1).max(500),
});

export const stockOrderPageSchema = z.object({
  items: z.array(stockOrderSchema),
  cursor: z.string().nullish(),
});

export const flowTypeSchema = z.nativeEnum(FlowType);

export const flowDraftSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    principal_id: z.string(),
    flow_type: flowTypeSchema,
    entity_id: z.string().nullish(),
    step: z.number(),
    payload: z.record(z.unknown()),
    expires_at: z.string(),
  });

export const saveFlowDraftSchema = z.object({
  store_id: z.string(),
  step: z.number().int().min(0).max(50),
  payload: z.record(z.unknown()),
  expected_version: z.number().nullish(),
  expected_id: z.string().nullish(),
});

export const flowDraftPageSchema = z.object({
  items: z.array(flowDraftSchema),
  cursor: z.string().nullish(),
});

export const storeEventsSchema = z.nativeEnum(StoreEvents);

export const storeFavouriteCellSchema = versionedSchema.extend({
  merchant_id: z.string(),
  store_id: z.string(),
  page: z.number(),
  position: z.number(),
  product_id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  updated_by: z.string().nullish(),
});

export const locationTypeSchema = z.nativeEnum(LocationType);

export const createStoreSchema = z.object({
  name: z.string(),
  merchant_id: z.string(),
  contact_person: z.string(),
  contact_person_phone_number: z.string(),
  city: z.string(),
  address: z.string().nullish(),
  region: z.string().nullish(),
  postal_code: z.string().nullish(),
  country_code: z.string().nullish(),
  phone_number: z.string().nullish(),
  description: z.string().nullish(),
  email: z.string().nullish(),
  tax_number: z.string().nullish(),
  whatsapp_number: z.string().nullish(),
  location_type: locationTypeSchema.nullish(),
  labels: z.record(z.string().trim().min(1).max(30), z.string().trim().min(1).max(50)).refine((labels) => Object.keys(labels).length <= 5, 'At most 5 labels').nullish(),
});

export const updateStoreSchema = z.object({
  name: z.string().nullish(),
  contact_person: z.string().nullish(),
  contact_person_phone_number: z.string().nullish(),
  address: z.string().nullish(),
  city: z.string().nullish(),
  region: z.string().nullish(),
  postal_code: z.string().nullish(),
  country_code: z.string().nullish(),
  phone_number: z.string().nullish(),
  description: z.string().nullish(),
  email: z.string().nullish(),
  id: z.string(),
  merchant_id: z.string(),
  tax_number: z.string().nullish(),
  note: z.string().nullish(),
  daily_count_target: z.number().nullish(),
  daily_count_enabled: z.boolean().nullish(),
  daily_count_recency_days: z.number().nullish(),
  daily_count_carry_over_enabled: z.boolean().nullish(),
  hide_stock_when_counting: z.boolean().nullish(),
  blind_shift_closing: z.boolean().nullish(),
  prevent_overdue_blocking: z.boolean().nullish(),
  allow_limited_settings: z.boolean().nullish(),
  hide_discounts_on_receipt: z.boolean().nullish(),
  po_profit_estimation_enabled: z.boolean().nullish(),
  whatsapp_number: z.string().nullish(),
  location_type: locationTypeSchema.nullish(),
  labels: z.record(z.string().trim().min(1).max(30), z.string().trim().min(1).max(50)).refine((labels) => Object.keys(labels).length <= 5, 'At most 5 labels').nullish(),
});

export const getStoresByMerchantDtoSchema = z.object({
  merchant_id: z.string(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const storeScaleTypeSchema = z.union([
  z.literal('tm_xa'),
  z.literal('tm_a'),
  z.literal('shop_and_smile'),
]);

export const scaleConfigParameterSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  value: z.number(),
  category: z.string().nullish(),
});

export const scaleConfigShortcutSchema = z.object({
  page: z.number(),
  position: z.number(),
  plu: z.string(),
  name: z.string().nullish(),
  description: z.string().nullish(),
});

export const storeScaleConfigSchema = versionedSchema.extend({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
  parameters: z.array(scaleConfigParameterSchema),
  shortcuts: z.array(scaleConfigShortcutSchema),
  updated_at: z.string(),
  updated_by: z.string().nullish(),
});

export const storeScaleConfigDBItemSchema = storeScaleConfigSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const putStoreScaleConfigSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
  parameters: z.array(scaleConfigParameterSchema),
  shortcuts: z.array(scaleConfigShortcutSchema),
  updated_by: z.string().nullish(),
});

export const getStoreScaleConfigDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
});

export const deleteStoreScaleConfigDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
});

export const storeFavouriteCellDBItemSchema = storeFavouriteCellSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const storeFavouriteCellsPageSchema = z.object({
  favourites: z.array(storeFavouriteCellSchema),
  count: z.number(),
});

export const putStoreFavouriteCellSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  page: z.number(),
  position: z.number(),
  product_id: z.string(),
  updated_by: z.string().nullish(),
});

export const deleteStoreFavouriteCellDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  page: z.number(),
  position: z.number(),
});

export const getStoreFavouriteCellsDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
});

export const storeScaleShortcutSchema = versionedSchema.extend({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
  page: z.number(),
  position: z.number(),
  plu: z.string(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
  updated_by: z.string().nullish(),
});

export const storeScaleShortcutDBItemSchema = storeScaleShortcutSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const storeScaleShortcutsPageSchema = z.object({
  shortcuts: z.array(storeScaleShortcutSchema),
  count: z.number(),
});

export const putStoreScaleShortcutSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
  page: z.number(),
  position: z.number(),
  plu: z.string(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  updated_by: z.string().nullish(),
});

export const deleteStoreScaleShortcutDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
  page: z.number(),
  position: z.number(),
});

export const listStoreScaleShortcutsDtoSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  scale_type: storeScaleTypeSchema,
});

export const supplierPageSchema = z.object({
  cursor: z.string().nullish(),
  count: z.number().nullish(),
  suppliers: z.array(supplierSchema),
});

export const createSupplierSchema = z.object({
  name: z.string(),
  merchant_id: z.string(),
  email: z.string().nullish(),
  phone_number: z.string().nullish(),
  website: z.string().nullish(),
  address_1: z.string().nullish(),
  address_2: z.string().nullish(),
  city: z.string().nullish(),
  region: z.string().nullish(),
  postal_code: z.string().nullish(),
  note: z.string().nullish(),
  country_code: z.string().nullish(),
  contact: z.string().nullish(),
});

export const updateSupplierSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  email: z.string().nullish(),
  phone_number: z.string().nullish(),
  website: z.string().nullish(),
  address_1: z.string().nullish(),
  address_2: z.string().nullish(),
  city: z.string().nullish(),
  region: z.string().nullish(),
  postal_code: z.string().nullish(),
  note: z.string().nullish(),
  country_code: z.string().nullish(),
  contact: z.string().nullish(),
});

export const supplierDBItemSchema = supplierSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const getSupplierByIdSchema = z.object({
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getSuppliersSchema = z.object({
  merchant_id: z.string(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const taskTypeSchema = z.nativeEnum(TaskType);

export const taskEventOpSchema = z.nativeEnum(TaskEventOp);

export const taskStatusSchema = z.nativeEnum(TaskStatus);

export const taskOriginSchema = z.nativeEnum(TaskOrigin);

export const taskPrioritySchema = z.nativeEnum(TaskPriority);

export const taskScopeSchema = z.nativeEnum(TaskScope);

export const taskParamsSchema = z.record(z.union([z.string(), z.number()]));

export const taskActorSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const taskSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    type: taskTypeSchema,
    origin: taskOriginSchema,
    status: taskStatusSchema,
    required_action: z.string(),
    app: z.string(),
    params: taskParamsSchema.nullish(),
    assignee_id: z.string().nullish(),
    assignee_name: z.string().nullish(),
    assignee_role_id: z.string().nullish(),
    assignee_role_name: z.string().nullish(),
    title: z.string().nullish(),
    description: z.string().nullish(),
    audio_attachment_id: z.string().nullish(),
    attachment_ids: z.array(z.string()).nullish(),
    due_at: z.string().nullish(),
    priority: taskPrioritySchema.nullish(),
    done_note: z.string().nullish(),
    waiting_since: z.string().nullish(),
    closed_at: z.string().nullish(),
    closed_by_id: z.string().nullish(),
    closed_by_name: z.string().nullish(),
    last_occurred_at: z.string(),
    created_by_id: z.string(),
    created_by_name: z.string(),
  });

export const getTasksSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  app: z.string().nullish(),
  scope: taskScopeSchema.nullish(),
});

export const taskListSchema = z.object({
  open: z.array(taskSchema),
  recently_closed: z.array(taskSchema),
  has_more: z.boolean(),
});

export const getTaskSummarySchema = z.object({
  merchant_id: z.string(),
});

export const storeTaskSummarySchema = z.object({
  store_id: z.string(),
  open: z.number(),
  recently_closed: z.boolean(),
});

export const taskSummarySchema = z.object({
  stores: z.array(storeTaskSummarySchema),
  created_open: z.number().nullish(),
});

export const createTaskSchema = z.object({
  id: z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/i),
  store_id: z.string().trim().min(1),
  title: z.string().trim().min(1).max(120),
  description: z.string().trim().max(2000).nullish(),
  audio_attachment_id: z.string().nullish(),
  attachment_ids: z.array(z.string().min(1)).max(5).nullish(),
  due_at: z.string().datetime({ offset: true }).nullish(),
  priority: taskPrioritySchema.nullish(),
  assignee_id: z.string().nullish(),
  assignee_role_id: z.string().nullish(),
});

export const completeTaskSchema = z.object({
  note: z.string().trim().max(500).nullish(),
});

export const getCreatedTasksSchema = z.object({
  merchant_id: z.string(),
  cursor: z.string().nullish(),
});

export const taskPageSchema = z.object({
  tasks: z.array(taskSchema),
  cursor: z.string().nullish(),
});

export const getTaskReportSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  from: z.string().datetime({ offset: true }),
  to: z.string().datetime({ offset: true }),
  cursor: z.string().nullish(),
  assignee_id: z.string().nullish(),
  assignee_role_id: z.string().nullish(),
  created_by_id: z.string().nullish(),
  origin: taskOriginSchema.nullish(),
  type: taskTypeSchema.nullish(),
  priority: taskPrioritySchema.nullish(),
  status: taskStatusSchema.nullish(),
});

export const taskReportTotalsSchema = z.object({
  created: z.number(),
  done: z.number(),
  open: z.number(),
  overdue: z.number(),
});

export const taskReportSchema = z.object({
  tasks: z.array(taskSchema),
  totals: taskReportTotalsSchema,
  cursor: z.string().nullish(),
  truncated: z.boolean(),
});

export const taxTypeSchema = z.nativeEnum(TaxType);

export const createTaxSchema = z.object({
  name: z.string(),
  type: taxTypeSchema,
  rate: z.number(),
  merchant_id: z.string(),
});

export const updateTaxSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  type: taxTypeSchema.nullish(),
  rate: z.number().nullish(),
  merchant_id: z.string(),
});

export const getTaxByIdSchema = z.object({
  id: z.string(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const getTaxesSchema = z.object({
  merchant_id: z.string(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const calculateTaxCommandsSchema = z.nativeEnum(CalculateTaxCommands);

export const calculateTaxSchema = z.object({
  item_price: z.number(),
  tax_ids: z.array(z.string()),
  added_tax_id: z.string(),
  included_tax_ids: z.array(z.string()),
  command: calculateTaxCommandsSchema,
});

export const calculateTaxResultSchema = z.object({
  command: calculateTaxCommandsSchema,
  item_price: z.number(),
  tax_value: z.number().nullable(),
  pre_tax_price: z.number().nullable(),
  total_tax: z.number().nullable(),
  added_tax: z.number().nullable(),
});

export const walletMessageSchema = z.object({
  id: z.string(),
  content: z.string(),
  created_at: z.string(),
  receiver_number: z.string(),
});

export const walletMessageDBItemSchema = walletMessageSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const getWalletMessageSchema = z.object({
  id: z.string(),
});

export const getAllWalletMessagesSchema = z.object({
  by_date_range: z.boolean().nullish(),
  by_receiver_number: z.boolean().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  receiver_number: z.string().nullish(),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const walletMessagesPageSchema = z.object({
  count: z.number().nullish(),
  cursor: z.string().nullish(),
  wallet_messages: z.array(walletMessageSchema),
});

export const emolaPrefixSchema = z.nativeEnum(EmolaPrefix);

export const counterpartyTypeSchema = z.nativeEnum(CounterpartyType);

export const topupTransactionTypeSchema = z.nativeEnum(TopupTransactionType);

export const assignmentSourceSchema = z.nativeEnum(AssignmentSource);

export const claimHistoryTypesSchema = z.nativeEnum(ClaimHistoryTypes);

export const topupClaimMatchMethodSchema = z.nativeEnum(TopupClaimMatchMethod);

export const claimHistorySchema = z.object({
  by: z.string(),
  entity_type: entityTypesSchema,
  created_at: z.string(),
  type: claimHistoryTypesSchema,
  note: z.string().nullish(),
});

export const topupSourceSchema = z.nativeEnum(TopupSource);

export const topupWalletSchema = z.object({
  operator: messageOperatorSchema,
  transaction_id: z.string().nullish(),
  amount: z.number(),
  assignment_source: assignmentSourceSchema,
  merchant_id: z.string(),
  store_id: z.string(),
  claimed_by: z.string(),
  client_claim_text: z.string().nullish(),
  entity_type: entityTypesSchema,
  date: z.string().nullish(),
});

export const createTopupRequestSchema = z.object({
  receiver_number: z.string(),
  sender_contact: z.string(),
  password: z.string(),
  message_content: z.string(),
});

export const getTopupRequestSchema = z.object({
  transaction_id: z.string(),
});

export const getAllTopupRequestsSchema = z.object({
  by_claim_status: z.boolean().nullish(),
  by_merchant: z.boolean().nullish(),
  by_receiver_number: z.boolean().nullish(),
  by_operator: z.boolean().nullish(),
  by_date_range: z.boolean().nullish(),
  by_amount_range: z.boolean().nullish(),
  by_transaction_type: z.boolean().nullish(),
  by_sender_contact: z.boolean().nullish(),
  claim_status: claimStatusSchema.nullish(),
  merchant_id: z.string().nullish(),
  receiver_number: z.string().nullish(),
  operator: messageOperatorSchema.nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  start_amount: z.number().nullish(),
  end_amount: z.number().nullish(),
  transaction_type: topupTransactionTypeSchema.nullish(),
  sender_contact: z.string().nullish(),
  password: z.string().nullish(),
  by_store: z.boolean().nullish(),
  store_id: z.string().nullish(),
  newest_first: z.boolean().nullish(),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const topupPasswordUpdateHistorySchema = z.object({
  updated_at: z.string(),
  old_password: z.string(),
});

export const updateTopupPasswordSchema = z.object({
  old_password: z.string(),
  new_password: z.string(),
  phone_number: z.string(),
});

export const walletTransferDirectionSchema = z.nativeEnum(
  WalletTransferDirection,
);

export const walletTransferOutSchema = z.object({
  transaction_id: z.string(),
  amount: z.number(),
  recipient_number: z.string(),
  recipient_name: z.string(),
  fee: z.number(),
  balance_after: z.number(),
  message_content: z.string(),
  receiver_number: z.string(),
  created_at: z.string(),
  subtype: txSubtypeSchema.nullish(),
  counterparty_type: counterpartyTypeSchema.nullish(),
  reversed_by: z.string().nullish(),
  reversed_at: z.string().nullish(),
  content: z.string().nullish(),
  occurred_at: z.string().nullish(),
  source: topupSourceSchema.nullish(),
  operator: messageOperatorSchema.nullish(),
});

export const walletTransferOutDBItemSchema = walletTransferOutSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
});

export const walletGetTransferOutSchema = z.object({
  transaction_id: z.string(),
});

export const walletGetAllTransferOutsSchema = z.object({
  by_recipient_number: z.boolean().nullish(),
  by_receiver_number: z.boolean().nullish(),
  by_amount: z.boolean().nullish(),
  by_date_range: z.boolean().nullish(),
  recipient_number: z.string().nullish(),
  receiver_number: z.string().nullish(),
  amount: z.number().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const walletTransferOutsPageSchema = z.object({
  count: z.number().nullish(),
  cursor: z.string().nullish(),
  transfer_outs: z.array(walletTransferOutSchema),
});

export const topupNumberUpdateHistorySchema = z.array(
  z.object({
    updated_at: z.string(),
    phone_number: z.string(),
    location: z.string(),
    platform_payment_type_id: z.string().nullish(),
    operator: messageOperatorSchema.nullish(),
    device_label: z.string().nullish(),
  }),
);

export const createTopupNumberSchema = z.object({
  phone_number: z.string(),
  location: z.string(),
  password: z.string(),
  platform_payment_type_id: z.string(),
  operator: messageOperatorSchema.nullish(),
  device_label: z.string().nullish(),
});

export const getTopupNumberSchema = z.object({
  phone_number: z.string(),
});

export const getAllTopupNumbersSchema = z.object({
  include_deleted: softDeleteFlagSchema.nullish(),
  by_platform_payment_type: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const updateTopupNumberCommandSchema = z.nativeEnum(
  UpdateTopupNumberCommand,
);

export const updateTopupNumberSchema = z.object({
  phone_number: z.string(),
  location: z.string().nullish(),
  password: z.string(),
  platform_payment_type_id: z.string().nullish(),
  operator: messageOperatorSchema.nullish(),
  device_label: z.string().nullish(),
  command: updateTopupNumberCommandSchema,
});

export const promoteTopupNumberSchema = z.object({
  pending_phone_number: z.string(),
  phone_number: z.string(),
  password: z.string(),
  location: z.string().nullish(),
});

export const mergeTopupNumberSchema = z.object({
  pending_phone_number: z.string(),
  phone_number: z.string(),
  dry_run: z.boolean().nullish(),
  use_pending_payment_type: z.boolean().nullish(),
});

export const topupDeviceStatusSchema = z.nativeEnum(TopupDeviceStatus);

export const assignTopupDeviceSchema = z.object({
  device_label: z.string(),
  phone_number: z.string(),
});

export const processIftttSmsSchema = z.object({
  id: z.string(),
  sender: z.string(),
  sender_name: z.string().nullish(),
  message_content: z.string().nullish(),
  received_at: z.string().nullish(),
  device_name: z.string().nullish(),
  created_at: z.string(),
});

export const processIftttSmsResultSchema = z.object({
  outcome: z.union([
    z.literal('CREATED'),
    z.literal('DUPLICATE'),
    z.literal('IGNORED'),
    z.literal('NEEDS_REVIEW'),
    z.literal('HELD'),
  ]),
  direction: walletTransferDirectionSchema.nullish(),
  transaction_id: z.string().nullish(),
  receiver_number: z.string().nullish(),
});

export const mobileMoneyLedgerEntrySchema = z.object({
  transaction_id: z.string(),
  receiver_number: z.string(),
  direction: z.union([
    z.literal(WalletTransferDirection.IN),
    z.literal(WalletTransferDirection.OUT),
  ]),
  operator: messageOperatorSchema.nullish(),
  amount: z.number(),
  fee: z.number(),
  balance_after: z.number().nullish(),
  counterparty_number: z.string().nullish(),
  counterparty_name: z.string().nullish(),
  content: z.string().nullish(),
  message_content: z.string(),
  occurred_at: z.string(),
  created_at: z.string(),
  subtype: txSubtypeSchema.nullish(),
  reversed_by: z.string().nullish(),
  claim_status: claimStatusSchema.nullish(),
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
  claimed_at: z.string().nullish(),
  claimed_by: z.string().nullish(),
});

export const getMobileMoneyLedgerSchema = z.object({
  receiver_number: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  limit: z.number().nullish(),
});

export const mobileMoneyLedgerPageSchema = z.object({
  entries: z.array(mobileMoneyLedgerEntrySchema),
  count: z.number(),
});

export const getTopupNumberBalanceSchema = z.object({
  phone_number: z.string(),
});

export const resetTopupPasswordSchema = z.object({
  phone_number: z.string(),
});

export const getTopupsBalanceSchema = z.object({
  receiver_number: z.string(),
  by_date_range: z.boolean().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export const getTopupsBalanceResponseSchema = z.object({
  total_in: z.number(),
  total_out: z.number(),
  calculated_balance: z.number(),
  real_balance: z.number(),
  real_balance_as_of: z.string().nullish(),
});

export const claimTopupByTransactionIdSchema = z.object({
  transaction_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  claimed_by: z.string(),
  claimed_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  amount: z.number().nullish(),
  client_claim_text: z.string().nullish(),
  payment_type_id: z.string(),
});

export const claimTopupByDetailsSchema = z.object({
  amount: z.number(),
  transaction_time: z.string(),
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  claimed_by: z.string(),
  claimed_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  window_minutes: z.number().nullish(),
  sender_contact: z.string().nullish(),
  receiver_number: z.string().nullish(),
  operator: messageOperatorSchema.nullish(),
  client_claim_text: z.string().nullish(),
  payment_type_id: z.string(),
});

export const claimTopupByMessageSchema = z.object({
  message_content: z.string(),
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  claimed_by: z.string(),
  claimed_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  client_claim_text: z.string().nullish(),
  payment_type_id: z.string(),
});

export const findTopupClaimMatchesSchema = z.object({
  amount: z.number(),
  transaction_time: z.string(),
  window_minutes: z.number().nullish(),
  sender_contact: z.string().nullish(),
  receiver_number: z.string().nullish(),
  operator: messageOperatorSchema.nullish(),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const approveTopupClaimSchema = z.object({
  transaction_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  approved_by: z.string(),
  approved_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  client_claim_text: z.string().nullish(),
  note: z.string().nullish(),
  payment_type_id: z.string().nullish(),
});

export const rejectTopupClaimSchema = z.object({
  transaction_id: z.string(),
  rejected_by: z.string(),
  entity_type: entityTypesSchema,
  reason: z.string(),
  note: z.string().nullish(),
});

export const revokeTopupClaimSchema = z.object({
  transaction_id: z.string(),
  revoked_by: z.string(),
  revoked_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  reason: z.string(),
  note: z.string().nullish(),
});

export const reopenTopupClaimSchema = z.object({
  transaction_id: z.string(),
  reopened_by: z.string(),
  reopened_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  note: z.string().nullish(),
});

export const correctTopupRequestSchema = z.object({
  transaction_id: z.string(),
  corrected_by: z.string(),
  corrected_by_name: z.string().nullish(),
  entity_type: entityTypesSchema,
  amount: z.number().nullish(),
  transaction_type: topupTransactionTypeSchema.nullish(),
  counterparty_name: z.string().nullish(),
  counterparty_number: z.string().nullish(),
  occurred_at: z.string().nullish(),
  content: z.string().nullish(),
  note: z.string().nullish(),
});

export const getTopupStatusCountsSchema = z.object({
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
});

export const topupStatusCountsSchema = z.object({
  counts: z.record(claimStatusSchema, z.number()),
  total: z.number(),
});

export const userEventsSchema = z.nativeEnum(UserEvents);

export const offlineCredentialSchema = z.object({
  employee_id: z.string(),
  cognito_id: z.string().nullish(),
  cognito_username: z.string().nullish(),
  name: z.string(),
  username: z.string(),
  phone_number: z.string(),
  roles: z.array(z.string()),
  stores: z.array(merchantAuthStoreSchema),
  merchant_id: z.string(),
  is_owner: z.boolean(),
  use_whatsapp_otp: z.boolean(),
  pin_hash: z.string(),
  pin_salt: z.string(),
  pin_updated_at: z.string(),
  actions: z.array(z.string()).nullish(),
});

export const offlineCredentialsResponseSchema = z.object({
  credentials: z.array(offlineCredentialSchema),
  generated_at: z.string(),
});

export const getOfflineCredentialsSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string().nullish(),
});

export const createUserSchema = z.object({
  name: z.string(),
  roles: z.array(z.string()),
  username: z.string(),
  email: z.string(),
  phone_number: z.string(),
  PIN: z.string(),
  stores: z.array(z.string()),
  merchant_id: z.string(),
});

export const markNumberVerifiedSchema = z.object({
  is_number_verified: z.boolean(),
});

export const updateUserLanguageSchema = z.object({
  language: uiLanguageSchema.nullable(),
});

export const getUserByCognitoIdSchema = z.object({
  cognito_id: z.string(),
  merchant_id: z.string(),
});

export const listWalletTransactionsBaseSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export const listWalletTransactionsByCreatorSchema =
  listWalletTransactionsBaseSchema.extend({
    created_by_type: entityTypesSchema,
    created_by_id: z.string(),
  });

export const listWalletTransactionsByReferenceSchema =
  listWalletTransactionsBaseSchema.extend({
    merchant_id: z.string(),
    reference_type: z.string(),
    reference_id: z.string(),
  });

export const walletSnapshotSchema = timestampsSchema.extend({
  merchant_id: z.string(),
  balance: z.number(),
  currency: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  version: z.number(),
});

export const walletTransactionTypeSchema = z.nativeEnum(WalletTransactionType);

export const walletTransactionSchema = z.object({
  merchant_id: z.string(),
  type: walletTransactionTypeSchema,
  amount: z.number(),
  reference_type: z.string(),
  reference_id: z.string(),
  reference_url: z.string().nullish(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  currency: z.string(),
  version: z.number(),
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  store_id: z.string().nullish(),
  description: z.string(),
  created_at: z.string(),
  receiver_number: z.union([z.string(), z.number()]).nullish(),
});

export const walletTransactionDBItemSchema = walletTransactionSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string().nullish(),
  GSI5SK: z.string().nullish(),
  GSI6PK: z.string().nullish(),
  GSI6SK: z.string().nullish(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const walletSnapshotDBItemSchema = walletSnapshotSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const creditWalletSchema = z.object({
  amount: z.number(),
  reference_type: z.string(),
  reference_id: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  currency: z.string(),
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  store_id: z.string().nullish(),
  description: z.string(),
  receiver_number: z.union([z.string(), z.number()]).nullish(),
});

export const debitWalletSchema = z.object({
  amount: z.number(),
  reference_type: z.string(),
  reference_id: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  currency: z.string(),
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  description: z.string(),
});

export const getWalletTransactionSchema = z.object({
  merchant_id: z.string(),
  payment_method_id: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  count: z.number().nullish(),
  cursor: z.string().nullish(),
  start_time: z.string().nullish(),
  end_time: z.string().nullish(),
});

export const walletTransactionPageSchema = z.object({
  transaction_rows: z.array(walletTransactionSchema),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const creditDebitResultSchema = z.object({
  balance: z.number(),
  transaction: walletTransactionSchema,
});

export const getWalletBalanceAtSchema = z.object({
  merchant_id: z.string(),
  payment_method_id: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  timestamp: z.string(),
});

export const walletBalanceAtResultSchema = z.object({
  balance: z.number(),
  as_of: z.string(),
  version: z.number(),
});

export const walletTransactionsPageSchema = z.object({
  items: z.array(walletTransactionSchema),
  cursor: z.string().nullish(),
  count: z.number().nullish(),
});

export const storeWalletTransactionSchema = walletTransactionSchema.extend({
  store_id: z.string(),
});

export const storeWalletSnapshotSchema = walletSnapshotSchema.extend({
  store_id: z.string(),
});

export const storeWalletTransactionDBItemSchema =
  storeWalletTransactionSchema.extend({
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    GSI2PK: z.string(),
    GSI2SK: z.string(),
    GSI3PK: z.string(),
    GSI3SK: z.string(),
    GSI4PK: z.string().nullish(),
    GSI4SK: z.string().nullish(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  });

export const storeWalletSnapshotDBItemSchema = storeWalletSnapshotSchema.extend(
  {
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  },
);

export const assignFundsToStorePayloadSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  amount: z.number(),
  currency: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  description: z.string().nullish(),
});

export const unassignFundsFromStorePayloadSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  amount: z.number(),
  currency: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  description: z.string().nullish(),
});

export const assignUnassignResultSchema = z.object({
  debit_transaction: walletTransactionSchema,
  credit_transaction: walletTransactionSchema,
  source_balance: z.number(),
  destination_balance: z.number(),
});

export const getStoreWalletBalanceParamsSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
});

export const storeWalletBalanceSchema = z.object({
  store_id: z.string(),
  merchant_id: z.string(),
  balance: z.number(),
  currency: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  version: z.number(),
});

export const listStoreWalletsByMerchantParamsSchema = z.object({
  merchant_id: z.string(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const storeWalletsPageSchema = z.object({
  items: z.array(storeWalletBalanceSchema),
  cursor: z.string().nullish(),
  count: z.number().nullish(),
});

export const listStoreWalletTransactionsByPaymentMethodParamsSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const listPlatformTransactionsParamsSchema = z.object({
  payment_method_type: paymentMethodTypeSchema.nullish(),
  payment_method_id: z.string().nullish(),
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export const platformTransactionsPageSchema = z.object({
  items: z.array(walletTransactionSchema),
  cursor: z.string().nullish(),
  count: z.number().nullish(),
});

export const creditPlatformWalletParamsSchema = z.object({
  amount: z.number(),
  currency: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  reference_type: z.string(),
  reference_id: z.string(),
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  description: z.string().nullish(),
});

export const debitPlatformWalletParamsSchema = z.object({
  amount: z.number(),
  currency: z.string(),
  payment_method_id: z.string(),
  payment_method_name: z.string(),
  payment_method_type: paymentMethodTypeSchema,
  reference_type: z.string(),
  reference_id: z.string(),
  created_by_id: z.string(),
  created_by_type: entityTypesSchema,
  created_by_name: z.string(),
  description: z.string().nullish(),
});

export const weightedSaleStatusSchema = z.nativeEnum(WeightedSaleStatus);

export const weightedSaleSourceSchema = z.nativeEnum(WeightedSaleSource);

export const weightedSaleScaleTypeSchema = z.nativeEnum(WeightedSaleScaleType);

export const weightedSaleSchema = versionedSchema.extend({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  pos_device_id: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string().nullish(),
  deleted_by_id: z.string().nullish(),
  deleted_by_name: z.string().nullish(),
  product_id: z.string(),
  product_name: z.string(),
  product_image_url: z.string().nullish(),
  plu: z.string().nullish(),
  original_barcode: z.string().nullish(),
  weight_kg: z.number(),
  unit_price: z.number(),
  total_price: z.number(),
  status: weightedSaleStatusSchema,
  source: weightedSaleSourceSchema,
  scale_type: weightedSaleScaleTypeSchema.nullish(),
  receipt_number: z.string().nullish(),
  custom_receipt_number: z.string().nullish(),
  receipt_item_id: z.string().nullish(),
  employee_id: z.string().nullish(),
  employee_name: z.string().nullish(),
  customer_id: z.string().nullish(),
  customer_name: z.string().nullish(),
  shift_id: z.string().nullish(),
  payment_method_ids: z.array(z.string()).nullish(),
  sold_at: z.string().nullish(),
  scale_report_id: z.string().nullish(),
});

export const weightedSaleDBItemSchema = weightedSaleSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string().nullish(),
  GSI2SK: z.string().nullish(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
});

export const weightedSalesPageSchema = z.object({
  items: z.array(weightedSaleSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const listWeightedSalesQuerySchema = z.object({
  merchant_id: z.string(),
  pos_device_id: z.string(),
  status: weightedSaleStatusSchema.nullish(),
  since: z.string().nullish(),
  cursor: z.string().nullish(),
  limit: z.number().nullish(),
});

export const createWeightedSaleSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  pos_device_id: z.string(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
  product_id: z.string(),
  product_name: z.string(),
  product_image_url: z.string().nullish(),
  plu: z.string().nullish(),
  original_barcode: z.string().nullish(),
  weight_kg: z.number(),
  unit_price: z.number(),
  total_price: z.number(),
  status: weightedSaleStatusSchema,
  source: weightedSaleSourceSchema,
  scale_type: weightedSaleScaleTypeSchema.nullish(),
  receipt_number: z.string().nullish(),
  custom_receipt_number: z.string().nullish(),
  receipt_item_id: z.string().nullish(),
  employee_id: z.string().nullish(),
  employee_name: z.string().nullish(),
  customer_id: z.string().nullish(),
  customer_name: z.string().nullish(),
  shift_id: z.string().nullish(),
  payment_method_ids: z.array(z.string()).nullish(),
  sold_at: z.string().nullish(),
  scale_report_id: z.string().nullish(),
});

export const updateWeightedSaleSchema = z.object({
  id: z.string(),
  merchant_id: z.string(),
  status: weightedSaleStatusSchema.nullish(),
  receipt_number: z.string().nullish(),
  custom_receipt_number: z.string().nullish(),
  receipt_item_id: z.string().nullish(),
  employee_id: z.string().nullish(),
  employee_name: z.string().nullish(),
  customer_id: z.string().nullish(),
  customer_name: z.string().nullish(),
  shift_id: z.string().nullish(),
  payment_method_ids: z.array(z.string()).nullish(),
  sold_at: z.string().nullish(),
  product_image_url: z.string().nullish(),
  product_name: z.string().nullish(),
  unit_price: z.number().nullish(),
  total_price: z.number().nullish(),
  weight_kg: z.number().nullish(),
});

export const bulkUpsertWeightedSalesSchema = z.object({
  merchant_id: z.string(),
  items: z.array(createWeightedSaleSchema),
});

export const bulkUpsertWeightedSalesSkippedSchema = z.object({
  id: z.string(),
  reason: z.string(),
});

export const bulkUpsertWeightedSalesResultSchema = z.object({
  created: z.array(z.string()),
  updated: z.array(z.string()),
  skipped: z.array(bulkUpsertWeightedSalesSkippedSchema),
});

export const whatsappSettingsSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    enabled: z.boolean(),
  });

export const whatsappSettingsResponseSchema = z.object({
  enabled: z.boolean(),
});

export const updateWhatsappSettingsSchema = z.object({
  enabled: z.boolean(),
});

export const whatsappSettingsDBItemSchema = whatsappSettingsSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const accountSnapshotsByPaymentMethodSchema = z.object({
  account_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  created_at: z.string(),
  account_snapshots: z.array(accountSnapshotSchema),
});

export const commentRefSchema = z.object({
  comment_id: z.string(),
  body: z.string(),
  commenter: personRefSchema,
  created_at: z.string(),
});

export const accountTransactionSchema = timestampsSchema.extend({
  account_id: z.string(),
  owner: personRefSchema,
  merchant_id: z.string(),
  store_id: z.string(),
  shift_id: z.string().nullish(),
  flow: transactionFlowSchema,
  category: transactionCategorySchema,
  payment_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  payment_method_metadata: z.record(z.any()).nullish(),
  origin_entity: originEntityRefSchema.nullish(),
  creator: personRefSchema,
  approver: personRefSchema.nullish(),
  forced: z.boolean().nullish(),
  without_consent: z.boolean().nullish(),
  amount: z.number(),
  currency: currencySchema,
  comments: z.array(commentRefSchema).nullish(),
  approved_at: z.string().nullish(),
  involved_parties: z.array(personRefSchema).nullish(),
  version: z.number(),
  reverses_transaction_id: z.string().nullish(),
  reversed_by_transaction_id: z.string().nullish(),
  reversal_reason: z.string().nullish(),
});

export const accountSnapshotDBItemSchema = accountSnapshotSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const accountTransactionDBItemSchema = accountTransactionSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string().nullish(),
  GSI2SK: z.string().nullish(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string().nullish(),
  GSI4SK: z.string().nullish(),
  GSI5PK: z.string().nullish(),
  GSI5SK: z.string().nullish(),
  GSI6PK: z.string().nullish(),
  GSI6SK: z.string().nullish(),
  GSI7PK: z.string().nullish(),
  GSI7SK: z.string().nullish(),
});

export const accountTransactionChangeSummarySchema = z.object({
  items: z.array(accountTransactionSchema),
  summary: z.array(summaryByPaymentMethodSchema),
  cursor: z.string().nullish(),
  count: z.number().nullish(),
  reversals: z.array(accountTransactionSchema).nullish(),
});

export const storeSnapshotsSchema = z.record(
  z.array(accountSnapshotsByPaymentMethodSchema),
);

export const transferAuditSchema = z.object({
  status: transferStatusSchema,
  created_at: z.string(),
  actor: personRefSchema.nullish(),
  notes: z.string().nullish(),
});

export const transferRequestSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    transfer_id: z.string(),
    merchant_id: z.string(),
    store_id: z.string(),
    transferer_account_id: z.string(),
    transferee_account_id: z.string(),
    amount: z.number(),
    payment_type: paymentMethodTypeSchema,
    payment_method_id: z.string(),
    status: transferStatusSchema,
    forced: z.boolean().nullish(),
    without_consent: z.boolean().nullish(),
    approvals: z.array(transferApprovalSchema),
    rejection_reason: z.string().nullish(),
    shift_id: z.string().nullish(),
    currency: currencySchema,
    transferer_owner: personRefSchema.nullish(),
    transferee_owner: personRefSchema.nullish(),
    creator: personRefSchema.nullish(),
    audit_history: z.array(transferAuditSchema).nullish(),
    comments: z.array(commentRefSchema).nullish(),
    approval_claimed_at: z.string().nullish(),
    approval_claimed_by_id: z.string().nullish(),
  });

export const transactionIngestEventSchema = z.object({
  source_system: z.string(),
  source_reference: z.string(),
  payload: accountTransactionSchema,
});

export const transferEventSchema = z.object({
  source_system: z.string(),
  transfer: transferRequestSchema,
});

export const transferRequestDBItemSchema = transferRequestSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
});

export const accountTransactionsPageSchema = z.object({
  items: z.array(accountTransactionSchema),
  cursor: z.string().nullish(),
  count: z.number().nullish(),
});

export const createAccountTransactionSchema = z.object({
  account_id: z.string(),
  owner: personRefSchema,
  merchant_id: z.string(),
  store_id: z.string(),
  shift_id: z.string().nullish(),
  flow: transactionFlowSchema,
  category: transactionCategorySchema,
  payment_type: paymentMethodTypeSchema,
  payment_method_id: z.string(),
  payment_method_metadata: z.record(z.any()).nullish(),
  origin_entity: originEntityRefSchema.nullish(),
  creator: personRefSchema,
  approver: personRefSchema.nullish(),
  forced: z.boolean().nullish(),
  without_consent: z.boolean().nullish(),
  amount: z.number(),
  currency: currencySchema,
  comments: z.array(commentRefSchema).nullish(),
  approved_at: z.string().nullish(),
  involved_parties: z.array(personRefSchema).nullish(),
  reverses_transaction_id: z.string().nullish(),
  reversal_reason: z.string().nullish(),
});

export const storePaymentRowSchema = z.object({
  storeId: z.string(),
  storeName: z.string(),
  merchantId: z.string(),
  storeCreatedAt: z.string(),
  hasAgreement: z.boolean(),
  agreementType: z.string().nullable(),
  agreementStatus: customerAgreementStatusSchema.nullable(),
  nextPaymentDate: z.string().nullable(),
  totalPaid: z.number(),
  totalPending: z.number(),
  totalOverdue: z.number(),
  walletBalance: z.number(),
  currency: z.string(),
  totalPaidByCurrency: z.record(z.number()).nullish(),
  totalPendingByCurrency: z.record(z.number()).nullish(),
  totalOverdueByCurrency: z.record(z.number()).nullish(),
  walletBalanceByCurrency: z.record(z.number()).nullish(),
  invoiceCount: z.number(),
  overdueInvoiceCount: z.number(),
  failedInvoiceCount: z.number(),
});

export const storePaymentsResponseSchema = z.object({
  rows: z.array(storePaymentRowSchema.nullable()),
  total: z.number(),
});

export const platformMetricsResponseSchema = z.object({
  currency: z.string(),
  excludedBilledByCurrency: z.record(z.number()).nullish(),
  excludedGmvByCurrency: z.record(z.number()).nullish(),
  billedTrailing30d: z.number(),
  billedTrailing12m: z.number(),
  collectedTrailing30d: z.number(),
  collectionRatePct90d: z.number().nullable(),
  momGrowthPct: z.number().nullable(),
  arOutstanding: z.number(),
  arOverdue: z.number(),
  failedInvoiceCount: z.number(),
  failedInvoiceAmount: z.number(),
  monthlyRevenue: z.array(
    z.object({
      month: z.string(),
      billed: z.number(),
      collected: z.number(),
    }),
  ),
  arAging: z.array(
    z.object({
      bucket: z.string(),
      amount: z.number(),
    }),
  ),
  billedThisMonth: z.number(),
  collectedThisMonth: z.number(),
  totalOutstanding: z.number(),
  totalOverdue: z.number(),
  pendingInvoiceCount: z.number(),
  dso: z.number().nullable(),
  avgDaysToPay: z.number().nullable(),
  monthlyAr: z.array(
    z.object({
      month: z.string(),
      billed: z.number(),
      collected: z.number(),
      outstanding: z.number(),
    }),
  ),
  expectedByMonth: z.array(
    z.object({
      month: z.string(),
      amount: z.number(),
      invoiceCount: z.number(),
    }),
  ),
  storeRows: z.array(platformStoreArRowSchema),
  gmvThisMonth: z.number(),
  gmvTrailing12m: z.number(),
  activeStoresThisMonth: z.number(),
  receiptsTrailing12m: z.number(),
  failedStores: z.number(),
  activationRatePct: z.number().nullable(),
  activatedStores: z.number(),
  activationEligibleStores: z.number(),
  monthlySales: z.array(
    z.object({
      month: z.string(),
      gmv: z.number(),
      receipts: z.number(),
      activeStores: z.number(),
    }),
  ),
  activeAgreements: z.number(),
  payingStores: z.number(),
  freeStores: z.number(),
  payingSharePct: z.number().nullable(),
  churnRateLastMonthPct: z.number().nullable(),
  monthlyChurn: z.array(
    z.object({
      month: z.string(),
      churned: z.number(),
      activeAtStart: z.number(),
      churnRatePct: z.number().nullable(),
    }),
  ),
  totalMerchants: z.number(),
  totalStores: z.number(),
  totalUsers: z.number(),
  monthlyJoiningTrends: z.array(
    z.object({
      month: z.string(),
      merchants: z.number(),
      stores: z.number(),
      seats: z.number(),
    }),
  ),
  platformWalletBalance: z.number(),
  platformWalletByCurrency: z.record(z.number()).nullish(),
  platformWalletMethodCount: z.number(),
  topupsProcessed: z.number(),
  topupsUnprocessed: z.number(),
  lastBillingRun: platformBillingRunInfoSchema.nullable(),
});

export const employeeSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    roles: z.array(z.string()),
    username: z.string(),
    email: z.string(),
    phone_number: z.string(),
    stores: z.array(z.string()),
    merchant_id: z.string(),
    is_active: z.boolean(),
    is_inactive_since: z.string().nullish(),
    cognito_id: z.union([z.string(), z.undefined()]).nullable(),
    cognito_username: z.union([z.string(), z.undefined()]).nullable(),
    is_owner: z.boolean(),
    auth_user: merchantUserAttributesSchema.nullish(),
    is_number_verified: z.boolean().nullish(),
    language: uiLanguageSchema.nullish(),
  });

export const encryptCredentialsDtoSchema = z.object({
  AccessToken: z.string(),
  ExpiresIn: z.number(),
  Employee: employeeSchema,
  TokenType: z.string(),
});

export const sendWhatsappOtpRequestSchema = z.object({
  phone_number: z.string(),
  otp: z.string(),
  language: languageSchema,
  code_expiration_minutes: z.number().nullish(),
});

export const principalListSchema = z.object({
  principals: z.array(principalSchema),
  meta: metaSchema,
});

export const multiplePolicyBodySchema = z.object({
  merchant_id: z.string(),
  policies: z.array(policyBodySchema),
});

export const getAllPermissionsV2Schema = z.object({
  cursor: z.string().nullish(),
  count: z.number().nullish(),
  include_deleted: softDeleteFlagSchema.nullish(),
});

export const dailyCountListPageSchema = paginatedSchema.extend({
  daily_count_lists: z.array(dailyCountListSchema),
});

export const debtSchema = timestampsSchema.extend({
  id: z.string(),
  creator_type: entityTypesSchema,
  creator_id: z.string(),
  creator_name: z.string(),
  debtor_id: z.string(),
  debtor_name: z.string(),
  debtor_type: entityTypesSchema,
  store_id: z.string(),
  merchant_id: z.string(),
  transfers: z.array(debtTransferSchema),
  origin_type: debtOriginTypeSchema,
  principal_amount: z.number(),
  outstanding_balance: z.number(),
  interest_rate: z.number(),
  status: debtStatusSchema,
  next_due_date: z.union([z.string(), z.undefined()]).nullable(),
  closed_date: z.union([z.string(), z.undefined()]).nullable(),
  payment_plans: z.array(paymentPlanSchema),
  last_payment_date: z.string().nullish(),
  is_due_date_auto_calculated: z.boolean(),
  reason: z.string(),
  receipt_id: z.string().nullish(),
  version: z.string(),
  row_version: z.number().nullish(),
  updated_by_id: z.string().nullish(),
  updated_by_name: z.string().nullish(),
  cancellation_reason: z.string().nullish(),
  cancelled_at: z.string().nullish(),
  reversed_at: z.string().nullish(),
  reversed_by_user_id: z.string().nullish(),
  reversal_reason: z.string().nullish(),
  shift_id: z.string().nullish(),
});

export const debtChangeSchema = timestampsSchema.extend({
  id: z.string(),
  event: debtEventSchema,
  version: z.string(),
  debt_version: z.string(),
  updator_id: z.string(),
  updator_name: z.string(),
  updator_type: entityTypesSchema,
  changed_attributes: changedAttributesSchema,
  store_id: z.string(),
  merchant_id: z.string(),
});

export const debtDBItemSchema = debtSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string().nullish(),
  GSI5SK: z.string().nullish(),
});

export const debtChangeDBItemSchema = debtChangeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
});

export const debtChangesPageSchema = z.object({
  changes: z.array(debtChangeSchema),
  cursor: z.string(),
  count: z.number(),
});

export const debtsPageSchema = z.object({
  debts: z.array(debtSchema),
  cursor: z.string(),
  count: z.number(),
});

export const debtAggregateSchema = z.object({
  debt: debtSchema,
  changes: debtChangesPageSchema,
  payments: debtPaymentsPageSchema,
});

export const shopAndSmileEventMetadataSchema = z.object({
  correlation_id: z.string().nullish(),
  causation_id: z.string(),
  event_id: z.string(),
  event_version: z.number(),
  time: z.string(),
  source: shopAndSmileEventSourceSchema,
  stage: z.string(),
  service: z.string(),
  tags: z.array(z.string()),
  creator_id: z.string(),
  creator_type: entityTypesSchema,
  creator_name: z.string(),
});

export const productIssueSchema = z.object({
  issue_type: productIssueTypeSchema,
  message: z.string(),
  created_at: z.string(),
  is_resolved: z.boolean(),
  metadata: z.record(z.any()).nullish(),
});

export const uploadItemImageRequestSchema = z.object({
  metadata: uploadImageRequestSchema,
  base64Image: z.string(),
});

export const imageMetadataSchema = z.record(z.string()).and(
  z.object({
    file_type: z.string(),
    entity_type: z.string(),
    entity_id: z.string(),
    image_id: z.string(),
    image_s3_key: z.string(),
    has_been_processed: stringBooleanSchema,
    updator_id: z.string(),
    updator_type: entityTypesSchema,
    store_id: z.string(),
    merchant_id: z.string(),
  }),
);

export const stockOperationRecordSchema = z.object({
  operation_id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  product_id: z.string(),
  type: stockOperationTypeSchema,
  quantity: z.number(),
  from_bucket: stockBucketSchema.nullish(),
  to_bucket: stockBucketSchema.nullish(),
  reference: stockOperationReferenceSchema.nullish(),
  note: z.string().nullish(),
  manual: z.boolean().nullish(),
  release_any: z.boolean().nullish(),
  reserved_quantity: z.number().nullish(),
  freed_quantity: z.number().nullish(),
  unit_cost: z.number().nullish(),
  valuation: inventoryValuationSchema.nullish(),
  fingerprint: z.string(),
  counters: stockOperationCountersSchema,
  actor_id: z.string(),
  actor_name: z.string(),
  occurred_at: z.string(),
  applied_at: z.string(),
});

export const purchaseOrderDetailsSchema = z.object({
  id: z.string(),
  supplier: supplierSchema,
});

export const inventoryChangeSchema = timestampsSchema.extend({
  id: z.string(),
  store_id: z.string(),
  product_id: z.string(),
  product_name: z.string(),
  change_quantity: z.number(),
  cumulative_quantity: z.number(),
  reason: inventoryChangeReasonSchema,
  merchant_id: z.string(),
  created_at: z.string(),
  type: z.literal('CHANGE'),
  source_id: z.string(),
  source_type: entityTypesSchema,
  cost: z.number(),
  price: z.number(),
  source_name: z.string(),
  purchase_order_details: purchaseOrderDetailsSchema.nullish(),
  transfer_store_id: z.string().nullish(),
  inventory_value_change: z.number(),
  retail_value_change: z.number(),
  change_fraction: z.number(),
  processed_at: z.string().nullish(),
  bucket: stockBucketSchema.nullish(),
  sub_reason: z.string().nullish(),
  reference: stockOperationReferenceSchema.nullish(),
  operation_id: z.string().nullish(),
  valuation_adjustment: z.number().nullish(),
  note: z.string().nullish(),
});

export const createInventoryChangeSchema = z.object({
  store_id: z.string(),
  product_id: z.string(),
  change_quantity: z.number(),
  reason: inventoryChangeReasonSchema,
  merchant_id: z.string(),
  source_id: z.string(),
  cost: z.number(),
  source_type: entityTypesSchema,
  source_name: z.string(),
  product_name: z.string(),
  purchase_order_details: purchaseOrderDetailsSchema.nullish(),
  price: z.number(),
  transfer_store_id: z.string().nullish(),
  inventory_value_change: z.number(),
  retail_value_change: z.number(),
  change_fraction: z.number(),
  source_created_at: z.string(),
  idempotency_key: z.string().nullish(),
  count_basis: countBasisSchema.nullish(),
  note: z.string().trim().max(120).nullish(),
  count_as_of: z.string().datetime().nullish(),
});

export const inventoryChangeDBItemSchema = inventoryChangeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  GSI7PK: z.string(),
  GSI7SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI8PK: z.string().nullish(),
  GSI8SK: z.string().nullish(),
});

export const getInventoryChangesSchema = z.object({
  by_store_and_product_and_date_range: z.boolean().nullish(),
  by_store_and_date_range: z.boolean().nullish(),
  by_reason_and_store_and_product_and_date_range: z.boolean().nullish(),
  by_reason_and_store: z.boolean().nullish(),
  by_reason_across_stores: z.boolean().nullish(),
  by_source_and_store: z.boolean().nullish(),
  by_source_across_stores: z.boolean().nullish(),
  by_reason_and_source_and_store: z.boolean().nullish(),
  by_reason_and_source_across_stores: z.boolean().nullish(),
  by_product_and_store: z.boolean().nullish(),
  by_product_across_stores: z.boolean().nullish(),
  by_reason_and_product_and_store: z.boolean().nullish(),
  by_reason_and_product_across_stores: z.boolean().nullish(),
  by_source_and_product_and_store: z.boolean().nullish(),
  by_source_and_product_across_stores: z.boolean().nullish(),
  by_source_and_reason_and_product: z.boolean().nullish(),
  by_source_and_reason_and_store: z.boolean().nullish(),
  by_source_and_reason_across_stores: z.boolean().nullish(),
  limit: z.number().nullish(),
  cursor: z.string().nullish(),
  sort_order: sortOrderSchema.nullish(),
  store_id: z.string().nullish(),
  product_id: z.string().nullish(),
  reason: inventoryChangeReasonSchema.nullish(),
  source_type: entityTypesSchema.nullish(),
  source_id: z.string().nullish(),
  merchant_id: z.string(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export const inventoryChangePageSchema = z.object({
  changes: z.array(inventoryChangeSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const pricingCalculationResultForBillingSchema = z.object({
  merchant_id: z.string(),
  store_id: z.string().nullish(),
  agreement_id: z.string(),
  pricing_plan_id: z.string().nullish(),
  pricing_type: pricingTypeSchema,
  billing_period: billingPeriodSchema,
  currency: z.string(),
  base_amount: z.number(),
  discount_amount: z.number(),
  final_amount: z.number(),
  is_billable: z.boolean(),
  period_start: z.string(),
  period_end: z.string(),
  breakdown: z.array(invoiceLineSchema),
  reason: z.string().nullish(),
});

export const loanHistoryItemSchema = timestampsSchema.extend({
  event: loanHistoryEventSchema,
  created_at: z.string(),
  creator_id: z.string(),
  creator_name: z.string(),
  creator_type: z.string(),
  paid_amount: z.number(),
  total_amount: z.number(),
  unpaid_amount: z.number(),
  due_date: z.string(),
  overdue_amount: z.number(),
});

export const merchantModulesSchema = z.object({
  orders_transfers: ordersTransfersModuleSchema.nullish(),
});

export const merchantPaymentSchema = timestampsSchema.extend({
  id: z.string(),
  merchant_id: z.string(),
  store_id: z.string(),
  total_amount: z.number(),
  amount_due: z.number(),
  amount_paid: z.number(),
  payment_status: merchantPaymentStatusSchema,
  payment_date: z.string(),
  currency: currencySchema,
  created_at: z.string(),
  updated_at: z.string(),
  due_date: z.string(),
  payment_month: monthSchema,
  payer_name: z.string(),
  payer_phone_number: z.union([z.string(), z.number()]),
  payment_type: paymentMethodTypeSchema,
  note: z.string().nullish(),
  receiver_name: z.string(),
});

export const merchantPaymentPageSchema = z.object({
  merchant_payments: z.array(merchantPaymentSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const iftttSmsReceivedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(NotificationEvents.IFTTT_SMS_RECEIVED),
  detail: z.object({
    filter: z.record(z.any()).nullish(),
    data: iftttSmsReceivedEventDataSchema,
    metadata: shopAndSmileEventMetadataSchema,
  }),
});

export const emailParamsSchema = z.object({
  bccEmailAddresses: z.array(z.string()).nullish(),
  ccEmailAddresses: z.array(z.string()).nullish(),
  toEmailAddresses: z.array(z.string()),
  bodyData: z.string(),
  bodyCharset: emailCharsetSchema,
  subjectdata: z.string(),
  subjectCharset: emailCharsetSchema,
  sourceEmail: z.string(),
  replyToAddresses: z.array(z.string()).nullish(),
});

export const whatsappWebhookEntrySchema = z.object({
  id: z.string(),
  changes: z.array(whatsappWebhookChangeSchema),
});

export const notificationSchema = z.object({
  message_id: z.string(),
  type: notificationRequestTypeSchema,
  trigger: notificationTriggerSchema,
  event_id: z.string().nullish(),
  period_key: z.string().nullish(),
  language: languageSchema,
  merchant_id: z.string(),
  store_id: z.string(),
  payload: z.record(z.unknown()),
  media: notificationMediaSchema.nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const notificationDBItemSchema = notificationSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const notificationSettingsResponseSchema = z.object({
  store_id: z.string(),
  timezone: z.string(),
  billing: notificationBillingStatusSchema,
  types: z.array(notificationTypeSettingsSchema),
});

export const notificationWithRecipientsSchema = notificationSchema.extend({
  recipients: z.array(notificationRecipientSchema),
});

export const notificationsHistoryPageSchema = z.object({
  notifications: z.array(notificationWithRecipientsSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const receiptPaymentDetailsSchema = z.object({
  receipt_id: z.string(),
  payment: receiptPaymentSchema,
  customer_id: z.string(),
});

export const paymentDetailsSchema = z.union([
  loanPaymentDetailsSchema,
  debtPaymentDetailsSchema,
  receiptPaymentDetailsSchema,
  refundReceiptPaymentDetailsSchema,
]);

export const paymentSchema = timestampsSchema
  .extend(commonPaymentAttributesSchema.shape)
  .extend({
    id: z.string(),
    payment_details: paymentDetailsSchema,
    owner_id: z.string(),
    owner_type: entityTypesSchema,
    allocations: z.array(allocationSchema),
    shift_id: z.string().nullish(),
  });

export const paymentsPageSchema = paginatedSchema.extend({
  payments: z.array(paymentSchema),
});

export const createReceiptPaymentDtoSchema =
  commonPaymentAttributesSchema.extend(receiptPaymentDetailsSchema.shape);

export const paymentDBItemSchema = paymentSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  GSI7PK: z.string(),
  GSI7SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const getPaymentByPayerDtoSchema = paginationParamsSchema.extend({
  payer_id: z.string(),
  payer_type: entityTypesSchema,
});

export const getPaymentsByEntityAndDateRangeDtoSchema = paginationParamsSchema
  .extend(dateRangeSchema.shape)
  .extend({
    entity_id: z.string(),
    entity_type: entityTypesSchema,
  });

export const platformFinanceTransactionSchema = z.object({
  transaction_id: z.string(),
  receiver_number: z.string(),
  direction: z.union([
    z.literal(WalletTransferDirection.IN),
    z.literal(WalletTransferDirection.OUT),
  ]),
  operator: messageOperatorSchema.nullish(),
  amount: z.number(),
  fee: z.number(),
  balance_after: z.number().nullish(),
  balance_before: z.number().nullish(),
  counterparty_number: z.string().nullish(),
  counterparty_name: z.string().nullish(),
  content: z.string().nullish(),
  message_content: z.string(),
  occurred_at: z.string(),
  subtype: txSubtypeSchema.nullish(),
  reversed_by: z.string().nullish(),
  claim_status: claimStatusSchema.nullish(),
  claimed_merchant_id: z.string().nullish(),
  claimed_store_id: z.string().nullish(),
  claimed_at: z.string().nullish(),
  assignment_status: platformFinanceAssignmentStatusSchema,
  category: platformFinanceCategorySchema.nullish(),
  assigned_to: z.string().nullish(),
  allocation: platformFinanceAllocationSchema.nullish(),
  suggestion: platformFinanceSuggestionSchema.nullish(),
  reconciliation_status: platformFinanceReconciliationStatusSchema.nullish(),
});

export const platformFinanceAccountSchema = z.object({
  phone_number: z.string(),
  label: z.string(),
  operator: messageOperatorSchema.nullish(),
  device_label: z.string().nullish(),
  status: topupNumberStatusSchema,
  platform_payment_type_id: z.string(),
  balance: z.number().nullish(),
  balance_as_of: z.string().nullish(),
});

export const platformFinanceDashboardSchema = z.object({
  currency: z.string(),
  current_balance: z.number(),
  balance_as_of: z.string().nullish(),
  month: z.string(),
  money_in: z.number(),
  subscription_income: z.number(),
  other_income: z.number(),
  money_out: z.number(),
  expenses: z.number(),
  material_purchases: z.number(),
  net: z.number(),
  subscription_expected: z.number(),
  subscription_received: z.number(),
  subscription_outstanding: z.number(),
  collection_pct: z.number(),
  overdue_count: z.number(),
  due_this_week: z.number(),
  installation_count: z.number(),
  non_active_count: z.number(),
  unassigned_count: z.number(),
  unassigned_amount: z.number(),
  attention_count: z.number(),
  platform_credits: z.number(),
  platform_debits: z.number(),
  recent: z.array(platformFinanceTransactionSchema),
});

export const platformFinanceBootstrapSchema = z.object({
  accounts: z.array(platformFinanceAccountSchema),
  receiver_number: z.string().nullish(),
  dashboard: platformFinanceDashboardSchema,
  transactions: z.array(platformFinanceTransactionSchema),
  clients: z.array(platformFinanceClientSchema),
  employees: z.array(platformFinanceEmployeeSchema),
  reports: z.array(platformFinanceReportBucketSchema),
  system: platformFinanceSystemSchema,
  generated_at: z.string(),
});

export const platformFinanceReconciliationGapSchema = z.object({
  previous_transaction_id: z.string(),
  current_transaction_id: z.string(),
  previous_balance_after: z.number(),
  current_balance_before: z.number(),
  difference: z.number(),
  missing_direction: z
    .union([
      z.literal(WalletTransferDirection.IN),
      z.literal(WalletTransferDirection.OUT),
    ])
    .nullish(),
  missing_amount: z.number(),
  explanation: z.string(),
  previous: platformFinanceTransactionSchema.nullish(),
  current: platformFinanceTransactionSchema.nullish(),
});

export const platformFinanceReconciliationSchema = z.object({
  receiver_number: z.string(),
  checked: z.number(),
  gaps: z.array(platformFinanceReconciliationGapSchema),
});

export const platformFinanceAccountMergeResultSchema = z.object({
  dry_run: z.boolean(),
  topups: topupNumberMergeResultSchema,
  classifications: z.number(),
  classification_conflicts: z.number(),
  held_sms: z.number(),
  replayed: z.number(),
});

export const topupDeviceSchema = versionedSchema.extend({
  device_key: z.string(),
  device_label: z.string(),
  status: topupDeviceStatusSchema,
  phone_number: z.string().nullish(),
  assigned_at: z.string().nullish(),
  assigned_by_name: z.string().nullish(),
  first_seen_at: z.string(),
  last_seen_at: z.string(),
  held_message_ids: z.array(z.string()).nullish(),
  suggested_phone_number: z.string().nullish(),
  alerted_at: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const posDeviceSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    store_id: z.string(),
    activated: z.boolean(),
    merchant_id: z.string(),
    prefix: z.string(),
    mac_address: z.string().nullish(),
    current_user_id: z.string().nullish(),
    current_user_claimed_at: z.string().nullish(),
    current_user_fingerprint: z.string().nullish(),
    current_user_device_label: z.string().nullish(),
    current_user_last_seen_at: z.string().nullish(),
    current_user_latitude: z
      .union([z.number(), z.undefined()])
      .nullish()
      .nullable(),
    current_user_longitude: z
      .union([z.number(), z.undefined()])
      .nullish()
      .nullable(),
    current_user_accuracy_meters: z
      .union([z.number(), z.undefined()])
      .nullish()
      .nullable(),
    current_user_location_source: locationSourceSchema.nullish(),
    feature_flags: posDeviceFeatureFlagsSchema.nullish(),
    geofence: posDeviceGeofenceSchema.nullish(),
    app_version: z.string().nullish(),
    app_platform: posAppPlatformSchema.nullish(),
    last_heartbeat_at: z.string().nullish(),
    last_session_event_at: z.string().nullish(),
  });

export const claimPosDeviceResponseSchema = posDeviceSchema.extend({
  session_secret: z.string().nullish(),
});

export const posDeviceDBItemSchema = posDeviceSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string().nullish(),
  GSI2SK: z.string().nullish(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const posDevicePageSchema = z.object({
  pos_devices: z.array(posDeviceSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const evictUserFromAllDevicesResponseSchema = z.object({
  evicted_count: z.number(),
  evicted: z.array(posDeviceSchema),
});

export const productExpiryDBItemSchema = productExpirySchema.extend(
  dynamoDBItemSchema.shape,
);

export const productNameOrUnitUpdatedEventDetailMetadataSchema =
  shopAndSmileEventMetadataSchema;

export const quantityInUnitPackageUpdatedEventDetailMetadataSchema =
  shopAndSmileEventMetadataSchema;

export const storeSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    address: z.string().nullable(),
    city: z.string(),
    region: z.string().nullable(),
    postal_code: z.string().nullable(),
    country_code: z.string(),
    phone_number: z.string().nullable(),
    description: z.string().nullable(),
    merchant_id: z.string(),
    contact_person: z.string(),
    email: z.string().nullable(),
    contact_person_phone_number: z.string(),
    tax_number: z.string().nullable(),
    store_prefix: z.string(),
    note: z.string().nullish(),
    daily_count_target: z.number().nullish(),
    daily_count_enabled: z.boolean().nullish(),
    daily_count_recency_days: z.number().nullish(),
    daily_count_carry_over_enabled: z.boolean().nullish(),
    hide_stock_when_counting: z.boolean().nullish(),
    blind_shift_closing: z.boolean().nullish(),
    credit_limit: z.number().nullish(),
    prevent_overdue_blocking: z.boolean().nullish(),
    whatsapp_number: z.string().nullish(),
    allow_limited_settings: z.boolean().nullish(),
    hide_discounts_on_receipt: z.boolean().nullish(),
    po_profit_estimation_enabled: z.boolean().nullish(),
    location_type: locationTypeSchema.nullish(),
    labels: z.record(z.string()).nullish(),
  });

export const storeProductCostUpdatedEventDetailMetadataSchema =
  shopAndSmileEventMetadataSchema;

export const updateStoreProductSchema = z.object({
  id: z.string(),
  store_id: z.string(),
  merchant_id: z.string(),
  updator_id: z.string(),
  inventory: z.number().nullish(),
  is_available_for_sale: z.boolean().nullish(),
  is_sold_by_range: z.boolean().nullish(),
  max_selling_price: z.number().nullish(),
  min_selling_price: z.number().nullish(),
  is_manually_controlled: z.boolean().nullish(),
  is_sold_by_weight: z.boolean().nullish(),
  is_sold_online: z.boolean().nullish(),
  add_loyalty_programs: z.array(z.string()).nullish(),
  remove_loyalty_programs: z.array(z.string()).nullish(),
  price: z.number().nullish(),
  cost: z.number().nullish(),
  low_stock_threshold: z.number().nullish(),
  is_available_in_store: z.boolean().nullish(),
  should_display_cost_on_pos: z.boolean().nullish(),
  expiry_warning_days: z.number().nullish(),
  reorder_level: z.number().nullish(),
  skip_inventory_value_delta: z.boolean().nullish(),
  last_counted_at: z.string().nullish(),
  risk_score_increment: z.number().nullish(),
  allow_below_cost_sale: z.boolean().nullish(),
  change_reason: z.string().nullish(),
  occurred_at: z.string().datetime().nullish(),
  expected_price: z.number().finite().nonnegative().nullish(),
  discount_change: productDiscountChangeSchema.nullish(),
  cost_update_origin: costUpdateOriginSchema.nullish(),
  weighted_receive: weightedReceiveSchema.nullish(),
  inventory_valuation: inventoryValuationSchema.nullish(),
});

export const changeEventSchema = z.object({
  changes: changedAttributesSchema,
  event: z.union([productChangeEventsSchema, storeProductChangeEventsSchema]),
});

export const storeProductChangesPageSchema = z.object({
  changes: z.array(storeProductChangeSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const promotionSchema = timestampsSchema.extend({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  promotion_type: promotionTypesSchema,
  promotion_value: z.number(),
  promotion_code: z.string(),
  promotion_status: promotionStatusSchema,
  store_id: z.string(),
  merchant_id: z.string(),
  product_id: z.string(),
  image_url: z.string(),
  is_manual: z.boolean(),
});

export const promotionPageSchema = z.object({
  promotions: z.array(promotionSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const promotionDBItemSchema = promotionSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const purchaseOrderPaymentMerchantSummarySchema =
  purchaseOrderPaymentSummarySchema.extend({
    merchant_id: z.string(),
  });

export const purchaseOrderPaymentStoreSummarySchema =
  purchaseOrderPaymentSummarySchema.extend({
    store_id: z.string(),
  });

export const purchaseOrderPaymentSupplierSummarySchema =
  purchaseOrderPaymentSummarySchema.extend({
    supplier_id: z.string(),
  });

export const purchaseOrderPaymentPurchaseOrderSummarySchema =
  purchaseOrderPaymentSummarySchema.extend({
    purchase_order_id: z.string(),
  });

export const purchaseOrderItemSchema = timestampsSchema.extend({
  id: z.string(),
  quantity: z.number(),
  cost: z.number(),
  received: z.number(),
  cancelled: z.number(),
  name: z.string(),
  in_stock: z.number(),
  received_at: z.string().nullish(),
  fractions: z.array(purchaseOrderItemFractionSchema).nullish(),
  estimate: purchaseOrderItemEstimateSchema.nullish(),
  expiry_date: z.string().nullish(),
});

export const supplierValuationSchema = z.object({
  supplier_due_start: z.number(),
  supplier_due_end: z.number(),
  period_metrics: supplierValuationPeriodMetricsSchema,
  period_metrics_delta: supplierValuationPeriodMetricsSchema,
  per_supplier: z.array(supplierValuationPerSupplierSchema).nullish(),
});

export const receiptCreatedEventDetailMetadataSchema =
  shopAndSmileEventMetadataSchema;

export const confirmedQuantityUpdateSchema = z.object({
  quantity: z.number(),
  updator: employeeSummarySchema,
  item_id: z.string(),
});

export const receiptHistoryItemSchema = z.union([
  saleReceiptHistoryItemSchema,
  debtPaymentHistoryItemSchema,
  refundReceiptHistoryItemSchema,
  receiptHistoryUpdateCustomerItemSchema,
  receiptHistoryCommentItemSchema,
]);

export const taxSchema = timestampsSchema.extend(versionedSchema.shape).extend({
  id: z.string(),
  type: taxTypeSchema,
  name: z.string(),
  rate: z.number(),
  merchant_id: z.string(),
});

export const createReceiptHistoryItemSchema = z.object({
  receiptHistory: receiptHistoryItemSchema,
  id: z.string(),
  receipt_number: z.string(),
  created_at: z.string(),
  merchant_id: z.string(),
});

export const receiptHistoryDbItemSchema = receiptHistoryItemSchema.and(
  z.object({
    PK: z.string(),
    SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
  }),
);

export const updateLineItemSchema = z.object({
  receipt_number: z.string(),
  confirmed_quantity: z.array(confirmedQuantityUpdateSchema).nullish(),
  missing: z.array(missingItemSchema).nullish(),
  command: updateReceiptCommandSchema,
  merchant_id: z.string(),
});

export const aggregateStoreSalesReportSchema = storeSalesReportSchema.extend(
  salesReportExtensionsSchema.shape,
);

export const aggregateEmployeeSalesReportSchema =
  employeeSalesReportSchema.extend(salesReportExtensionsSchema.shape);

export const aggregateProductSalesReportSchema =
  productSalesReportSchema.extend(salesReportExtensionsSchema.shape);

export const aggregateSalesReportSchema = z.object({
  store: aggregateStoreSalesReportSchema,
  employees: z.array(aggregateEmployeeSalesReportSchema),
  products: z.array(aggregateProductSalesReportSchema),
});

export const employeePageSchema = z.object({
  employees: z.array(employeeSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const closeShiftAttemptSchema = attemptToCloseShiftSchema.extend(
  timestampsSchema.shape,
);

export const closeShiftWithReconciliationSchema = z.object({
  reconciliations: z.array(paymentBalanceSchema),
  note: z.union([z.string(), z.undefined()]).nullish(),
  verified_by: z.string(),
  verified_by_name: z.string(),
  verified_user_type: entityTypesSchema,
  force_close: z.boolean(),
});

export const closingAuditTrailEntrySchema = timestampsSchema.extend({
  id: z.string(),
  event: closeShiftStepEventSchema,
  recorded_at: z.string(),
  actor: closingAuditTrailActorSchema,
  entered_balances: z.array(paymentBalanceSchema),
  expected_balances: z.array(closingAuditTrailExpectedBalanceSchema),
  differences: z.array(closingAuditTrailDifferenceSchema),
  session_transaction_ids: z
    .union([z.array(z.string()), z.undefined()])
    .nullish()
    .nullable(),
  client_step_index: z.number(),
  note: z.union([z.string(), z.undefined()]).nullish(),
});

export const stockTransferLineSchema = z.object({
  line_id: z.string(),
  product_id: z.string(),
  product_name: z.string(),
  authorized: z.number(),
  prepared: z.number().nullish(),
  dispatched: z.number().nullish(),
  unit_cost: z.number().nullish(),
  shortfall_reason: z.string().nullish(),
  accepted: z.number().nullish(),
  extra_received: z.number().nullish(),
  returned_good: z.number().nullish(),
  returned_blocked: z.number().nullish(),
  written_off: z.number().nullish(),
  redirected: z.number().nullish(),
  unresolved: transferUnresolvedSchema.nullish(),
  unresolved_custody: transferUnresolvedCustodySchema.nullish(),
  pending_approval: z.number().nullish(),
  extra_resolution: transferExtraResolutionSchema.nullish(),
  price_approval: transferLinePriceApprovalSchema.nullish(),
});

export const stockTransferSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    reference: z.string(),
    merchant_id: z.string(),
    stock_order_id: z.string(),
    source_store_id: z.string(),
    destination_store_id: z.string(),
    store_id: z.string(),
    logistics_status: transferLogisticsStatusSchema,
    reconciliation_status: transferReconciliationStatusSchema,
    valuation_status: transferValuationStatusSchema,
    lines: z.array(stockTransferLineSchema),
    preparation: transferPreparationRecordSchema.nullish(),
    dispatch: transferDispatchRecordSchema.nullish(),
    receipt: transferReceiptRecordSchema.nullish(),
    stock_operation_intents: z.array(stockOperationIntentSchema),
    follow_up_since: z.string().nullish(),
    demand_return_pending: z.boolean().nullish(),
    tasks_pending: z.boolean().nullish(),
    actionable_since: z.string().nullish(),
    cancelled_at: z.string().nullish(),
    cancel_reason: z.string().nullish(),
    parent_transfer_id: z.string().nullish(),
    child_transfer_ids: z.array(z.string()).nullish(),
    return_requested_at: z.string().nullish(),
    returned_at: z.string().nullish(),
    reconciled_at: z.string().nullish(),
    settlements: z.array(transferSettlementRecordSchema).nullish(),
    price_approval: transferPriceApprovalRecordSchema.nullish(),
    price_update_pending: z.boolean().nullish(),
    created_by_id: z.string(),
    created_by_name: z.string(),
  });

export const redirectResultSchema = z.object({
  transfer: stockTransferSchema,
  child: stockTransferSchema,
});

export const stockOrderViewSchema = z.object({
  order: stockOrderSchema,
  transfers: z.array(stockTransferSchema),
});

export const stockTransferPageSchema = z.object({
  items: z.array(stockTransferSchema),
  cursor: z.string().nullish(),
});

export const storeCreatedEventDetailDataSchema = z.object({
  owner: employeeSchema.nullish(),
  store: storeSchema,
});

export const storeCreatedEventDetailMetadataSchema =
  shopAndSmileEventMetadataSchema;

export const storeFavouriteUpsertedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(StoreEvents.STORE_FAVOURITE_UPSERTED),
  detail: z.object({
    filter: z.record(z.any()).nullish(),
    data: z.object({
      favourite: storeFavouriteCellSchema,
    }),
    metadata: shopAndSmileEventMetadataSchema,
  }),
});

export const storeFavouriteDeletedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(StoreEvents.STORE_FAVOURITE_DELETED),
  detail: z.object({
    filter: z.record(z.any()).nullish(),
    data: z.object({
      merchant_id: z.string(),
      store_id: z.string(),
      page: z.number(),
      position: z.number(),
    }),
    metadata: shopAndSmileEventMetadataSchema,
  }),
});

export const storePageSchema = z.object({
  stores: z.array(storeSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const storeDBItemSchema = storeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const taskEventSchema = z.object({
  op: taskEventOpSchema,
  type: taskTypeSchema,
  source_key: z.string().trim().min(1).max(200),
  merchant_id: z.string().trim().min(1),
  store_id: z.string().trim().min(1),
  params: taskParamsSchema.nullish(),
  assignee_id: z.string().nullable(),
  occurred_at: z.string().datetime({ offset: true }),
  waiting_since: z.string().datetime({ offset: true }).nullish(),
  actor: taskActorSchema.nullish(),
  only_if_open: z.boolean().nullish(),
});

export const taxPageSchema = z.object({
  taxes: z.array(taxSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const taxDBItemSchema = taxSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const topupRequestSchema = z.object({
  receiver_number: z.string(),
  sender_contact: z.string(),
  operator: messageOperatorSchema,
  message_content: z.string(),
  transaction_id: z.string(),
  amount: z.number(),
  transaction_type: topupTransactionTypeSchema,
  claim_status: claimStatusSchema,
  claim_history: z.array(claimHistorySchema),
  created_at: z.string(),
  updated_at: z.string().nullish(),
  version: z.number().nullish(),
  updated_by_id: z.string().nullish(),
  updated_by_name: z.string().nullish(),
  assignment_source: assignmentSourceSchema.nullish(),
  claimed_at: z.string().nullish(),
  merchant_id: z.string().nullish(),
  store_id: z.string().nullish(),
  claimed_by: z.string().nullish(),
  client_claim_text: z.string().nullish(),
  entity_type: entityTypesSchema.nullish(),
  wallet_balance: z.number().nullish(),
  reversed_by: z.string().nullish(),
  reversed_at: z.string().nullish(),
  wallet_credit_reference_type: z.string().nullish(),
  wallet_credit_reference_id: z.string().nullish(),
  wallet_credit_transaction_version: z.number().nullish(),
  wallet_credit_created_at: z.string().nullish(),
  wallet_credit_balance_after: z.number().nullish(),
  wallet_credit_error: z.string().nullish(),
  claim_match_method: topupClaimMatchMethodSchema.nullish(),
  claim_match_score: z.number().nullish(),
  claim_review_reason: z.string().nullish(),
  manual_review_requested_at: z.string().nullish(),
  wallet_credit_payment_type_id: z.string().nullish(),
  wallet_credit_payment_type_name: z.string().nullish(),
  wallet_credit_payment_type: paymentMethodTypeSchema.nullish(),
  claim_merchant_id: z.string().nullish(),
  rejected_at: z.string().nullish(),
  rejected_by: z.string().nullish(),
  rejection_reason: z.string().nullish(),
  revoked_at: z.string().nullish(),
  revoked_by: z.string().nullish(),
  revocation_reason: z.string().nullish(),
  fee: z.number().nullish(),
  balance_after: z.number().nullish(),
  counterparty_number: z.string().nullish(),
  counterparty_name: z.string().nullish(),
  content: z.string().nullish(),
  occurred_at: z.string().nullish(),
  source: topupSourceSchema.nullish(),
  device_label: z.string().nullish(),
});

export const topupRequestDBItemSchema = topupRequestSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string().nullish(),
  GSI1SK: z.string().nullish(),
  GSI2PK: z.string().nullish(),
  GSI2SK: z.string().nullish(),
  GSI3PK: z.string().nullish(),
  GSI3SK: z.string().nullish(),
});

export const topupRequestsPageSchema = z.object({
  count: z.number().nullish(),
  cursor: z.string().nullish(),
  topup_requests: z.array(topupRequestSchema),
});

export const topupPasswordSchema = versionedSchema.extend({
  current_password: z.string(),
  updated_at: z.string(),
  update_history: z.array(topupPasswordUpdateHistorySchema),
  phone_number: z.string(),
});

export const topupPasswordDBItemSchema = topupPasswordSchema.extend({
  SK: z.string(),
  PK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const walletHandleSmsResponseSchema = z.object({
  direction: walletTransferDirectionSchema,
  topup_request: topupRequestSchema.nullable(),
  transfer_out: walletTransferOutSchema.nullable(),
  noise: z.boolean().nullish(),
  unparsed: z.boolean().nullish(),
});

export const topupNumberSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    phone_number: z.string(),
    location: z.string(),
    platform_payment_type_id: z.string(),
    update_history: topupNumberUpdateHistorySchema,
    operator: messageOperatorSchema.nullish(),
    device_label: z.string().nullish(),
    status: topupNumberStatusSchema.nullish(),
    merged_into: z.string().nullish(),
  });

export const topupNumberDBItemSchema = topupNumberSchema.extend({
  SK: z.string(),
  PK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string().nullish(),
  GSI1SK: z.string().nullish(),
});

export const topupNumbersPageSchema = z.object({
  numbers: z.array(topupNumberSchema),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const topupDeviceDBItemSchema = topupDeviceSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const topupDevicesPageSchema = z.object({
  devices: z.array(topupDeviceSchema),
});

export const topupClaimMatchSchema = z.object({
  topup_request: topupRequestSchema,
  reasons: z.array(z.string()),
});

export const topupClaimMatchesPageSchema = z.object({
  matches: z.array(topupClaimMatchSchema),
  count: z.number().nullish(),
  cursor: z.string().nullish(),
});

export const firstMerchantUserCreatedEventDetailDataSchema = z.object({
  user: employeeSchema,
});

export const firstMerchantUserCreatedEventDetailMetadataSchema =
  shopAndSmileEventMetadataSchema;

export const userItemSchema = employeeSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string().nullish(),
  GSI3SK: z.string().nullish(),
  GSI4PK: z.string().nullish(),
  GSI4SK: z.string().nullish(),
  PIN: z.string(),
  pin_hash: z.string().nullish(),
  pin_salt: z.string().nullish(),
  pin_updated_at: z.string().nullish(),
});

export const updateUserSchema = employeeSchema
  .partial()
  .and(updateMerchantUserRequestBodySchema.partial())
  .and(
    z.object({
      id: z.string(),
      auth_type: authTypeSchema,
      is_active: z.boolean().nullish(),
      PIN: z.string().nullish(),
      stores: z.array(z.string()).nullish(),
    }),
  );

export const walletSnapshotsByPaymentMethodSchema = z.object({
  merchant_id: z.string(),
  created_at: z.string(),
  account_snapshots: z.array(walletSnapshotSchema),
});

export const storeSnapshotsResultSchema = z.object({
  at_time: z.string(),
  snapshots: z.array(accountSnapshotsByPaymentMethodSchema),
});

export const authenticateUserResponseSchema = z.object({
  encryptedCredentials: z.string(),
  userData: merchantUserAttributesSchema,
  employee: employeeSchema,
  credentials: encryptCredentialsDtoSchema,
});

export const debtorSummarySchema = z.object({
  debtor_id: z.string(),
  debtor_type: entityTypesSchema,
  debtor_name: z.string(),
  total_money_debt: z.number(),
  total_money_payments: z.number(),
  total_money_outstanding: z.number(),
  total_money_overdue: z.number(),
  total_money_defaulted: z.number(),
  total_money_closed: z.number(),
  total_money_interest: z.number(),
  total_money_principal: z.number(),
  total_money_transferred_out: z.number(),
  total_money_transferred_in: z.number(),
  next_due_date: z.string(),
  stores: z.array(z.string()),
  overdue_count: z.number(),
  debt_count: z.number(),
  closed_count: z.number(),
  debts: z.array(debtAggregateSchema),
  closed_debt_cursor: z.string().nullish(),
  has_more_closed_debts: z.boolean().nullish(),
});

export const updateCustomerSchema = z.object({
  id: z.string(),
  name: z.string().nullish(),
  email: z.string().nullish(),
  phone_number: z.string().nullish(),
  address: z.string().nullish(),
  city: z.string().nullish(),
  region: z.string().nullish(),
  postal_code: z.string().nullish(),
  country_code: z.string().nullish(),
  customer_code: z.string().nullish(),
  note: z.string().nullish(),
  first_visit: z.string().nullish(),
  last_visit: z.string().nullish(),
  pin: z.string().nullish(),
  debtor_summary: debtorSummarySchema.nullish(),
  is_number_verified: z.boolean().nullish(),
});

export const debtorGroupSchema = z.object({
  debtor_id: z.string(),
  debtor_type: entityTypesSchema,
  debtor_name: z.string(),
  debts: z.array(debtSchema),
  total_outstanding_amount: z.number(),
  total_paid_amount: z.number(),
  total_amount: z.number(),
});

export const globalProductSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    images: z.array(z.string()),
    quantity_in_unit_package: z.number(),
    suggested_cost: z.number().finite().nonnegative().optional(),
    weight_kg: z.number(),
    unit: z.union([z.string(), z.number()]),
    unit_of_measurement: z.string(),
    country: z.string().nullish(),
    countries: z.array(z.string()).nullish(),
    fraction: z.number(),
    parent_id: z.string(),
    is_parent: z.boolean(),
    product_fractions: z.array(globalProductFractionSchema),
    barcodes: z.array(barcodeSchema),
    tags: z.array(z.string()),
    import_ids: z.array(z.string()).nullish(),
    approval_status: approvalStatusSchema,
    issues: z.array(productIssueSchema),
  });

export const globalProductPageSchema = z.object({
  products: z.array(globalProductSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const globalProductDBItemSchema = globalProductSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const loanSchema = timestampsSchema
  .extend(commonEmployeeAsCreatorAttributesSchema.shape)
  .extend({
    id: z.string(),
    paid_amount: z.number(),
    total_amount: z.number(),
    unpaid_amount: z.number(),
    borrower_id: z.string(),
    borrower_type: entityTypesSchema,
    borrower_loan_id: z.string(),
    due_date: z.string(),
    overdue_amount: z.number(),
    status: loanStatusSchema,
    reason: z.string(),
    associated_payments: z.array(z.string()),
    loan_history: z.array(loanHistoryItemSchema),
    store_id: z.string(),
    shift_id: z.string().nullish(),
  });

export const borrowerLoanSchema = timestampsSchema
  .extend(commonEmployeeAsCreatorAttributesSchema.shape)
  .extend({
    id: z.string(),
    borrower_id: z.string(),
    borrower_type: entityTypesSchema,
    total_amount: z.number(),
    total_paid_amount: z.number(),
    total_value_of_completed_loans: z.number(),
    total_number_of_loans: z.number(),
    total_number_of_completed_loans: z.number(),
    total_unpaid_amount: z.number(),
    total_overdue_amount: z.number(),
    oldest_due_date: z.string(),
    status: loanStatusSchema,
    incomplete_loans: z.array(loanSchema),
    reason: z.string(),
  });

export const borrowerLoanPageSchema = z.object({
  borrower_loans: z.array(borrowerLoanSchema),
  cursor: z.string().nullable(),
  count: z.number(),
});

export const loanDBItemSchema = loanSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const loanPageSchema = z.object({
  loans: z.array(loanSchema),
  cursor: z.string().nullable(),
  count: z.number(),
});

export const borrowerLoanSummarySchema = z.object({
  borrower_loan: borrowerLoanSchema,
  incomplete_loans_cursor: z.string().nullable(),
  incomplete_loans_count: z.number(),
});

export const merchantSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    business_name: z.string(),
    email: z.string(),
    country: z.string(),
    currency: currencySchema,
    phone_number: z.string(),
    address: z.string(),
    contact_person: z.string(),
    stores: z.array(z.string()),
    monthly_fee: z.number(),
    default_language: uiLanguageSchema.nullish(),
    modules: merchantModulesSchema.nullish(),
  });

export const merchantPageSchema = z.object({
  merchants: z.array(merchantSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const merchantDBItemSchema = merchantSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const whatsappWebhookPayloadSchema = z.object({
  object: z.string(),
  entry: z.array(whatsappWebhookEntrySchema),
});

export const platformFinanceDeviceAssignResultSchema = z.object({
  device: topupDeviceSchema,
  replayed: z.number(),
});

export const productSchema = timestampsSchema.extend({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  image: z.string(),
  barcode: z.union([z.string(), z.number()]),
  quantity_in_unit_package: z.number(),
  global_sku: z.number(),
  weight_kg: z.number(),
  unit: z.union([z.string(), z.number()]),
  unit_of_measurement: z.string(),
  category_id: z.string().nullish(),
  merchant_id: z.string(),
  fraction: z.number(),
  parent_id: z.string(),
  is_parent: z.boolean(),
  product_fractions: z.array(productFractionSchema),
  taxes: z.union([z.array(z.string()), z.array(taxSchema)]),
  barcodes: z.array(barcodeSchema).nullish(),
  countries: z.array(z.string()).nullish(),
  version: z.number(),
  updated_by_id: z.string().nullish(),
  updated_by_name: z.string().nullish(),
  deleted_by_id: z.string().nullish(),
  deleted_by_name: z.string().nullish(),
});

export const quantityInUnitPackageUpdatedEventDetailDataSchema = z.object({
  parentProduct: productSchema,
  childProducts: z.array(productSchema),
  store: storeSchema,
});

const storeProductCostUpdatedEventDetailSchema = z.object({
  filter: z.record(z.any()).nullish(),
  data: storeProductCostUpdatedEventDetailDataSchema,
  metadata: storeProductCostUpdatedEventDetailMetadataSchema,
});

export const productPageSchema = z.object({
  products: z.array(productSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const productDBItemSchema = productSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const purchaseOrderPaymentSummariesSchema = z.object({
  merchants: z.array(purchaseOrderPaymentMerchantSummarySchema),
  stores: z.array(purchaseOrderPaymentStoreSummarySchema),
  suppliers: z.array(purchaseOrderPaymentSupplierSummarySchema),
  purchase_orders: z.array(purchaseOrderPaymentPurchaseOrderSummarySchema),
});

export const purchaseOrderPaymentPageSchema = z.object({
  purchase_order_payments: z.array(purchaseOrderPaymentSchema),
  cursor: z.union([z.string(), z.undefined()]).nullable(),
  count: z.number(),
  summary: z
    .union([purchaseOrderPaymentSummariesSchema, z.undefined()])
    .nullable(),
});

export const purchaseOrderSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    purchase_date: z.string(),
    ordered_by: z.string(),
    note: z.string(),
    supplier_id: z.string(),
    purchase_status: purchaseStatusSchema,
    total_cost: z.number(),
    items: z.array(purchaseOrderItemSchema),
    total_received: z.number(),
    payment_status: purchaseOrderPaymentStatusSchema,
    is_draft: z.boolean(),
    store_id: z.string(),
    merchant_id: z.string(),
    total_ordered: z.number(),
    supplier_name: z.string(),
    total_cancelled: z.number(),
    shift_id: z.string().nullish(),
    po_total_paid: z.number().nullish(),
    po_total_refunded: z.number().nullish(),
    po_amount_due: z.number().nullish(),
    cancelled_at: z.string().nullish(),
    estimate_min_profit: z.number().nullish(),
    estimate_max_profit: z.number().nullish(),
    estimate_pending_count: z.number().nullish(),
  });

export const purchaseOrderPageSchema = z.object({
  purchase_orders: z.array(purchaseOrderSchema),
  cursor: z.union([z.string(), z.undefined()]).nullable(),
  count: z.number(),
});

export const receiptHistorySchema = z.object({
  receipt_number: z.string(),
  history_item: z.array(receiptHistoryItemSchema),
});

export const receiptTaxSchema = taxSchema.extend({
  money_amount: z.number(),
  pre_tax_money: z.number(),
});

export const storeSalesReportDBItemSnapshotSchema =
  aggregateStoreSalesReportSchema.extend({
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
    includes_own_event: z.boolean().nullish(),
  });

export const employeeSalesReportDBItemSnapshotSchema =
  aggregateEmployeeSalesReportSchema.extend({
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
    includes_own_event: z.boolean().nullish(),
  });

export const productSalesReportDBItemSnapshotSchema =
  aggregateProductSalesReportSchema.extend({
    PK: z.string(),
    SK: z.string(),
    GSI1PK: z.string(),
    GSI1SK: z.string(),
    EntityIndexPK: z.string(),
    EntityIndexSK: z.string(),
    includes_own_event: z.boolean().nullish(),
  });

export const shiftSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    pos_id: z.union([z.string(), z.undefined()]).nullish(),
    status: shiftStatusSchema,
    opened_at: z.string(),
    opened_by: z.string(),
    opened_by_name: z.string(),
    opened_user_type: entityTypesSchema,
    opening_note: z.union([z.string(), z.undefined()]).nullish(),
    closing_started_at: z
      .union([z.string(), z.undefined()])
      .nullish()
      .nullable(),
    closed_at: z.union([z.string(), z.undefined()]).nullish(),
    closed_by: z.union([z.string(), z.undefined()]).nullish(),
    closed_by_name: z.union([z.string(), z.undefined()]).nullish(),
    closed_user_type: entityTypesSchema.nullish(),
    closing_note: z.union([z.string(), z.undefined()]).nullish(),
    opening_balances: z.array(shiftReportPaymentMethodSchema),
    closing_balances: z
      .array(shiftReportPaymentMethodWithReconciliationSchema)
      .nullish(),
    merchant_id: z.string(),
    store_id: z.string(),
    comments: z.array(shiftCommentSchema),
    closing_attempts: z.array(
      z.union([closeShiftAttemptSchema, closeShiftWithReconciliationSchema]),
    ),
    closing_audit_trail: z.array(closingAuditTrailEntrySchema),
  });

export const shiftPageSchema = z.object({
  shifts: z.array(shiftSchema),
  count: z.number(),
  cursor: z.union([z.string(), z.undefined()]).nullish(),
});

export const shiftDbItemSchema = shiftSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string().nullish(),
  GSI2SK: z.string().nullish(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

const storeCreatedEventDetailSchema = z.object({
  filter: z.record(z.any()).nullish(),
  data: storeCreatedEventDetailDataSchema,
  metadata: storeCreatedEventDetailMetadataSchema,
});

const firstMerchantUserCreatedEventDetailSchema = z.object({
  filter: z.record(z.any()).nullish(),
  data: firstMerchantUserCreatedEventDetailDataSchema,
  metadata: firstMerchantUserCreatedEventDetailMetadataSchema,
});

export const customerSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    id: z.string(),
    name: z.string(),
    email: z.string().nullish(),
    phone_number: z.string().nullish(),
    address: z.string().nullish(),
    city: z.string().nullish(),
    region: z.string().nullish(),
    postal_code: z.string().nullish(),
    country_code: z.string().nullish(),
    customer_code: z.string().nullish(),
    note: z.string().nullish(),
    first_visit: z.string().nullish(),
    last_visit: z.string().nullish(),
    total_visits: z.number(),
    total_spent: z.number(),
    total_points: z.number(),
    permanent_deletion_at: z.string().nullish(),
    pin: z.string().nullish(),
    merchant_id: z.string(),
    date_of_birth: z.string().nullish(),
    debtor_summary: debtorSummarySchema.nullish(),
    is_number_verified: z.boolean().nullish(),
  });

export const customerPageSchema = z.object({
  cursor: z.string().nullish(),
  count: z.number().nullish(),
  customers: z.array(customerSchema),
});

export const customerDBItemSchema = customerSchema.extend({
  PK: z.string(),
  SK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
});

export const whatsappWebhookEventSchema = z.object({
  id: z.string().nullish(),
  phone_number_id: z.string(),
  payload: whatsappWebhookPayloadSchema,
  created_at: z.string(),
  event_type: z.string(),
});

export const whatsappEventsPageSchema = z.object({
  events: z.array(whatsappWebhookEventSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const productNameOrUnitUpdatedEventDetailDataSchema = z.object({
  product: productSchema,
});

export const quantityInUnitPackageUpdatedEventDetailSchema = z.object({
  filter: z.record(z.any()).nullish(),
  data: quantityInUnitPackageUpdatedEventDetailDataSchema,
  metadata: quantityInUnitPackageUpdatedEventDetailMetadataSchema,
});

export const storeProductCostUpdatedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(StoreProductChangeEvents.STORE_PRODUCT_COST_UPDATED),
  detail: storeProductCostUpdatedEventDetailSchema,
});

export const lineItemSchema = z.object({
  id: z.string(),
  item_id: z.string(),
  item_name: z.string(),
  sku: z.string(),
  quantity: z.number(),
  parent_id: z.string().nullish(),
  line_quantity: z.number(),
  fraction: z.number(),
  price: z.number(),
  gross_total_money: z.number(),
  total_money: z.number(),
  cost: z.number(),
  cost_total: z.number(),
  line_note: z.string().nullish(),
  line_taxes: z.array(receiptTaxSchema),
  total_discount: z.number(),
  line_discounts: z.array(receiptDiscountSchema),
  confirmed_quantity: z.number(),
  confirmed_quantity_traceback: z.array(confirmedQuantityTracebackSchema),
  missing: missingItemSchema,
  missing_quantity_traceback: z.array(missingItemTracebackSchema),
  is_confirmed: z.boolean(),
  is_sold_by_weight: z.boolean(),
});

export const storeCreatedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(StoreEvents.STORE_CREATED),
  detail: storeCreatedEventDetailSchema,
});

export const firstMerchantUserCreatedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(UserEvents.FIRST_MERCHANT_USER_CREATED),
  detail: firstMerchantUserCreatedEventDetailSchema,
});

const productNameOrUnitUpdatedEventDetailSchema = z.object({
  filter: z.record(z.any()).nullish(),
  data: productNameOrUnitUpdatedEventDetailDataSchema,
  metadata: productNameOrUnitUpdatedEventDetailMetadataSchema,
});

export const quantityInUnitPackageUpdatedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.literal(
    ProductChangeEvents.PRODUCT_QUANTITY_IN_UNIT_PACKAGE_UPDATED,
  ),
  detail: quantityInUnitPackageUpdatedEventDetailSchema,
});

export const receiptSchema = timestampsSchema
  .extend(versionedSchema.shape)
  .extend({
    receipt_number: z.string(),
    note: z.string().nullish(),
    receipt_type: receiptTypeSchema,
    refund_for: z.string().nullish(),
    order: z.string().nullish(),
    created_at: z.string(),
    updated_at: z.string(),
    source: z.string(),
    cancelled_at: z.any().nullish(),
    total_money: z.number(),
    total_tax: z.number(),
    points_earned: z.number(),
    points_deducted: z.number(),
    points_balance: z.number(),
    customer_id: z.string(),
    total_discount: z.number(),
    employee_id: z.string(),
    store_id: z.string(),
    pos_device_id: z.string(),
    dining_option: z.string().nullish(),
    total_discounts: z.array(receiptDiscountSchema),
    total_taxes: z.array(receiptTaxSchema),
    tip: z.number(),
    surcharge: z.number(),
    line_items: z.array(lineItemSchema),
    payments: z.array(receiptPaymentSchema),
    associated_refunds: z.array(z.string()),
    total_receipt_items: z.number(),
    confirmation_type: confirmationTypeSchema,
    receipt_status: receiptStatusSchema,
    comments: z.array(commentSchema),
    client: clientSchema,
    waiter: employeeSummarySchema.nullish(),
    is_confirmable: z.boolean(),
    confirmed_by: employeeSummarySchema.nullish(),
    customer: customerSchema.nullish(),
    customer_name: z.string(),
    employee_name: z.string(),
    pos_device_name: z.string(),
    customer_updated_traceback: z.array(customerUpdateTracebackSchema),
    has_debt: z.boolean(),
    custom_receipt_number: z.string(),
    failed_checks: z.array(receiptFailedChecksSchema),
    merchant_id: z.string(),
    threshold: thresholdSchema,
    initial_payment_plan: paymentPlanSchema.nullish(),
    shift_id: z.string().nullish(),
    outstanding_debt_before: z
      .union([z.number(), z.undefined()])
      .nullish()
      .nullable(),
  });

export const extendedLineItemSchema = lineItemSchema.extend({
  missing: missingItemSchema,
  is_confirmed: z.boolean(),
});

export const receiptDBItemSchema = receiptSchema.extend({
  PK: z.string(),
  SK: z.string(),
  EntityIndexPK: z.string(),
  EntityIndexSK: z.string(),
  GSI1PK: z.string(),
  GSI1SK: z.string(),
  GSI2PK: z.string(),
  GSI2SK: z.string(),
  GSI3PK: z.string(),
  GSI3SK: z.string(),
  GSI4PK: z.string(),
  GSI4SK: z.string(),
  GSI5PK: z.string(),
  GSI5SK: z.string(),
  GSI6PK: z.string(),
  GSI6SK: z.string(),
  GSI7PK: z.string(),
  GSI7SK: z.string(),
});

export const receiptsPageSchema = z.object({
  receipts: z.array(receiptSchema),
  cursor: z.string().nullish(),
  count: z.number(),
});

export const receiptEventSchema = z.object({
  request_id: z.string(),
  merchant_id: z.string(),
  created_at: z.string(),
  body: receiptSchema,
  type: receiptTypeSchema,
  receipt_number: z.string(),
  success: z.boolean(),
});

export const receiptEventsPageSchema = z.object({
  receipt_events: z.array(receiptEventSchema),
  count: z.number(),
  cursor: z.string().nullish(),
});

export const productNameOrUnitUpdatedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.union([
    z.literal(ProductChangeEvents.PRODUCT_NAME_UPDATED),
    z.literal(ProductChangeEvents.PRODUCT_UNIT_UPDATED),
  ]),
  detail: productNameOrUnitUpdatedEventDetailSchema,
});

export const receiptCreatedEventDetailDataSchema = z.object({
  receipt: receiptSchema,
});

export const receiptCreatedEventDetailSchema = z.object({
  filter: z.record(z.any()).nullish(),
  data: receiptCreatedEventDetailDataSchema,
  metadata: receiptCreatedEventDetailMetadataSchema,
});

export const receiptCreatedEventSchema = z.object({
  bus_name: z.string(),
  source: shopAndSmileEventSourceSchema,
  detail_type: z.union([
    z.literal(ReceiptEvents.SaleReceiptCreated),
    z.literal(ReceiptEvents.RefundReceiptCreated),
  ]),
  detail: receiptCreatedEventDetailSchema,
});

export const storeProductFractionSchema: z.ZodSchema<StoreProductFraction> =
  z.lazy(() =>
    productSchema.and(storeProductAttributesSchema).and(productFractionSchema),
  );

export const storeProductAttributesSchema: z.ZodSchema<StoreProductAttributes> =
  z.lazy(() =>
    timestampsSchema.extend({
      id: z.string(),
      store_sku: z.string(),
      store_id: z.string(),
      unit_of_measurement: z.string(),
      inventory: z.number(),
      stock_breakdown: stockBreakdownSchema.nullish(),
      stock_version: z.number().nullish(),
      cost_changed_at: z.string().nullish(),
      cost_stock_version: z.number().nullish(),
      is_available_for_sale: z.boolean(),
      is_manually_controlled: z.boolean(),
      is_sold_online: z.boolean(),
      is_available_in_store: z.boolean(),
      is_sold_by_range: z.boolean(),
      should_display_cost_on_pos: z.boolean(),
      is_sold_by_weight: z.boolean(),
      loyalty_programs: z.union([
        z.array(z.string()),
        z.array(loyaltyProgramSchema),
      ]),
      price: z.number(),
      cost: z.number(),
      low_stock_threshold: z.number(),
      reorder_level: z.number().nullish(),
      store_prefix: z.string(),
      is_parent: z.boolean(),
      merchant_id: z.string(),
      version: z.number(),
      row_version: z.number().nullish(),
      updated_by_id: z.string().nullish(),
      updated_by_name: z.string().nullish(),
      store_product_fractions: z.array(storeProductFractionSchema),
      max_selling_price: z.number(),
      min_selling_price: z.number(),
      profit_margin: z.number().nullish(),
      max_profit_margin: z.number().nullish(),
      min_profit_margin: z.number().nullish(),
      popularity_score: z.number().nullish(),
      last_counted_at: z.string().nullish(),
      risk_score: z.number().nullish(),
      allow_below_cost_sale: z.boolean().nullish(),
      discount_updated_at: z.string().nullish(),
      expiry_warning_days: z.number().nullish(),
    }),
  );

export const storeProductSchema: z.ZodSchema<StoreProduct> = z.lazy(() =>
  productSchema.and(storeProductAttributesSchema),
);

export const realTimeProductEventMessageSchema: z.ZodSchema<RealTimeProductEventMessage> =
  z.lazy(() =>
    z.object({
      storeId: z.string(),
      product: storeProductSchema,
      deduplication_id: z.string(),
    }),
  );

export const storeProductPageSchema: z.ZodSchema<StoreProductPage> = z.lazy(
  () =>
    z.object({
      products: z.array(storeProductSchema),
      cursor: z.string().nullish(),
      count: z.number(),
    }),
);

export const deletedProductsPageSchema: z.ZodSchema<DeletedProductsPage> =
  z.lazy(() =>
    z.object({
      products: z.array(productSchema),
      store_products: z.array(storeProductSchema),
      cursor: z.string().nullish(),
      count: z.number(),
    }),
  );

export const storeProductDBItemSchema: z.ZodSchema<StoreProductDBItem> = z.lazy(
  () =>
    storeProductAttributesSchema.and(
      z.object({
        PK: z.string(),
        SK: z.string(),
        GSI1PK: z.string(),
        GSI1SK: z.string(),
        GSI2PK: z.string(),
        GSI2SK: z.string(),
        EntityIndexPK: z.string(),
        EntityIndexSK: z.string(),
      }),
    ),
);

export const storeProductWebSocketMessageSchema: z.ZodSchema<StoreProductWebSocketMessage> =
  z.lazy(() =>
    z.object({
      type: entityTypesSchema,
      message: storeProductSchema,
    }),
  );
